// Generated legal-page translations for the supported locale catalog.
export const legalCopy = {
  "bn": {
    "privacy": {
      "title": "গোপনীয়তা নীতি",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. আমরা কী কী তথ্য সংগ্রহ করি",
          "paragraphs": [],
          "items": [
            "পরিচয়পত্র ও প্রমাণ: আপনার জাতীয় পরিচয়পত্র (NID) নম্বর, NID-এর ছবি, জন্ম নিবন্ধন (Birth Certificate) নম্বর, জন্ম নিবন্ধনের ছবি এবং আপনার পাসপোর্ট সাইজের ছবি।",
            "যোগাযোগের তথ্য: ফোন নম্বর, নাম এবং ইমেইল অ্যাড্রেস।",
            "ট্রানজেকশন ডেটা: পেমেন্ট লিংক, ইনভয়েস এবং ট্রানজেকশন স্ট্যাটাস।"
          ]
        },
        {
          "heading": "1.2. টু-ফ্যাক্টর অথেনটিকেশন (2FA) এবং অ্যাকাউন্ট সুরক্ষা",
          "paragraphs": [
            "MecoPay-তে অ্যাকাউন্ট সুরক্ষার জন্য কোনো সনাতন ইমেইল ও পাসওয়ার্ড দিয়ে সরাসরি অ্যাকাউন্ট খোলার ব্যবস্থা রাখা হয়নি। আপনাকে কেবল Google Account (গুগল সাইন-ইন) যুক্ত সুরক্ষিত ডিভাইসের মাধ্যমে এক্সেস নিতে হবে।"
          ],
          "items": [
            "অ্যাক্সেস ও 2-Step ভেরিফিকেশন সুরক্ষা: আমাদের প্ল্যাটফর্মে গুগল সাইন-ইন করার পর আপনি 2-Step Verification (TOTP) সক্রিয় করতে পারবেন। কোনো অনাকাঙ্ক্ষিত পরিস্থিতিতে যদি কেউ আপনার জিমেইল অ্যাকাউন্ট হ্যাক করে ফেলে বা আপনার জিমেইল পাসওয়ার্ড জেনেও ফেলে, তবুও আপনার Google Authenticator-এর ৬ ডিজিটের ভেরিফিকেশন কোড ছাড়া অন্য কারো পক্ষে আপনার MecoPay অ্যাকাউন্টে প্রবেশ করা সম্ভব হবে না।",
            "বায়োমেট্রিক রিকমেন্ডেশন: আপনার অ্যাকাউন্টকে সম্পূর্ণ সুরক্ষিত রাখতে আমরা 2-Step Verification-এর ক্ষেত্রে ফিঙ্গারপ্রিন্ট (Fingerprint) বা বায়োমেট্রিক অপশন ব্যবহারের জন্য জোরালো সুপারিশ করছি।"
          ]
        },
        {
          "heading": "1.3. সিঙ্গেল অ্যাকাউন্ট এবং পার্মানেন্ট লক পলিসি",
          "paragraphs": [
            "আমাদের প্ল্যাটফর্মে একজন ব্যক্তির তথ্য দিয়ে কেবল একটি অ্যাকাউন্টই খোলা সম্ভব। লগইন প্রোফাইলে আইডেন্টিটি ভেরিফিকেশনের জন্য দুটি অপশন থাকে (১৮ বছরের নিচে বা ১৮ বছরের উপরে):"
          ],
          "items": [
            "১৮ বছরের উপরে: NID এবং জন্ম নিবন্ধন (Birth Certificate) উভয়ের তথ্য ও ছবি প্রদান বাধ্যতামূলক। একবার প্রোফাইল ভেরিফাই করা হলে, এই ডকুমেন্টগুলো সিস্টেমে পার্মানেন্টলি লক হয়ে যাবে।",
            "১৮ বছরের নিচে: শুধুমাত্র জন্ম নিবন্ধনের তথ্য ও ছবি প্রদান করে অ্যাকাউন্ট ভেরিফাই করা যাবে। পরবর্তীতে NID আপডেট করার সুযোগ থাকবে, তবে জন্ম নিবন্ধন তথ্যটি পার্মানেন্টলি লক থাকবে।",
            "সতর্কতা: বয়স ১৮ বছরের উপরে হয়েও NID এড়ানোর জন্য ভুল বয়স নির্বাচন করলে অ্যাকাউন্ট ভেরিফাই হবে না এবং ব্লক করা হতে পারে। একই ডকুমেন্ট দিয়ে দ্বিতীয় অ্যাকাউন্ট খোলার চেষ্টা বাতিল হবে।"
          ]
        },
        {
          "heading": "1.4. ইন্টারন্যাশনাল ব্যাংক-লেভেল সিকিউরিটি",
          "paragraphs": [
            "আমরা গ্রাহকদের তথ্যের নিরাপত্তায় কোনো আপস করি না। আপনার তথ্য সুরক্ষিত রাখতে MecoPay ইন্টারন্যাশনাল ব্যাংক-লেভেল সিকিউরিটি মেইনটেইন করে।"
          ],
          "items": [
            "ফ্রন্টএন্ড ও এজ সিকিউরিটি (MecoPay Shield): আমাদের গ্লোবাল এজ নেটওয়ার্কের মাধ্যমে ফ্রন্টএন্ড এবং API ট্রাফিক এনক্রিপ্টেড ও DDoS আক্রমণ থেকে সুরক্ষিত থাকে।",
            "ব্যাকএন্ড সিকিউরিটি (Row Level Security - RLS): আপনার অ্যাকাউন্টের ডাটা শুধুমাত্র আপনিই দেখতে পারবেন।",
            "এন্ড-টু-এন্ড এনক্রিপশন: অ্যান্ড্রয়েড অ্যাপ এবং সার্ভারের প্রতিটি কানেকশন HMAC SHA-256 সিগনেচার দিয়ে সুরক্ষিত থাকে।"
          ]
        },
        {
          "heading": "1.5. যোগাযোগ",
          "paragraphs": [
            "এই প্রাইভেসি পলিসি সম্পর্কে প্রশ্ন থাকলে support@mecopay.com-এ যোগাযোগ করুন।"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "শর্তাবলী",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. সার্ভিসের বিবরণ",
          "paragraphs": [
            "MecoPay একটি অল-ইন-ওয়ান (All-in-One) ই-কমার্স SaaS প্ল্যাটফর্ম, যা Innovative Education & Technology (IET)-এর একটি বিশেষ উদ্যোগ। এটি মার্চেন্ট এবং কাস্টমারদের মধ্যে লেনদেন স্বয়ংক্রিয় করার একটি পেমেন্ট অটোমেশন ও সমন্বিত ই-কমার্স ইকোসিস্টেম।",
            "MecoPay সরাসরি কাস্টমার থেকে মার্চেন্টের অ্যাকাউন্টে পেমেন্ট প্রসেস ও ভেরিফাই করতে সাহায্য করে এবং কোনো কাস্টমার বা মার্চেন্ট의 টাকা নিজেদের কাছে হোল্ড বা জমা রাখে না।"
          ],
          "items": []
        },
        {
          "heading": "2.2. অটো-রাউটিং এবং ট্রানজেকশন লিমিট",
          "paragraphs": [],
          "items": [
            "পার্সোনাল MFS: ইউজাররা পার্সোনাল মোবাইল ব্যাংকিং অ্যাকাউন্ট ব্যবহার করতে পারবেন। সর্বোচ্চ ২টি পার্সোনাল নাম্বার সেট করা যাবে; প্রথম নাম্বারের লিমিট শেষ হলে সিস্টেম দ্বিতীয় নাম্বরে পেমেন্ট রাউট করবে।",
            "মার্চেন্ট API: পার্সোনাল অ্যাকাউন্টের লিমিটের চেয়ে বেশি ভলিউমের ট্রানজেকশন প্রয়োজন হলে মার্চেন্ট API সেট করতে হবে।"
          ]
        },
        {
          "heading": "2.3. দায়বদ্ধতার সীমাবদ্ধতা (Limitation of Liability)",
          "paragraphs": [
            "পার্সোনাল MFS অ্যাকাউন্টে অতিরিক্ত ট্রানজেকশন বা অটো-রাউটিং ব্যবহারের কারণে সংশ্লিষ্ট মোবাইল ব্যাংকিং কর্তৃপক্ষ অ্যাকাউন্ট সীমিত, ব্লক বা সাসপেন্ড করলে তার দায়ভার ইউজারের। এ ধরনের কারণে MecoPay কোনো আইনি বা আর্থিকভাবে দায়ী থাকবে না।"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "রিফান্ড নীতি",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. সাবস্ক্রিপশন রিফান্ড",
          "paragraphs": [
            "MecoPay ইউজারদের ফ্রি ট্রায়ালের সুবিধা প্রদান করে, যাতে তারা সার্ভিস যাচাই করতে পারেন। তাই Basic বা Pro-এর মতো পেইড সাবস্ক্রিপশন শুরু হওয়ার পর সাধারণত ফি ফেরতযোগ্য নয়।"
          ],
          "items": []
        },
        {
          "heading": "2. রিফান্ডের ক্ষেত্রে ক্লায়েন্টের জন্য জিরো চার্জ",
          "paragraphs": [
            "কাস্টমার কোনো প্রোডাক্ট রিটার্ন করলে বা অ্যাডভান্স পেমেন্ট রিফান্ড চাইলে ক্লায়েন্ট/মার্চেন্টকে সম্পূর্ণ অগ্রিম টাকা ফেরত দিতে হবে।",
            "রিফান্ড ভেরিফাই করার সময় MecoPay যে ট্রানজেকশন বা সার্ভিস চার্জ নিয়েছিল, তা ক্লায়েন্টের কাছ থেকে আর কাটা হবে না বা মওকুফ করা হবে।"
          ],
          "items": []
        },
        {
          "heading": "3. ব্যতিক্রমী ক্ষেত্র (Exceptional Cases)",
          "paragraphs": [
            "নিচের ক্ষেত্রে MecoPay-এর সাবস্ক্রিপশন ফি রিফান্ড বিবেচনা করা হতে পারে:"
          ],
          "items": [
            "সিস্টেমের টেকনিক্যাল ত্রুটির কারণে ডাবল বিলিং হলে।",
            "দীর্ঘমেয়াদী অপ্রত্যাশিত আউটেজ বা ডাউনটাইম থাকলে।",
            "নোট: তৃতীয় পক্ষের মোবাইল ব্যাংকিং প্রদানকারীর নিজস্ব সার্ভার ডাউনের কারণে বিলম্ব এই শর্তের আওতাভুক্ত নয়।"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "প্রতারণা প্রতিরোধ ও গ্রাহক অধিকার নীতি",
      "alertTitle": "জিরো-টলারেন্স অ্যান্টি-ফ্রড নীতি",
      "alert": "আমরা কাস্টমারদের অধিকার রক্ষায় জিরো-টলারেন্স নীতি মেনে চলি। Checkout page-এ Report button রয়েছে; প্রতারণা হলে প্রমাণসহ সরাসরি অভিযোগ জানানো যাবে।",
      "sections": [
        {
          "heading": "1. ডেলিভারি যাচাইকরণ প্রক্রিয়া",
          "paragraphs": [],
          "items": [
            "ফিজিক্যাল প্রোডাক্ট: কাস্টম বা নো-কোড ওয়েবসাইট যেটিই ব্যবহার করা হোক, delivery API সংযোগ করা বাধ্যতামূলক। ব্যাকএন্ড courier API থেকে ডেটা নিয়ে রিয়েল-টাইমে যাচাই করবে।",
            "ডিজিটাল প্রোডাক্ট: অভিযোগ এলে ক্রেতা ও বিক্রেতার স্ক্রিনশট, brand data এবং server log cross-check করে ম্যানুয়ালি যাচাই করা হবে।"
          ]
        },
        {
          "heading": "2. প্রতারণার শাস্তি এবং আইনি ব্যবস্থা",
          "paragraphs": [
            "প্রমাণিত হলে যে কোনো merchant বা client অগ্রিম টাকা নিয়ে product দেনি, নিচের পদক্ষেপ নেওয়া হবে:"
          ],
          "items": [
            "Warning ও সমাধান: রিপোর্ট পাওয়ার পর প্রমাণসহ জানানো হবে; সমাধান না হলে account ban হবে।",
            "Permanent Ban: অভিযোগ প্রমাণিত হলে account স্থায়ীভাবে ban এবং পরিচয়পত্র blacklisted করা হবে।",
            "Refund বাধ্যবাধকতা: client-কে নিজের দায়িত্বে সম্পূর্ণ টাকা ফেরত দিতে হবে।",
            "মামলা ও আইনি পদক্ষেপ: টাকা ফেরত না দিলে বা সমাধান না করলে প্রচলিত consumer protection ও cyber law অনুযায়ী ব্যবস্থা নেওয়া হবে।"
          ]
        }
      ]
    },
    "docs": {
      "title": "Docs",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "লগইন করে profile details save করার পর Your MecoPay সেকশন থেকে Documentation Docs-এ Laravel, Node.js বা Python দিয়ে তৈরি ওয়েবসাইটের জন্য বিস্তারিত API Documentation ও JSON payload দেখতে পারবেন।",
            "WordPress/WooCommerce integration-এর জন্য Plugin Apps & Plugin সেকশনে এবং Personal MFS automation-এর জন্য Sync App একই জায়গা থেকে download করতে পারবেন।"
          ],
          "items": []
        }
      ]
    }
  },
  "en": {
    "privacy": {
      "title": "Privacy Policy",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. What information do we collect",
          "paragraphs": [],
          "items": [
            "Identification documents and proof: your National Identity (NID) number, a photo of the NID, birth registration (Birth Certificate) number, a photo of the birth certificate, and your passport-size photograph.",
            "Contact information: phone number, name, and email address.",
            "Transaction data: payment links, invoices, and transaction status."
          ]
        },
        {
          "heading": "1.2. Two-Factor Authentication (2FA) and Account Security",
          "paragraphs": [
            "MecoPay does not provide a traditional email-and-password signup for account security. You must access via a secured device linked to your Google Account (Google Sign-In)."
          ],
          "items": [
            "Access and 2-Step verification security: After signing in with Google on our platform, you can enable 2-Step Verification (TOTP). Even if someone hacks your Gmail account or learns your Gmail password, they cannot access your MecoPay account without the six-digit verification code from your Google Authenticator.",
            "Biometric recommendation: To fully secure your account, we strongly recommend using fingerprint or biometric options for 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Single Account and Permanent Lock Policy",
          "paragraphs": [
            "Only one account can be opened on our platform using a single person's information. There are two options for identity verification on the login profile (under 18 or 18 and above):"
          ],
          "items": [
            "18 and above: Provision of both NID and birth registration (Birth Certificate) information and photos is mandatory. Once the profile is verified, these documents will be permanently locked in the system.",
            "Under 18: The account can be verified by providing only the birth registration information and photo. There will be an opportunity to update NID later, but the birth registration information will remain permanently locked.",
            "Warning: If you falsely select a younger age to avoid NID despite being over 18, the account will not be verified and may be blocked. Attempts to open a second account with the same document will be rejected."
          ]
        },
        {
          "heading": "1.4. International Bank-Level Security",
          "paragraphs": [
            "We do not compromise on the security of customer data. MecoPay maintains international bank-level security to protect your information."
          ],
          "items": [
            "Frontend and edge security (MecoPay Shield): Through our global edge network, frontend and API traffic are encrypted and protected from DDoS attacks.",
            "Backend security (Row Level Security - RLS): Only you can view your account's data.",
            "End-to-end encryption: Each connection between the Android app and the server is secured with an HMAC SHA-256 signature."
          ]
        },
        {
          "heading": "1.5. Contact",
          "paragraphs": [
            "If you have questions about this Privacy Policy, contact support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Terms & Conditions",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Service Description",
          "paragraphs": [
            "MecoPay is an all-in-one e-commerce SaaS platform, a special initiative of Innovative Education & Technology (IET). It is a payment automation and integrated e-commerce ecosystem to automate transactions between merchants and customers.",
            "MecoPay assists in processing and verifying payments directly from customers to merchants' accounts and does not hold or deposit any customer's or merchant's funds with itself."
          ],
          "items": []
        },
        {
          "heading": "2.2. Auto-Routing and Transaction Limits",
          "paragraphs": [],
          "items": [
            "Personal MFS: Users may use personal mobile banking accounts. Up to 2 personal numbers can be set; if the first number's limit is reached, the system will route payments to the second number.",
            "Merchant API: If transactions require a volume beyond personal account limits, the merchant must set up a Merchant API."
          ]
        },
        {
          "heading": "2.3. Limitation of Liability",
          "paragraphs": [
            "If the relevant mobile banking authority limits, blocks, or suspends an account due to excess transactions or use of auto-routing on a personal MFS account, the user will be responsible. MecoPay will not be legally or financially liable for such consequences."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Refund Policy",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Subscription Refund",
          "paragraphs": [
            "MecoPay offers users a free trial so they can evaluate the service. Therefore, fees are generally non-refundable after paid subscriptions such as Basic or Pro have started."
          ],
          "items": []
        },
        {
          "heading": "2. Zero Charge to Client for Refunds",
          "paragraphs": [
            "If a customer returns a product or requests a refund for an advance payment, the client/merchant must fully refund the advance amount.",
            "When verifying the refund, any transaction or service charges that MecoPay had taken will not be deducted from the client; they will be waived."
          ],
          "items": []
        },
        {
          "heading": "3. Exceptional Cases",
          "paragraphs": [
            "MecoPay may consider refunding subscription fees in the following cases:"
          ],
          "items": [
            "If double billing occurs due to a technical fault in the system.",
            "If there is prolonged unexpected outage or downtime.",
            "Note: Delays caused by third-party mobile banking providers' own server downtime are not covered by this condition."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Anti-Fraud & Customer Rights Policy",
      "alertTitle": "Zero-Tolerance Anti-Fraud Policy",
      "alert": "We follow a zero-tolerance policy to protect customers' rights. There is a Report button on the Checkout page; if fraud occurs, complaints with evidence can be submitted directly.",
      "sections": [
        {
          "heading": "1. Delivery Verification Process",
          "paragraphs": [],
          "items": [
            "Physical products: Whether using a custom or no-code website, connecting a delivery API is mandatory. The backend will fetch data from the courier API and verify in real-time.",
            "Digital products: For complaints, buyer and seller screenshots, brand data, and server logs will be manually cross-checked."
          ]
        },
        {
          "heading": "2. Penalties for Fraud and Legal Measures",
          "paragraphs": [
            "If proven that any merchant or client took advance payment and did not deliver the product, the following steps will be taken:"
          ],
          "items": [
            "Warning and resolution: After receiving a report, the issue will be reported with evidence; if not resolved, the account will be banned.",
            "Permanent Ban: If the complaint is proven, the account will be permanently banned and identity documents blacklisted.",
            "Refund obligation: The client must, at their own responsibility, refund the full amount.",
            "Litigation and legal steps: If the money is not refunded or no resolution is reached, action will be taken under applicable consumer protection and cyber law."
          ]
        }
      ]
    },
    "docs": {
      "title": "Docs",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "After logging in and saving profile details, from the Your MecoPay section under Documentation Docs you can view detailed API documentation and JSON payloads for websites built with Laravel, Node.js, or Python.",
            "For WordPress/WooCommerce integration, you can download Plugins in the Plugin Apps & Plugin section, and for Personal MFS automation you can download the Sync App from the same place."
          ],
          "items": []
        }
      ]
    }
  },
  "hi": {
    "privacy": {
      "title": "गोपनीयता नीति",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. हम कौन-कौन सी जानकारी एकत्र करते हैं",
          "paragraphs": [],
          "items": [
            "पहचान पत्र और प्रमाण: आपका राष्ट्रीय पहचान पत्र (NID) नंबर, NID की तस्वीर, जन्म प्रमाणन (Birth Certificate) नंबर, जन्म प्रमाणन की तस्वीर और आपका पासपोर्ट साइज फोटो।",
            "संपर्क जानकारी: फ़ोन नंबर, नाम और ईमेल पता।",
            "लेन-देन डेटा: भुगतान लिंक, चालान और लेन-देन स्थिति।"
          ]
        },
        {
          "heading": "1.2. टू-फैक्टर ऑथेंटिकेशन (2FA) और खाता सुरक्षा",
          "paragraphs": [
            "MecoPay में खाते की सुरक्षा के लिए पारंपरिक ईमेल और पासवर्ड के साथ सीधे खाता खोलने की व्यवस्था नहीं है। आपको केवल Google Account (गूगल साइन-इन) से जुड़े सुरक्षित डिवाइस के माध्यम से एक्सेस लेना होगा।"
          ],
          "items": [
            "एक्सेस और 2-Step वेरिफिकेशन सुरक्षा: हमारे प्लेटफ़ॉर्म पर Google साइन-इन के बाद आप 2-Step Verification (TOTP) सक्रिय कर सकते हैं। किसी अनपेक्षित स्थिति में यदि कोई आपका Gmail अकाउंट हैक कर ले या आपका Gmail पासवर्ड जान ले, तब भी आपके Google Authenticator के 6 डिजिट वेरिफिकेशन कोड के बिना कोई अन्य व्यक्ति आपके MecoPay खाते में प्रवेश नहीं कर पाएगा।",
            "बायोमेट्रिक सिफारिश: अपने खाते को पूरी तरह सुरक्षित रखने के लिए हम 2-Step Verification में फिंगरप्रिंट (Fingerprint) या बायोमेट्रिक विकल्प इस्तेमाल करने की कड़क सिफारिश करते हैं।"
          ]
        },
        {
          "heading": "1.3. सिंगल अकाउंट और परमानेंट लॉक नीति",
          "paragraphs": [
            "हमारे प्लेटफ़ॉर्म पर एक व्यक्ति की जानकारी से केवल एक ही खाता खोला जा सकता है। लॉगिन प्रोफ़ाइल में पहचान सत्यापन के लिए दो विकल्प होते हैं (18 वर्ष से कम या 18 वर्ष से अधिक):"
          ],
          "items": [
            "18 वर्ष से ऊपर: NID और जन्म प्रमाणन (Birth Certificate) दोनों की जानकारी और तस्वीर प्रदान करना अनिवार्य है। एक बार प्रोफ़ाइल सत्यापित होने पर ये दस्तावेज़ सिस्टम में स्थायी रूप से लॉक हो जाएंगे।",
            "18 वर्ष से कम: केवल जन्म प्रमाणन की जानकारी और तस्वीर देकर खाता सत्यापित किया जा सकता है। बाद में NID अपडेट करने का विकल्प रहेगा, पर जन्म प्रमाणन की जानकारी स्थायी रूप से लॉक रहेगी।",
            "सतर्कता: यदि 18 वर्ष से अधिक होने के बावजूद NID से बचने के लिए गलत उम्र चुनते हैं तो खाता सत्यापित नहीं होगा और ब्लॉक किया जा सकता है। उसी दस्तावेज़ से दूसरा खाता खोलने का प्रयास रद्द कर दिया जाएगा।"
          ]
        },
        {
          "heading": "1.4. अंतरराष्ट्रीय बैंक-स्तरीय सुरक्षा",
          "paragraphs": [
            "हम ग्राहकों के डेटा की सुरक्षा में कोई समझौता नहीं करते। आपके डेटा की सुरक्षा के लिए MecoPay अंतरराष्ट्रीय बैंक-स्तरीय सुरक्षा बनाए रखता है।"
          ],
          "items": [
            "फ्रंटएंड और एज सुरक्षा (MecoPay Shield): हमारे ग्लोबल एज नेटवर्क के माध्यम से फ्रंटएंड और API ट्रैफ़िक एन्क्रिप्टेड और DDoS हमलों से सुरक्षित रहता है।",
            "बैकएंड सुरक्षा (Row Level Security - RLS): आपके अकाउंट का डेटा केवल आप ही देख पाएंगे।",
            "एंड-टू-एंड एन्क्रिप्शन: एंड्रॉइड ऐप और सर्वर के प्रत्येक कनेक्शन को HMAC SHA-256 सिग्नेचर द्वारा सुरक्षित किया जाता है।"
          ]
        },
        {
          "heading": "1.5. संपर्क",
          "paragraphs": [
            "इस गोपनीयता नीति के बारे में प्रश्न होने पर support@mecopay.com पर संपर्क करें।"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "नियम एवं शर्तें",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. सेवा का विवरण",
          "paragraphs": [
            "MecoPay एक ऑल-इन-वन (All-in-One) ई-कॉमर्स SaaS प्लेटफ़ॉर्म है, जो Innovative Education & Technology (IET) की एक विशेष पहल है। यह व्यापारियों और ग्राहकों के बीच लेनदेन को स्वचालित करने वाला एक भुगतान ऑटोमेशन और समेकित ई-कॉमर्स इकोसिस्टम है।",
            "MecoPay सीधे ग्राहक से व्यापारी के खाते में भुगतान को प्रोसेस और सत्यापित करने में मदद करता है और किसी भी ग्राहक या व्यापारी की राशि को अपने पास होल्ड या जमा नहीं रखता।"
          ],
          "items": []
        },
        {
          "heading": "2.2. ऑटो-राउटिंग और लेन-देन सीमा",
          "paragraphs": [],
          "items": [
            "Personal MFS: उपयोगकर्ता व्यक्तिगत मोबाइल बैंकिंग अकाउंट उपयोग कर सकते हैं। अधिकतम 2 व्यक्तिगत नंबर सेट किए जा सकेंगे; पहले नंबर की सीमा समाप्त होने पर सिस्टम दूसरे नंबर पर भुगतान रूट करेगा।",
            "Merchant API: व्यक्तिगत अकाउंट की सीमा से अधिक वॉल्यूम वाले लेन-देन के लिए Merchant API सेट करना होगा।"
          ]
        },
        {
          "heading": "2.3. उत्तरदायित्व की सीमाएं (Limitation of Liability)",
          "paragraphs": [
            "यदि व्यक्तिगत MFS अकाउंट में अतिरिक्त लेन-देन या ऑटो-राउटिंग के उपयोग के कारण संबंधित मोबाइल बैंकिंग प्राधिकारी अकाउंट को सीमित, ब्लॉक या सस्पेंड कर दे तो इसकी जिम्मेदारी उपयोगकर्ता की होगी। ऐसे मामलों में MecoPay किसी कानूनी या वित्तीय रूप में जिम्मेदार नहीं होगा।"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "रिफंड नीति (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. सब्सक्रिप्शन रिफंड",
          "paragraphs": [
            "MecoPay उपयोगकर्ताओं को फ्री ट्रायल की सुविधा देता है ताकि वे सेवा का परीक्षण कर सकें। इसलिए Basic या Pro जैसे पेड सब्सक्रिप्शन शुरू होने के बाद सामान्यतः शुल्क रिफंड योग्य नहीं होते।"
          ],
          "items": []
        },
        {
          "heading": "2. रिफंड के मामलों में क्लाइंट के लिए ज़ीरो चार्ज",
          "paragraphs": [
            "यदि ग्राहक कोई उत्पाद लौटाता है या अग्रिम भुगतान के रिफंड की मांग करता है तो क्लाइंट/व्यापारी को पूरा अग्रिम भुगतान वापस करना होगा।",
            "रिफंड सत्यापित होने पर MecoPay द्वारा लिया गया कोई ट्रांज़ैक्शन या सेवा शुल्क क्लाइंट से फिर नहीं काटा जाएगा या माफ़ कर दिया जाएगा।"
          ],
          "items": []
        },
        {
          "heading": "3. अपवादात्मक मामले (Exceptional Cases)",
          "paragraphs": [
            "नीचे दिए गए मामलों में MecoPay की सदस्यता शुल्क रिफंड के लिए विचार किया जा सकता है:"
          ],
          "items": [
            "सिस्टम की तकनीकी त्रुटि के कारण डबल बिलिंग होने पर।",
            "दीर्घकालिक अनपेक्षित आउटेज या डाउनटाइम होने पर।",
            "नोट: तीसरे पक्ष के मोबाइल बैंकिंग प्रदाता के अपने सर्वर डाउन होने के कारण होने वाली देरी इस शर्त के अंतर्गत नहीं आती।"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "एंटी-फ़्रॉड और ग्राहक अधिकार नीति",
      "alertTitle": "ज़ीरो-टॉलरेंस एंटी-फ़्रॉड नीति",
      "alert": "हम ग्राहकों के अधिकारों की रक्षा में ज़ीरो-टॉलरेंस नीति अपनाते हैं। Checkout पेज पर Report बटन है; धोखाधड़ी होने पर सबूत के साथ सीधे शिकायत दर्ज की जा सकती है।",
      "sections": [
        {
          "heading": "1. वितरण सत्यापन प्रक्रिया",
          "paragraphs": [],
          "items": [
            "फिजिकल प्रोडक्ट: कस्टम या नो-कोड वेबसाइट जो भी उपयोग हो, delivery API कनेक्शन अनिवार्य है। बैकएंड courier API से डेटा लेकर रीयल-टाइम में सत्यापन करेगा।",
            "डिजिटल प्रोडक्ट: शिकायत आने पर खरीदार और विक्रेता के स्क्रीनशॉट, brand data और server log को क्रॉस-चेक करके मैन्युअली सत्यापित किया जाएगा।"
          ]
        },
        {
          "heading": "2. धोखाधड़ी की सजा और कानूनी कार्रवाई",
          "paragraphs": [
            "साबित होने पर कि किसी भी merchant या client ने अग्रिम धन लेकर उत्पाद नहीं दिया, निम्नलिखित कदम उठाए जाएंगे:"
          ],
          "items": [
            "Warning और समाधान: रिपोर्ट मिलने पर सबूत के साथ बताया जाएगा; समाधान नहीं होने पर अकाउंट ban कर दिया जाएगा।",
            "Permanent Ban: शिकायत सिद्ध होने पर अकाउंट को स्थायी रूप से ban और पहचान पत्र को blacklisted कर दिया जाएगा।",
            "Refund बाध्यता: client को अपनी जिम्मेदारी पर पूरा पैसा वापस करना होगा।",
            "मामला और कानूनी कार्रवाई: पैसा वापस न करने या समाधान न होने पर प्रचलित consumer protection और cyber law के तहत कार्रवाई की जाएगी।"
          ]
        }
      ]
    },
    "docs": {
      "title": "API दस्तावेज़",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "लॉगिन करके profile details save करने के बाद Your MecoPay सेक्शन से Documentation Docs में Laravel, Node.js या Python से बने वेबसाइट के लिए विस्तृत API Documentation और JSON payload देख सकते हैं।",
            "WordPress/WooCommerce integration के लिए Plugin Apps & Plugin सेक्शन में और Personal MFS automation के लिए Sync App को उसी जगह से download कर सकते हैं।"
          ],
          "items": []
        }
      ]
    }
  },
  "ar": {
    "privacy": {
      "title": "سياسة الخصوصية",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. المعلومات التي نجمعها",
          "paragraphs": [],
          "items": [
            "الهويات والوثائق: رقم بطاقة الهوية الوطنية (NID)، صورة الـNID، رقم شهادة الميلاد (Birth Certificate)، صورة شهادة الميلاد، وصورة بحجم جواز السفر.",
            "معلومات الاتصال: رقم الهاتف، الاسم وعنوان البريد الإلكتروني.",
            "بيانات المعاملات: رابط الدفع، الفاتورة وحالة المعاملة."
          ]
        },
        {
          "heading": "1.2. المصادقة الثنائية (2FA) وأمن الحساب",
          "paragraphs": [
            "لا يوفر MecoPay خيار فتح حساب مباشر باستخدام بريد إلكتروني تقليدي وكلمة مرور. يجب الوصول إلى الحساب عبر جهاز مؤمَّن مرتبط بـGoogle Account (تسجيل الدخول عبر Google)."
          ],
          "items": [
            "الحماية عبر الدخول والتحقق المكوّن من خطوتين: بعد تسجيل الدخول عبر Google على منصتنا يمكنك تفعيل 2-Step Verification (TOTP). حتى إذا تمكن شخص ما من اختراق حساب Gmail الخاص بك أو علم بكلمة مرور Gmail، فلن يتمكن أحد من الوصول إلى حساب MecoPay الخاص بك دون رمز التحقق المكوّن من 6 أرقام في Google Authenticator.",
            "توصية القياسات الحيوية: للحفاظ على أمان حسابك ننصح بشدَّة باستخدام بصمة الإصبع (Fingerprint) أو خيار القياسات الحيوية عند تفعيل 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. سياسة الحساب الواحد والقفل الدائم",
          "paragraphs": [
            "يسمح لمنصتنا بفتح حساب واحد فقط لكل شخص. يوجد خياران للتحقق من الهوية في ملف الدخول (أقل من 18 عامًا أو فوق 18 عامًا):"
          ],
          "items": [
            "فوق 18 عامًا: تقديم معلومات وصور كل من NID وشهادة الميلاد (Birth Certificate) إلزامي. بمجرد التحقق من الملف الشخصي، سيتم قفل هذه المستندات نهائيًا في النظام.",
            "أقل من 18 عامًا: يمكن التحقق من الحساب بتقديم معلومات وصورة شهادة الميلاد فقط. سيكون هناك إمكانية لتحديث NID لاحقًا، لكن معلومات شهادة الميلاد ستبقى مقفلة نهائيًا.",
            "تنبيه: إذا كان عمرك فوق 18 ولم تقم بتقديم NID واخترت عمرًا خاطئًا لتجنّب الـNID، فلن يتم التحقق من الحساب وقد يتم حظره. كما سيتم رفض أي محاولة لفتح حساب ثانٍ بنفس الوثيقة."
          ]
        },
        {
          "heading": "1.4. أمان بمستوى البنوك الدولية",
          "paragraphs": [
            "نحن لا نتهاون في أمن بيانات العملاء. يحافظ MecoPay على أمان بمستوى البنوك الدولية لحماية معلوماتك."
          ],
          "items": [
            "أمن الواجهة والنهايات (MecoPay Shield): عبر شبكة الحافة العالمية لدينا يتم تشفير حركة الواجهة وAPI وحمايتها من هجمات DDoS.",
            "أمن الخلفية (Row Level Security - RLS): بيانات حسابك لا يراها إلا أنت.",
            "تشفير من النهاية إلى النهاية: كل اتصال بين تطبيق Android والخادم محمي بتوقيع HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. التواصل",
          "paragraphs": [
            "لأي استفسارات حول سياسة الخصوصية هذه، يرجى التواصل عبر support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "الأحكام والشروط",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. وصف الخدمة",
          "paragraphs": [
            "MecoPay هو منصة e‑commerce متكاملة (All-in-One) على نموذج SaaS، ومبادرة مميزة من Innovative Education & Technology (IET). إنها منظومة تجارية إلكترونية متكاملة لأتمتة المدفوعات والتنسيق بين التاجر والزبون.",
            "يساعد MecoPay في معالجة والتحقق من المدفوعات مباشرة من الزبون إلى حساب التاجر، ولا يحتجز أو يخزن أموال أي زبون أو تاجر لدى نفسه."
          ],
          "items": []
        },
        {
          "heading": "2.2. التوجيه التلقائي وحدود المعاملات",
          "paragraphs": [],
          "items": [
            "MFS شخصي: يمكن للمستخدمين استخدام حسابات الخدمات المالية عبر المحمول الشخصية. يمكن تعيين حتى رقمين شخصيين كحد أقصى؛ عند نفاد حد الرقم الأول يقوم النظام بتوجيه الدفع إلى الرقم الثاني.",
            "API للتاجر: إذا كانت هناك حاجة إلى حجم معاملات يتجاوز حدود الحسابات الشخصية، يجب إعداد Merchant API."
          ]
        },
        {
          "heading": "2.3. حدود المسؤولية (Limitation of Liability)",
          "paragraphs": [
            "إذا قامت سلطة الخدمات المالية عبر المحمول المعنية بتقييد أو حظر أو إيقاف الحساب نتيجة لاستخدام معاملات إضافية أو التوجيه التلقائي على حساب MFS الشخصي، فالمسؤولية تقع على المستخدم. لن يكون MecoPay مسؤولًا قانونيًا أو ماليًا عن مثل هذه الحالات."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "سياسة الاسترداد (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. استرداد الاشتراك",
          "paragraphs": [
            "يقدم MecoPay فترة تجريبية مجانية للمستخدمين لفحص الخدمة. لذلك بشكل عام لا تُسترد الرسوم بعد بدء الاشتراك المدفوع مثل Basic أو Pro."
          ],
          "items": []
        },
        {
          "heading": "2. في حالة الاسترداد: عدم تحميل العميل أية رسوم",
          "paragraphs": [
            "إذا أعاد الزبون منتجًا أو طالب باسترداد دفعة مسبقة، يجب على العميل/التاجر إعادة المبلغ المدفوع بالكامل.",
            "أثناء التحقق من الاسترداد، لن يتم اقتطاع أو تحميل العميل رسوم المعاملة أو رسوم الخدمة التي كان يحصل عليها MecoPay؛ سيتم إما عدم خصمها أو إعفاؤها."
          ],
          "items": []
        },
        {
          "heading": "3. الحالات الاستثنائية (Exceptional Cases)",
          "paragraphs": [
            "قد يتم النظر في استرداد رسوم اشتراك MecoPay في الحالات التالية:"
          ],
          "items": [
            "في حال حدوث فوترة مزدوجة نتيجة خلل تقني في النظام.",
            "في حال حدوث انقطاع طويل وغير متوقع في الخدمة.",
            "ملاحظة: التأخير الناتج عن تعطل خوادم مزود خدمات المحمول التابع لجهة خارجية لا يندرج تحت هذا الشرط."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "سياسة مكافحة الاحتيال وحقوق العملاء",
      "alertTitle": "سياسة عدم التسامح مطلقًا لمكافحة الاحتيال",
      "alert": "نحن نتبع سياسة عدم التسامح مطلقًا لحماية حقوق العملاء. توجد زر Report في صفحة الخروج (Checkout)؛ في حال الاشتباه بالاحتيال يمكن تقديم شكوى مباشرة مع الأدلة.",
      "sections": [
        {
          "heading": "1. عملية التحقق من التسليم",
          "paragraphs": [],
          "items": [
            "المنتجات المادية: سواء كان الموقع مخصصًا أو بنظام no-code، فإن توصيل delivery API إلزامي. سيقوم النظام بالتحقق في الوقت الحقيقي من بيانات الـcourier API في الخلفية.",
            "المنتجات الرقمية: في حالة وجود شكوى، سيتم التحقق يدويًا بمقارنة لقطات الشاشة من المشتري والبائع، وبيانات العلامة (brand data) وسجلات الخادم (server log)."
          ]
        },
        {
          "heading": "2. عقوبات الاحتيال والإجراءات القانونية",
          "paragraphs": [
            "إذا ثبت أن أي تاجر أو عميل أخذ أموالًا مقدَّمة ولم يسلم المنتج، فسيتم اتخاذ الإجراءات التالية:"
          ],
          "items": [
            "تحذير وحل: بعد استلام التقرير سيتم إخطار الطرف المعني مع الأدلة؛ إذا لم يتم الحل سيُحظر الحساب (account ban).",
            "حظر دائم: إذا ثبتت الشكوى سيتم حظر الحساب بشكل دائم ووضع وثائق الهوية في القائمة السوداء (blacklisted).",
            "التزام بالاسترداد: يجب على العميل إعادة المبلغ بالكامل على مسؤوليته.",
            "دعاوى وإجراءات قانونية: إذا لم يُرد المال أو لم يُحل النزاع، سيتم اتخاذ الإجراءات وفق قوانين حماية المستهلك والقوانين الإلكترونية المعمول بها."
          ]
        }
      ]
    },
    "docs": {
      "title": "توثيق API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "بعد تسجيل الدخول وحفظ تفاصيل الملف الشخصي، يمكنك من قسم Your MecoPay الدخول إلى Documentation Docs للاطلاع على توثيق API المفصل وJSON payload لمواقع الويب المبنية بـLaravel أو Node.js أو Python.",
            "لتكامل WordPress/WooCommerce توجه إلى قسم Plugin Apps & Plugin، ولأتمتة Personal MFS يمكنك تنزيل Sync App من نفس المكان."
          ],
          "items": []
        }
      ]
    }
  },
  "fr": {
    "privacy": {
      "title": "Politique de confidentialité",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Quelles informations nous collectons",
          "paragraphs": [],
          "items": [
            "Identifiants et justificatifs : le numéro de votre carte d'identité nationale (NID), la photo du NID, le numéro du certificat de naissance (Birth Certificate), la photo du certificat de naissance et votre photo au format passeport.",
            "Coordonnées : numéro de téléphone, nom et adresse e-mail.",
            "Données de transaction : lien de paiement, facture et statut des transactions."
          ]
        },
        {
          "heading": "1.2. Authentification à deux facteurs (2FA) et sécurité du compte",
          "paragraphs": [
            "MecoPay ne permet pas l'ouverture directe de compte par e-mail et mot de passe traditionnels. Vous devez accéder uniquement via un appareil sécurisé connecté à un Google Account (Google Sign-In)."
          ],
          "items": [
            "Accès et sécurité 2-Step Verification : après connexion via Google Sign-In sur notre plateforme, vous pouvez activer la 2-Step Verification (TOTP). Si quelqu'un compromet votre compte Gmail ou connaît votre mot de passe Gmail, sans le code de vérification à 6 chiffres de Google Authenticator, il ne pourra pas accéder à votre compte MecoPay.",
            "Recommandation biométrique : pour sécuriser pleinement votre compte, nous recommandons fortement d'utiliser l'empreinte digitale (Fingerprint) ou une option biométrique pour la 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Compte unique et politique de verrouillage permanent",
          "paragraphs": [
            "Sur notre plateforme, un seul compte peut être créé par personne. Le profil de connexion propose deux options de vérification d'identité (moins de 18 ans ou 18 ans et plus) :"
          ],
          "items": [
            "18 ans et plus : la fourniture des informations et des photos du NID et du certificat de naissance (Birth Certificate) est obligatoire. Une fois le profil vérifié, ces documents seront verrouillés de manière permanente dans le système.",
            "Moins de 18 ans : le compte peut être vérifié uniquement avec les informations et la photo du certificat de naissance. Il sera possible de mettre à jour le NID ultérieurement, mais les informations du certificat de naissance resteront verrouillées de façon permanente.",
            "Avertissement : si une personne majeure choisit incorrectement un âge inférieur pour éviter le NID, le compte ne sera pas vérifié et pourra être bloqué. Toute tentative d'ouvrir un deuxième compte avec le même document sera annulée."
          ]
        },
        {
          "heading": "1.4. Sécurité de niveau bancaire international",
          "paragraphs": [
            "Nous ne faisons aucun compromis sur la sécurité des données clients. Pour protéger vos informations, MecoPay maintient une sécurité de niveau bancaire international."
          ],
          "items": [
            "Sécurité front-end et edge (MecoPay Shield) : via notre réseau global d'edge, le trafic front-end et API est chiffré et protégé contre les attaques DDoS.",
            "Sécurité back-end (Row Level Security - RLS) : seules vous pouvez consulter les données de votre compte.",
            "Chiffrement de bout en bout : chaque connexion entre l'application Android et les serveurs est protégée par une signature HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Contact",
          "paragraphs": [
            "Pour toute question concernant cette politique de confidentialité, contactez support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Conditions générales",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Description du service",
          "paragraphs": [
            "MecoPay est une plateforme e‑commerce SaaS tout‑en‑un (All‑in‑One), initiative d'Innovative Education & Technology (IET). Elle constitue un écosystème d'automatisation de paiements et d'e‑commerce intégré visant à automatiser les transactions entre marchands et clients.",
            "MecoPay facilite le traitement et la vérification des paiements directement du client vers le compte du marchand et ne détient ni ne conserve les fonds des clients ou des marchands."
          ],
          "items": []
        },
        {
          "heading": "2.2. Routage automatique et limites de transaction",
          "paragraphs": [],
          "items": [
            "MFS personnel : les utilisateurs peuvent utiliser un compte de mobile banking personnel. Jusqu'à 2 numéros personnels peuvent être configurés ; lorsque la limite du premier numéro est atteinte, le système routage les paiements vers le deuxième numéro.",
            "API marchand : si vous avez besoin de volumes de transaction supérieurs aux limites des comptes personnels, vous devez configurer une API marchand."
          ]
        },
        {
          "heading": "2.3. Limitation de responsabilité (Limitation of Liability)",
          "paragraphs": [
            "Si l'autorité de mobile banking limite, bloque ou suspend le compte en raison de transactions excessives ou du routage automatique, la responsabilité incombe à l'utilisateur. MecoPay ne sera ni légalement ni financièrement responsable de tels cas."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Politique de remboursement (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Remboursement des abonnements",
          "paragraphs": [
            "MecoPay offre aux utilisateurs une période d'essai gratuite pour tester le service. Par conséquent, les frais des abonnements payants tels que Basic ou Pro sont généralement non remboursables après le début de l'abonnement."
          ],
          "items": []
        },
        {
          "heading": "2. Zéro frais pour le client lors d'un remboursement",
          "paragraphs": [
            "Si un client retourne un produit ou demande un remboursement d'un paiement anticipé, le client/marchand doit rembourser intégralement l'avance.",
            "Lors de la vérification du remboursement, les frais de transaction ou de service retenus par MecoPay ne seront pas prélevés sur le client ou seront annulés."
          ],
          "items": []
        },
        {
          "heading": "3. Cas exceptionnels (Exceptional Cases)",
          "paragraphs": [
            "Dans les cas suivants, un remboursement des frais d'abonnement de MecoPay peut être envisagé :"
          ],
          "items": [
            "En cas de double facturation due à une défaillance technique du système.",
            "En cas d'indisponibilité prolongée ou d'une panne inattendue.",
            "Remarque : les retards dus à une panne des serveurs d'un prestataire de mobile banking tiers ne sont pas couverts par cette condition."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Politique anti-fraude et droits des clients",
      "alertTitle": "Politique anti-fraude à tolérance zéro",
      "alert": "Nous appliquons une politique de tolérance zéro pour la protection des droits des clients. Sur la page de paiement (Checkout), un bouton Report est disponible ; en cas de fraude, il est possible de déposer une plainte directement avec des preuves.",
      "sections": [
        {
          "heading": "1. Procédure de vérification de livraison",
          "paragraphs": [],
          "items": [
            "Produit physique : quelle que soit la solution (site personnalisé ou no-code), la connexion à l'API de livraison (delivery API) est obligatoire. Le back-end vérifiera en temps réel les données à partir de l'API du coursier.",
            "Produit numérique : en cas de réclamation, les captures d'écran de l'acheteur et du vendeur, les données de la marque et les logs serveur seront vérifiés manuellement en croisant les éléments."
          ]
        },
        {
          "heading": "2. Sanctions en cas de fraude et mesures juridiques",
          "paragraphs": [
            "Si une fraude est avérée et qu'un marchand ou client a perçu une avance sans fournir le produit, les mesures suivantes seront prises :"
          ],
          "items": [
            "Avertissement et résolution : après réception du rapport et présentation des preuves, le cas sera communiqué ; en l'absence de résolution, le compte sera banni.",
            "Bannissement permanent : si l'accusation est prouvée, le compte sera définitivement banni et les pièces d'identité seront mises sur liste noire.",
            "Obligation de remboursement : le client devra rembourser intégralement de sa propre responsabilité.",
            "Action judiciaire et mesures légales : en cas de refus de remboursement ou d'absence de résolution, des actions seront engagées conformément aux lois sur la protection des consommateurs et au droit cybernétique applicables."
          ]
        }
      ]
    },
    "docs": {
      "title": "Documentation API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Après connexion et enregistrement des détails du profil, dans la section Your MecoPay, sous Documentation Docs, vous pourrez consulter la documentation API détaillée et les payloads JSON pour les sites développés en Laravel, Node.js ou Python.",
            "Pour l'intégration WordPress/WooCommerce, rendez-vous dans la section Plugin Apps & Plugin, et pour l'automatisation MFS personnelle, téléchargez le Sync App depuis le même emplacement."
          ],
          "items": []
        }
      ]
    }
  },
  "es": {
    "privacy": {
      "title": "Política de Privacidad",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. ¿Qué información recopilamos?",
          "paragraphs": [],
          "items": [
            "Documentos de identidad y comprobantes: su número de identificación nacional (NID), foto del NID, número del certificado de nacimiento (Birth Certificate), foto del certificado de nacimiento y su foto tamaño pasaporte.",
            "Datos de contacto: número de teléfono, nombre y dirección de correo electrónico.",
            "Datos de transacción: enlace de pago, factura y estado de la transacción."
          ]
        },
        {
          "heading": "1.2. Autenticación de dos factores (2FA) y seguridad de la cuenta",
          "paragraphs": [
            "No existe un mecanismo tradicional para crear una cuenta en MecoPay usando solo correo electrónico y contraseña. Debe acceder únicamente mediante un dispositivo seguro vinculado a su Google Account (Google Sign-in)."
          ],
          "items": [
            "Acceso y protección 2-Step Verification: después de iniciar sesión con Google en nuestra plataforma, podrá activar la verificación en 2 pasos (TOTP). En caso de que alguien comprometa su cuenta de Gmail o conozca su contraseña de Gmail, aún así no será posible acceder a su cuenta de MecoPay sin el código de verificación de 6 dígitos de Google Authenticator.",
            "Recomendación biométrica: para mantener su cuenta totalmente segura recomendamos encarecidamente usar la huella dactilar (Fingerprint) u opción biométrica en la verificación en 2 pasos."
          ]
        },
        {
          "heading": "1.3. Política de cuenta única y bloqueo permanente",
          "paragraphs": [
            "Solo se puede crear una cuenta por persona en nuestra plataforma. En el perfil de inicio de sesión hay dos opciones para la verificación de identidad (menor de 18 años o 18 años o más):"
          ],
          "items": [
            "18 años o más: es obligatorio proporcionar la información y las fotos del NID y del certificado de nacimiento (Birth Certificate). Una vez verificado el perfil, estos documentos quedarán bloqueados permanentemente en el sistema.",
            "Menores de 18 años: la cuenta se puede verificar únicamente proporcionando la información y la foto del certificado de nacimiento. Posteriormente habrá la posibilidad de actualizar el NID, pero la información del certificado de nacimiento quedará bloqueada permanentemente.",
            "Advertencia: si tiene más de 18 años pero selecciona una edad menor para evitar el NID, la cuenta no será verificada y puede ser bloqueada. Se cancelará cualquier intento de abrir una segunda cuenta con el mismo documento."
          ]
        },
        {
          "heading": "1.4. Seguridad a nivel bancario internacional",
          "paragraphs": [
            "No escatimamos en la seguridad de los datos de los clientes. MecoPay mantiene seguridad a nivel bancario internacional para proteger su información."
          ],
          "items": [
            "Seguridad de frontend y edge (MecoPay Shield): gracias a nuestra red global de edge, el tráfico del frontend y de la API está cifrado y protegido contra ataques DDoS.",
            "Seguridad de backend (Row Level Security - RLS): solo usted podrá ver los datos de su cuenta.",
            "Cifrado de extremo a extremo: cada conexión entre la aplicación Android y el servidor está protegida con firmas HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Contacto",
          "paragraphs": [
            "Si tiene preguntas sobre esta política de privacidad, contacte a support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Términos y Condiciones",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Descripción del servicio",
          "paragraphs": [
            "MecoPay es una plataforma de comercio electrónico SaaS todo en uno (All-in-One), desarrollada como una iniciativa de Innovative Education & Technology (IET). Es un ecosistema de e-commerce integrado y de automatización de pagos que automatiza las transacciones entre comerciantes y clientes.",
            "MecoPay ayuda a procesar y verificar los pagos directamente desde el cliente a la cuenta del comerciante y no retiene ni deposita dinero de clientes o comerciantes en su propia cuenta."
          ],
          "items": []
        },
        {
          "heading": "2.2. Enrutamiento automático y límites de transacción",
          "paragraphs": [],
          "items": [
            "MFS personal: los usuarios pueden usar cuentas personales de banca móvil (MFS). Se pueden configurar hasta 2 números personales; si se alcanza el límite del primer número, el sistema enrutará el pago al segundo número.",
            "Merchant API: si se requieren transacciones con un volumen superior al límite de cuentas personales, debe configurarse la Merchant API."
          ]
        },
        {
          "heading": "2.3. Limitación de responsabilidad (Limitation of Liability)",
          "paragraphs": [
            "Si la autoridad competente de banca móvil limita, bloquea o suspende la cuenta debido al uso de transacciones adicionales o enrutamiento automático en una cuenta personal MFS, la responsabilidad será del usuario. MecoPay no será legal ni financieramente responsable por tales circunstancias."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Política de Reembolso (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Reembolso de suscripción",
          "paragraphs": [
            "MecoPay ofrece a los usuarios una prueba gratuita para que puedan evaluar el servicio. Por ello, las tarifas de suscripciones de pago como Basic o Pro generalmente no son reembolsables una vez que han comenzado."
          ],
          "items": []
        },
        {
          "heading": "2. Cero cargos para el cliente en caso de reembolso",
          "paragraphs": [
            "Si un cliente devuelve un producto o solicita el reembolso de un pago anticipado, el cliente/comerciante debe devolver la totalidad del importe anticipado.",
            "Al verificar el reembolso, los cargos por transacción o servicio que MecoPay haya cobrado no serán cobrados al cliente ni se le descontarán (serán eximidos)."
          ],
          "items": []
        },
        {
          "heading": "3. Casos excepcionales (Exceptional Cases)",
          "paragraphs": [
            "En los siguientes casos se podrá considerar el reembolso de la tarifa de suscripción de MecoPay:"
          ],
          "items": [
            "En caso de doble facturación debido a un fallo técnico del sistema.",
            "Si se produce una interrupción o tiempo de inactividad prolongado e imprevisto.",
            "Nota: los retrasos debidos a la caída de los servidores del proveedor de banca móvil de terceros no entran en el ámbito de esta condición."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Política Anti-Fraude y Derechos del Cliente",
      "alertTitle": "Política anti-fraude de tolerancia cero",
      "alert": "Seguimos una política de tolerancia cero para proteger los derechos de los clientes. En la página de pago (Checkout) hay un botón Report; en caso de fraude se puede presentar una denuncia directa con pruebas.",
      "sections": [
        {
          "heading": "1. Proceso de verificación de entrega",
          "paragraphs": [],
          "items": [
            "Producto físico: sea cual sea el sitio web (personalizado o no-code) que se use, la conexión al delivery API es obligatoria. El backend verificará en tiempo real con los datos del courier API.",
            "Producto digital: ante una reclamación se verificarán manualmente las capturas de pantalla del comprador y el vendedor, los datos de la marca y los registros del servidor (server log) mediante cotejo."
          ]
        },
        {
          "heading": "2. Sanciones por fraude y acciones legales",
          "paragraphs": [
            "Si se demuestra que algún merchant o cliente aceptó un pago anticipado y no entregó el producto, se tomarán las siguientes medidas:"
          ],
          "items": [
            "Advertencia y resolución: tras recibir el informe se comunicará con pruebas; si no hay solución, la cuenta será bloqueada (account ban).",
            "Baneo permanente: si la denuncia se demuestra, la cuenta será baneada permanentemente y el documento de identidad será incluido en la lista negra (blacklisted).",
            "Obligación de reembolso: el cliente deberá devolver íntegramente el importe por su propia cuenta.",
            "Demandas y acciones legales: si no se devuelve el dinero o no se alcanza una solución, se tomarán medidas conforme a la legislación vigente de protección al consumidor (consumer protection) y la ley cibernética (cyber law)."
          ]
        }
      ]
    },
    "docs": {
      "title": "Documentación de la API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Después de iniciar sesión y guardar los detalles del perfil, desde la sección Your MecoPay en Documentation Docs podrá ver la documentación detallada de la API y los payloads JSON para sitios web desarrollados con Laravel, Node.js o Python.",
            "Para la integración con WordPress/WooCommerce, en la sección Plugin Apps & Plugin podrá descargar los complementos, y para la automatización de Personal MFS podrá descargar la Sync App desde el mismo lugar."
          ],
          "items": []
        }
      ]
    }
  },
  "pt": {
    "privacy": {
      "title": "Política de Privacidade",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Quais informações nós coletamos",
          "paragraphs": [],
          "items": [
            "Documentos de identidade e comprovação: número do seu documento nacional de identidade (NID), foto do NID, número da certidão de nascimento (Birth Certificate), foto da certidão de nascimento e sua foto no tamanho de passaporte.",
            "Informações de contato: número de telefone, nome e endereço de e-mail.",
            "Dados de transação: link de pagamento, fatura e status da transação."
          ]
        },
        {
          "heading": "1.2. Autenticação de dois fatores (2FA) e segurança da conta",
          "paragraphs": [
            "Não existe a opção de criar conta diretamente com e-mail e senha tradicionais no MecoPay. Você deverá acessar apenas por meio de um dispositivo protegido vinculado ao Google Account (Google Sign-in)."
          ],
          "items": [
            "Proteção de acesso e verificação em 2 etapas: após efetuar o login com Google Account na nossa plataforma, você poderá ativar a verificação em 2 etapas (TOTP). Mesmo que alguém invada sua conta do Gmail ou descubra sua senha do Gmail, não será possível acessar sua conta MecoPay sem o código de verificação de 6 dígitos do Google Authenticator.",
            "Recomendação biométrica: para manter sua conta totalmente segura, recomendamos fortemente o uso de impressão digital (Fingerprint) ou opção biométrica para a verificação em 2 etapas."
          ]
        },
        {
          "heading": "1.3. Conta única e política de bloqueio permanente",
          "paragraphs": [
            "Na nossa plataforma, apenas uma conta pode ser criada com os dados de uma pessoa. Para a verificação de identidade no perfil de login existem duas opções (menor de 18 anos ou maior de 18 anos):"
          ],
          "items": [
            "Maior de 18 anos: é obrigatório fornecer informações e fotos tanto do NID quanto da certidão de nascimento (Birth Certificate). Uma vez que o perfil seja verificado, esses documentos serão permanentemente bloqueados no sistema.",
            "Menor de 18 anos: a conta pode ser verificada apenas com as informações e foto da certidão de nascimento. Posteriormente poderá haver oportunidade de atualizar o NID, mas os dados da certidão de nascimento permanecerão permanentemente bloqueados.",
            "Aviso: se, mesmo sendo maior de 18 anos, selecionar idade incorreta para evitar o NID, a conta não será verificada e poderá ser bloqueada. Tentativas de abrir uma segunda conta com o mesmo documento serão canceladas."
          ]
        },
        {
          "heading": "1.4. Segurança em nível bancário internacional",
          "paragraphs": [
            "Não fazemos concessões na segurança dos dados dos clientes. Para proteger suas informações, o MecoPay mantém segurança em nível bancário internacional."
          ],
          "items": [
            "Segurança de frontend e edge (MecoPay Shield): através da nossa rede global de edge, o tráfego de frontend e os tráfegos de API são criptografados e protegidos contra ataques DDoS.",
            "Segurança de backend (Row Level Security - RLS): os dados da sua conta só podem ser visualizados por você.",
            "Criptografia ponta a ponta: cada conexão entre o aplicativo Android e os servidores é protegida por assinatura HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Contato",
          "paragraphs": [
            "Se tiver perguntas sobre esta política de privacidade, entre em contato pelo support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Termos e Condições",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Descrição do serviço",
          "paragraphs": [
            "MecoPay é uma plataforma SaaS de e-commerce tudo-em-um (All-in-One), uma iniciativa especial da Innovative Education & Technology (IET). É um ecossistema integrado de automação de pagamentos e e-commerce que automatiza transações entre comerciantes e clientes.",
            "O MecoPay ajuda a processar e verificar pagamentos diretamente da conta do cliente para a conta do comerciante, e não retém nem mantém valores de clientes ou comerciantes para si."
          ],
          "items": []
        },
        {
          "heading": "2.2. Auto-roteamento e limite de transação",
          "paragraphs": [],
          "items": [
            "MFS pessoal: os usuários podem usar contas pessoais de mobile banking. Poderão ser configurados no máximo 2 números pessoais; quando o limite do primeiro número for atingido, o sistema roteará o pagamento para o segundo número.",
            "Merchant API: se forem necessárias transações com volume superior ao limite das contas pessoais, deverá ser configurada a Merchant API."
          ]
        },
        {
          "heading": "2.3. Limitação de responsabilidade (Limitation of Liability)",
          "paragraphs": [
            "Se as autoridades de mobile banking aplicáveis limitarem, bloquearem ou suspenderem uma conta pessoal de MFS devido a transações adicionais ou uso de auto-roteamento, a responsabilidade será do usuário. Nesses casos, o MecoPay não terá qualquer responsabilidade legal ou financeira."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Política de Reembolso (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Reembolso de assinatura",
          "paragraphs": [
            "O MecoPay oferece aos usuários um período de teste gratuito para que possam avaliar o serviço. Por isso, normalmente as taxas não são reembolsáveis após o início de assinaturas pagas como Basic ou Pro."
          ],
          "items": []
        },
        {
          "heading": "2. Isenção de taxa para o cliente em caso de reembolso",
          "paragraphs": [
            "Se um cliente devolver um produto ou solicitar o reembolso de um pagamento adiantado, o comerciante deverá restituir integralmente o valor adiantado.",
            "Ao verificar o reembolso, a taxa de transação ou de serviço que o MecoPay cobrou não será deduzida do montante a ser restituído ao cliente; será perdoada."
          ],
          "items": []
        },
        {
          "heading": "3. Casos excepcionais (Exceptional Cases)",
          "paragraphs": [
            "Nos casos abaixo, o reembolso da taxa de assinatura do MecoPay poderá ser considerado:"
          ],
          "items": [
            "Em caso de cobrança em duplicidade devido a falha técnica do sistema.",
            "Em caso de interrupção ou downtime prolongado e inesperado.",
            "Nota: atrasos causados por queda nos servidores do provedor de mobile banking de terceiros não estão cobertos por esta condição."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Política Anti-Fraude e Direitos do Cliente",
      "alertTitle": "Política Anti-Fraude de Tolerância Zero",
      "alert": "Adotamos uma política de tolerância zero na proteção dos direitos dos clientes. Na página de checkout existe um botão 'Report'; em caso de fraude, é possível registrar uma reclamação diretamente com evidências.",
      "sections": [
        {
          "heading": "1. Processo de verificação de entrega",
          "paragraphs": [],
          "items": [
            "Produto físico: independentemente do site customizado ou no-code utilizado, é obrigatório integrar a delivery API. O backend verificará em tempo real os dados obtidos da courier API.",
            "Produto digital: em caso de reclamação, será realizada uma verificação manual com screenshots do comprador e do vendedor, dados da marca (brand data) e cruzamento dos server logs."
          ]
        },
        {
          "heading": "2. Punições por fraude e medidas legais",
          "paragraphs": [
            "Se comprovado que algum merchant ou cliente recebeu pagamento antecipado e não entregou o produto, as seguintes medidas serão tomadas:"
          ],
          "items": [
            "Advertência e resolução: após receber o relatório será comunicado com evidências; se não houver resolução, a conta será banida.",
            "Banimento permanente: se a alegação for comprovada, a conta será banida permanentemente e os documentos de identidade serão colocados em lista negra (blacklisted).",
            "Obrigação de reembolso: o comerciante/cliente deverá, por sua responsabilidade, devolver integralmente o valor.",
            "Processo judicial e medidas legais: se o valor não for devolvido ou não houver resolução, serão tomadas medidas de acordo com as leis de proteção ao consumidor e a legislação cibernética aplicáveis."
          ]
        }
      ]
    },
    "docs": {
      "title": "Documentação da API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Após fazer login e salvar os detalhes do perfil, na seção Your MecoPay, em Documentation Docs, você poderá ver a documentação detalhada da API e o JSON payload para sites desenvolvidos em Laravel, Node.js ou Python.",
            "Para integração com WordPress/WooCommerce, você poderá fazer o download dos Plugin Apps & Plugin na respectiva seção, e para automação de MFS pessoal, o Sync App também poderá ser baixado no mesmo local."
          ],
          "items": []
        }
      ]
    }
  },
  "zh": {
    "privacy": {
      "title": "隐私政策",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. 我们收集哪些信息",
          "paragraphs": [],
          "items": [
            "身份凭证与证明：您的国家身份证 (NID) 号码、NID 的照片、出生登记 (Birth Certificate) 号码、出生登记的照片以及您的护照尺寸照片。",
            "联系方式：电话号码、姓名和电子邮件地址。",
            "交易数据：支付链接、发票和交易状态。"
          ]
        },
        {
          "heading": "1.2. 双因素认证 (2FA) 与账户安全",
          "paragraphs": [
            "在 MecoPay 中不存在传统通过电子邮件和密码直接开设账户的方式。您必须通过绑定了 Google Account（Google 登录）的受保护设备进行访问。"
          ],
          "items": [
            "访问与 2 步验证安全性：在我们的平台使用 Google 登录后，您可以启用 2-Step Verification (TOTP)。即使在不利情况下某人入侵了您的 Gmail 帐户或得知您的 Gmail 密码，若无您 Google Authenticator 的 6 位验证码，其他人也无法进入您的 MecoPay 账户。",
            "生物识别建议：为充分保护您的账户，我们强烈建议在 2-Step Verification 中使用指纹 (Fingerprint) 或生物识别选项。"
          ]
        },
        {
          "heading": "1.3. 单一账户与永久锁定政策",
          "paragraphs": [
            "在我们的平台上，一个人信息只能开设一个账户。登录资料的身份验证有两种选项（18岁以下或 18岁以上）："
          ],
          "items": [
            "18岁以上：必须提供 NID 及出生登记 (Birth Certificate) 的信息和照片。一旦资料验证通过，这些文件将在系统中永久锁定。",
            "18岁以下：仅通过提供出生登记的信息和照片即可验证账户。以后可更新 NID，但出生登记信息将被永久锁定。",
            "注意：即使超过 18 岁，如果为规避 NID 而故意选择错误年龄，账户将无法验证且可能被封锁。使用相同证件尝试开设第二个账户的行为将被拒绝。"
          ]
        },
        {
          "heading": "1.4. 国际银行级安全",
          "paragraphs": [
            "我们对客户数据安全毫不妥协。为保护您的信息，MecoPay 维持国际银行级别的安全。"
          ],
          "items": [
            "前端与边缘安全 (MecoPay Shield)：通过我们的全球边缘网络，前端和 API 流量均被加密，并受到 DDoS 攻击防护。",
            "后端安全 (Row Level Security - RLS)：您的账户数据仅您可见。",
            "端到端加密：Android 应用与服务器之间的每次连接均使用 HMAC SHA-256 签名进行保护。"
          ]
        },
        {
          "heading": "1.5. 联系方式",
          "paragraphs": [
            "如对本隐私政策有疑问，请联系 support@mecopay.com。"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "条款与条件",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. 服务说明",
          "paragraphs": [
            "MecoPay 是一款 All-in-One 电商 SaaS 平台，为 Innovative Education & Technology (IET) 的一项专项举措。它是一个用于在商户和客户之间自动化交易的支付自动化与整合电商生态系统。",
            "MecoPay 协助将客户的付款直接处理并验证至商户账户，不会将任何客户或商户的资金保留或存放于自身账户。"
          ],
          "items": []
        },
        {
          "heading": "2.2. 自动路由与交易限额",
          "paragraphs": [],
          "items": [
            "个人 MFS：用户可以使用个人移动银行账户。最多可设置 2 个个人号码；当第一个号码的额度用尽时，系统将把付款路由至第二个号码。",
            "商户 API：如需处理超过个人账户限额的大额交易量，必须设置商户 API。"
          ]
        },
        {
          "heading": "2.3. 责任限制 (Limitation of Liability)",
          "paragraphs": [
            "因在个人 MFS 账户中发生额外交易或使用自动路由而导致相关移动银行机构对账户限制、封锁或暂停的责任由用户自行承担。就此类情况，MecoPay 不承担任何法律或财务责任。"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "退款政策 (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. 订阅退款",
          "paragraphs": [
            "MecoPay 为用户提供免费试用以便他们检验服务。因此，像 Basic 或 Pro 这样的付费订阅一旦开始，通常费用不可退还。"
          ],
          "items": []
        },
        {
          "heading": "2. 退款时对客户零手续费",
          "paragraphs": [
            "若客户退货或请求预付款退款，客户/商户须全额退还预付款。",
            "在核实退款时，MecoPay 所收取的交易或服务费用不会再从客户处扣除或将被豁免。"
          ],
          "items": []
        },
        {
          "heading": "3. 例外情况 (Exceptional Cases)",
          "paragraphs": [
            "在以下情况下，MecoPay 的订阅费用可被考虑退款："
          ],
          "items": [
            "因系统技术故障导致重复计费的情况。",
            "出现长时间意外中断或停机的情况。",
            "注：因第三方移动银行服务提供商自身服务器宕机造成的延迟不在此条款范围内。"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "反欺诈与客户权利政策",
      "alertTitle": "零容忍反欺诈政策",
      "alert": "我们以零容忍政策维护客户权益。结账页面有 Report 按钮；若发生欺诈，可携证据直接举报。",
      "sections": [
        {
          "heading": "1. 发货核验流程",
          "paragraphs": [],
          "items": [
            "实体产品：无论使用定制或无代码网站，都必须接入 delivery API。后端将从快递 API 获取数据并进行实时核验。",
            "数字产品：在收到投诉时，将通过买卖双方的截图、 brand data 以及 server log 进行交叉核查并人工审核。"
          ]
        },
        {
          "heading": "2. 欺诈处罚与法律措施",
          "paragraphs": [
            "如证实任何商户或客户在收取预付款后未提供产品，将采取如下措施："
          ],
          "items": [
            "警告与解决：接报后将连同证据告知；若未解决则会对账户进行封禁（account ban）。",
            "永久封禁：若投诉经证实，账户将被永久封禁并将身份证明列入黑名单（blacklisted）。",
            "退款义务：客户须自行承担并全额退还款项。",
            "诉讼与法律行动：若不退还款项或不达成解决，将依据现行消费者保护与网络法律采取措施。"
          ]
        }
      ]
    },
    "docs": {
      "title": "API 文档",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "登录并保存个人资料详情后，在 Your MecoPay 部分的 Documentation Docs 中，您可查看针对使用 Laravel、Node.js 或 Python 构建的网站的详细 API 文档与 JSON payload。",
            "关于 WordPress/WooCommerce 集成，可在 Plugin Apps & Plugin 部分下载相应插件；Personal MFS 自动化的 Sync App 也可在同一位置下载。"
          ],
          "items": []
        }
      ]
    }
  },
  "de": {
    "privacy": {
      "title": "Datenschutzerklärung",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Welche Informationen wir sammeln",
          "paragraphs": [],
          "items": [
            "Identitätsdokumente und Nachweise: Ihre nationale Identitätskartennummer (NID), ein Foto der NID, die Nummer der Geburtsurkunde (Birth Certificate), ein Foto der Geburtsurkunde sowie ein Passfoto.",
            "Kontaktinformationen: Telefonnummer, Name und E-Mail-Adresse.",
            "Transaktionsdaten: Zahlungslinks, Rechnungen und Transaktionsstatus."
          ]
        },
        {
          "heading": "1.2. Zwei-Faktor-Authentifizierung (2FA) und Kontosicherheit",
          "paragraphs": [
            "Bei MecoPay gibt es keine traditionelle Möglichkeit, ein Konto direkt mit E-Mail und Passwort zu erstellen. Sie müssen über ein gesichertes Gerät mit einem Google Account (Google Sign-In) zugreifen."
          ],
          "items": [
            "Zugriffsschutz und 2‑Step‑Verifikation: Nach dem Google Sign-In auf unserer Plattform können Sie die 2‑Step Verification (TOTP) aktivieren. Selbst wenn jemand Ihr Gmail‑Konto kompromittiert oder Ihr Gmail‑Passwort kennt, ist ein Zugriff auf Ihr MecoPay‑Konto ohne den sechsstelligen Verifizierungscode Ihres Google Authenticators nicht möglich.",
            "Biometrische Empfehlung: Um Ihr Konto bestmöglich zu schützen, empfehlen wir dringend die Nutzung von Fingerabdruck (Fingerprint) oder anderen biometrischen Optionen bei der 2‑Step Verification."
          ]
        },
        {
          "heading": "1.3. Einzelkonto- und permanente Sperrregelung",
          "paragraphs": [
            "Auf unserer Plattform kann pro Person nur ein Konto mit den persönlichen Daten eröffnet werden. Für die Identitätsverifizierung im Login‑Profil gibt es zwei Optionen (unter 18 Jahre oder über 18 Jahre):"
          ],
          "items": [
            "Über 18 Jahre: Sowohl NID als auch die Angaben und Fotos der Geburtsurkunde (Birth Certificate) sind verpflichtend. Nach erfolgreicher Profilverifizierung werden diese Dokumente im System dauerhaft gesperrt.",
            "Unter 18 Jahre: Das Konto kann mit den Angaben und dem Foto der Geburtsurkunde verifiziert werden. Ein späteres Hochladen/Update des NID ist möglich, jedoch bleibt die Geburtsurkunden‑Information dauerhaft gesperrt.",
            "Hinweis: Wenn trotz Volljährigkeit aufgrund falscher Altersangabe versucht wird, das NID zu umgehen, wird das Konto nicht verifiziert und kann gesperrt werden. Der Versuch, ein zweites Konto mit denselben Dokumenten zu eröffnen, wird abgelehnt."
          ]
        },
        {
          "heading": "1.4. Internationale Bank‑Level‑Sicherheit",
          "paragraphs": [
            "Wir machen keine Kompromisse bei der Sicherheit der Kundendaten. MecoPay wendet internationale Bank‑Level‑Sicherheitsstandards an, um Ihre Daten zu schützen."
          ],
          "items": [
            "Frontend‑ und Edge‑Sicherheit (MecoPay Shield): Über unser globales Edge‑Netzwerk werden Frontend‑ und API‑Verbindungen verschlüsselt und vor DDoS‑Angriffen geschützt.",
            "Backend‑Sicherheit (Row Level Security - RLS): Die Daten Ihres Kontos sind ausschließlich für Sie einsehbar.",
            "Ende‑zu‑Ende‑Verschlüsselung: Jede Verbindung zwischen der Android‑App und dem Server ist durch HMAC SHA-256‑Signaturen abgesichert."
          ]
        },
        {
          "heading": "1.5. Kontakt",
          "paragraphs": [
            "Bei Fragen zu dieser Datenschutzerklärung kontaktieren Sie bitte support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Allgemeine Geschäftsbedingungen",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Beschreibung des Dienstes",
          "paragraphs": [
            "MecoPay ist eine All‑in‑One E‑Commerce‑SaaS‑Plattform und eine Initiative von Innovative Education & Technology (IET). Sie ist ein Zahlungsautomatisierungs‑ und integriertes E‑Commerce‑Ökosystem zur Automatisierung von Transaktionen zwischen Händlern und Kunden.",
            "MecoPay unterstützt bei der Verarbeitung und Verifizierung von Zahlungen direkt vom Kunden zum Händlerkonto und hält oder verwahrt keine Gelder von Kunden oder Händlern."
          ],
          "items": []
        },
        {
          "heading": "2.2. Auto‑Routing und Transaktionslimits",
          "paragraphs": [],
          "items": [
            "Personal MFS: Nutzer können persönliche Mobile‑Banking‑Konten verwenden. Es können maximal zwei persönliche Nummern hinterlegt werden; wenn das Limit der ersten Nummer erreicht ist, leitet das System Zahlungen zur zweiten Nummer weiter.",
            "Merchant API: Bei Transaktionsvolumen, das die Limits persönlicher Konten übersteigt, muss die Merchant API eingerichtet werden."
          ]
        },
        {
          "heading": "2.3. Haftungsbeschränkung (Limitation of Liability)",
          "paragraphs": [
            "Wenn aufgrund zusätzlicher Transaktionen oder der Verwendung von Auto‑Routing ein persönliches MFS‑Konto von der zuständigen Mobile‑Banking‑Behörde eingeschränkt, gesperrt oder ausgesetzt wird, liegt die Verantwortung beim Nutzer. MecoPay haftet in solchen Fällen weder rechtlich noch finanziell."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Rückerstattungsrichtlinie (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Rückerstattung bei Abonnements",
          "paragraphs": [
            "MecoPay bietet Nutzern eine kostenlose Testphase an, damit sie den Dienst prüfen können. Daher sind nach Beginn eines kostenpflichtigen Abonnements wie Basic oder Pro die Gebühren in der Regel nicht erstattungsfähig."
          ],
          "items": []
        },
        {
          "heading": "2. Keine Gebühren für den Kunden im Rückerstattungsfall",
          "paragraphs": [
            "Wenn ein Kunde ein Produkt zurückgibt oder eine Rückerstattung einer Vorauszahlung verlangt, muss der Auftraggeber/Händler den vollständigen vorausgezahlten Betrag zurückerstatten.",
            "Bei der Verifizierung der Rückerstattung werden von MecoPay erhobene Transaktions‑ oder Servicegebühren dem Kunden nicht erneut in Rechnung gestellt bzw. nicht vom Rückerstattungsbetrag abgezogen."
          ],
          "items": []
        },
        {
          "heading": "3. Ausnahmefälle (Exceptional Cases)",
          "paragraphs": [
            "In den folgenden Fällen kann eine Rückerstattung der MecoPay‑Abogebühr in Betracht gezogen werden:"
          ],
          "items": [
            "Bei doppelter Abrechnung aufgrund eines technischen Systemfehlers.",
            "Bei langfristigen, unvorhergesehenen Ausfällen oder Downtimes.",
            "Hinweis: Verzögerungen aufgrund von Serverausfällen eines Drittanbieters des Mobile‑Banking sind nicht von dieser Regelung gedeckt."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Anti‑Betrugs‑ und Kundenrechte‑Richtlinie",
      "alertTitle": "Nulltoleranz‑Anti‑Betrugs‑Richtlinie",
      "alert": "Wir verfolgen eine Null‑Toleranz‑Politik zum Schutz der Kundenrechte. Auf der Checkout‑Seite gibt es einen Report‑Button; im Falle von Betrug kann direkt mit Beweismitteln eine Beschwerde eingereicht werden.",
      "sections": [
        {
          "heading": "1. Lieferverifizierungsprozess",
          "paragraphs": [],
          "items": [
            "Physische Produkte: Unabhängig davon, ob eine Custom‑ oder No‑Code‑Website verwendet wird, ist die Anbindung an die delivery API verpflichtend. Das Backend prüft in Echtzeit Daten aus der Courier‑API.",
            "Digitale Produkte: Bei einer Beschwerde werden Screenshots von Käufer und Verkäufer, Brand‑Daten und Server‑Logs manuell überprüft und abgeglichen (cross‑check)."
          ]
        },
        {
          "heading": "2. Sanktionen bei Betrug und rechtliche Maßnahmen",
          "paragraphs": [
            "Wenn sich der nachgewiesene Fall ergibt, dass ein Händler oder Client im Voraus Geld genommen und das Produkt nicht geliefert hat, werden folgende Maßnahmen ergriffen:"
          ],
          "items": [
            "Warnung und Lösung: Nach Eingang der Meldung wird mit Belegen informiert; kommt es zu keiner Einigung, wird das Konto gesperrt.",
            "Dauerhafte Sperre: Wenn der Vorwurf bestätigt wird, wird das Konto dauerhaft gesperrt und die Identitätsdokumente werden auf eine Blacklist gesetzt.",
            "Rückerstattungspflicht: Der Client/Händler ist verpflichtet, auf eigene Verantwortung den vollen Betrag zurückzuerstatten.",
            "Klagen und rechtliche Schritte: Wird das Geld nicht zurückerstattet oder keine Lösung gefunden, werden Maßnahmen nach den geltenden Verbraucher‑schutzbestimmungen und Cyber‑Gesetzen eingeleitet."
          ]
        }
      ]
    },
    "docs": {
      "title": "API‑Dokumentation",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Nach dem Einloggen und dem Speichern der Profildetails können Sie im Bereich 'Your MecoPay' unter 'Documentation Docs' die ausführliche API‑Dokumentation und JSON‑Payloads für Websites einsehen, die mit Laravel, Node.js oder Python erstellt wurden.",
            "Für die Integration mit WordPress/WooCommerce finden Sie Plugins im Bereich 'Plugin Apps & Plugin', und für die Automatisierung von Personal MFS können Sie die 'Sync App' an derselben Stelle herunterladen."
          ],
          "items": []
        }
      ]
    }
  },
  "ja": {
    "privacy": {
      "title": "プライバシーポリシー",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. 当社が収集する情報",
          "paragraphs": [],
          "items": [
            "身分証明書および証拠：あなたの国民識別番号（NID）番号、NIDの写真、出生登録（Birth Certificate）番号、出生登録の写真およびパスポートサイズの写真。",
            "連絡先情報：電話番号、氏名およびメールアドレス。",
            "取引データ：支払いリンク、請求書および取引状況。"
          ]
        },
        {
          "heading": "1.2. 二要素認証（2FA）とアカウントの保護",
          "paragraphs": [
            "MecoPayでは、従来のメールとパスワードによる直接アカウント作成の仕組みは用意していません。Google Account（グーグルサインイン）に連携されたセキュアなデバイスからのみアクセスしていただきます。"
          ],
          "items": [
            "アクセスおよび2-Step Verificationの保護：当社プラットフォームでGoogleサインインした後、2-Step Verification（TOTP）を有効にできます。不正な状況で誰かがあなたのGmailアカウントをハッキングしたりGmailのパスワードを知っていたとしても、Google Authenticatorの6桁の認証コードがなければ他人があなたのMecoPayアカウントにアクセスすることはできません。",
            "生体認証の推奨：アカウントを完全に保護するため、2-Step Verification に関しては指紋（Fingerprint）や生体認証オプションの使用を強く推奨します。"
          ]
        },
        {
          "heading": "1.3. シングルアカウントおよび永久ロックポリシー",
          "paragraphs": [
            "当社プラットフォームでは、一人の個人情報につき一つのアカウントのみ開設可能です。ログインプロファイルの身元確認には二つのオプションがあります（18歳未満または18歳以上）："
          ],
          "items": [
            "18歳以上：NIDおよび出生登録（Birth Certificate）の両方の情報および写真の提出が必須です。一度プロファイルが検証されると、これらの書類はシステム上で永久にロックされます。",
            "18歳未満：出生登録の情報および写真のみでアカウントを検証できます。後にNIDを更新する機会はありますが、出生登録の情報は永久にロックされます。",
            "注意：18歳以上でありながらNIDを回避するために誤った年齢を選択した場合、アカウントは検証されずブロックされることがあります。同一の書類で二つ目のアカウントを作成しようとする試みは取り消されます。"
          ]
        },
        {
          "heading": "1.4. 国際的な銀行レベルのセキュリティ",
          "paragraphs": [
            "当社は顧客データのセキュリティにおいて妥協しません。MecoPayは顧客データ保護のため国際的な銀行レベルのセキュリティを維持しています。"
          ],
          "items": [
            "フロントエンドおよびエッジのセキュリティ（MecoPay Shield）：当社のグローバルエッジネットワークを通じて、フロントエンドおよびAPIトラフィックは暗号化され、DDoS攻撃から保護されます。",
            "バックエンドのセキュリティ（Row Level Security - RLS）：あなたのアカウントのデータはあなただけが閲覧できます。",
            "エンドツーエンド暗号化：Androidアプリとサーバー間の各接続はHMAC SHA-256署名で保護されています。"
          ]
        },
        {
          "heading": "1.5. 連絡先",
          "paragraphs": [
            "このプライバシーポリシーに関する質問は support@mecopay.com までお問い合わせください。"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "利用規約",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. サービスの説明",
          "paragraphs": [
            "MecoPayはAll-in-OneのeコマースSaaSプラットフォームであり、Innovative Education & Technology（IET）の一事業です。これはマーチャントと顧客間の取引を自動化する、支払いの自動化と統合されたeコマースのエコシステムです。",
            "MecoPayは顧客からマーチャントのアカウントへの支払いを処理・検証するのを支援し、顧客またはマーチャントの資金を保持・預かることはありません。"
          ],
          "items": []
        },
        {
          "heading": "2.2. 自動ルーティングと取引制限",
          "paragraphs": [],
          "items": [
            "パーソナルMFS：ユーザーは個人のモバイルバンキングアカウントを使用できます。最大2つの個人番号を設定できます。最初の番号の限度額に達した場合、システムは自動的に第二の番号に支払いをルーティングします。",
            "マーチャントAPI：個人アカウントの限度を超えるボリュームの取引が必要な場合は、マーチャントAPIを設定する必要があります。"
          ]
        },
        {
          "heading": "2.3. 責任の制限（Limitation of Liability）",
          "paragraphs": [
            "個人MFSアカウントでの追加取引や自動ルーティングの使用に起因して、該当するモバイルバンキング事業者がアカウントを制限、ブロック、または停止した場合、その責任はユーザーにあります。このような理由でMecoPayは法的または財務的責任を負いません。"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "返金ポリシー (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. サブスクリプションの返金",
          "paragraphs": [
            "MecoPayはユーザーにフリートライアルを提供しており、サービスを評価できます。したがって、BasicやProなどの有料サブスクリプションが開始された後でも、通常は料金は返金可能です。"
          ],
          "items": []
        },
        {
          "heading": "2. 返金の場合のクライアントへのゼロ負担",
          "paragraphs": [
            "顧客が商品を返品したり前払いの返金を求めた場合、クライアント/マーチャントは全額を返金する義務があります。",
            "返金を検証する際に、MecoPayが徴収した取引手数料やサービス料はクライアントから差し引かれないか、免除されます。"
          ],
          "items": []
        },
        {
          "heading": "3. 例外的事例（Exceptional Cases）",
          "paragraphs": [
            "以下の場合、MecoPayのサブスクリプション料金の返金が検討されることがあります："
          ],
          "items": [
            "システムの技術的な不具合により二重請求が発生した場合。",
            "長期にわたる予期せぬ停止またはダウンタイムが発生した場合。",
            "注：第三者のモバイルバンキング提供者自身のサーバーダウンによる遅延はこの条件の対象ではありません。"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "不正防止および顧客権利ポリシー",
      "alertTitle": "ゼロトレランスの不正防止ポリシー",
      "alert": "当社は顧客の権利保護においてゼロトレランス方針を採用しています。CheckoutページにはReportボタンがあり、不正があった場合は証拠を添えて直接通報できます。",
      "sections": [
        {
          "heading": "1. 配送確認プロセス",
          "paragraphs": [],
          "items": [
            "物理的製品：カスタムまたはノーコードのウェブサイトに関わらず、delivery APIの接続が必須です。バックエンドはcourier APIからデータを取得し、リアルタイムで検証します。",
            "デジタル製品：苦情があった場合、購入者と販売者のスクリーンショット、brand dataおよびserver logを突合して手動で確認します。"
          ]
        },
        {
          "heading": "2. 詐欺の罰則と法的措置",
          "paragraphs": [
            "証明された場合、任意のマーチャントまたはクライアントが前払い金を受け取り製品を提供しなかったとき、以下の措置が取られます："
          ],
          "items": [
            "警告と解決：報告を受けた後、証拠と共に通知します。解決がなされない場合、アカウントは停止されます。",
            "永久停止：苦情が立証された場合、アカウントは永久に停止され、身分証はブラックリストに登録されます。",
            "返金義務：クライアントは自己責任で全額を返金する義務があります。",
            "訴訟および法的手続き：返金が行われない、または解決されない場合、一般的な消費者保護法およびサイバー法に従い措置が取られます。"
          ]
        }
      ]
    },
    "docs": {
      "title": "APIドキュメント",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "ログインしてプロファイル詳細を保存した後、Your MecoPayセクションのDocumentation Docsから、Laravel、Node.js、またはPythonで作成されたウェブサイト向けの詳細なAPIドキュメントとJSONペイロードを閲覧できます。",
            "WordPress/WooCommerce統合のためのPlugin Apps & Pluginセクション、およびPersonal MFS自動化のためのSync Appは同じ場所からダウンロードできます。"
          ],
          "items": []
        }
      ]
    }
  },
  "ko": {
    "privacy": {
      "title": "개인정보 처리방침",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. 우리가 수집하는 정보",
          "paragraphs": [],
          "items": [
            "신분증 및 증빙: 귀하의 국가 신분증(NID) 번호, NID 사진, 출생증명서(Birth Certificate) 번호, 출생증명서 사진 및 여권 사진(패스포트 사이즈).",
            "연락처 정보: 전화번호, 이름 및 이메일 주소.",
            "거래 데이터: 결제 링크, 인보이스 및 거래 상태."
          ]
        },
        {
          "heading": "1.2. 2단계 인증(2FA) 및 계정 보안",
          "paragraphs": [
            "MecoPay에서는 계정 보안을 위해 전통적인 이메일 및 비밀번호로 직접 계정을 생성하는 방식을 제공하지 않습니다. Google Account(구글 로그인)에 연결된 보안된 기기를 통해서만 접근해야 합니다."
          ],
          "items": [
            "접근 및 2단계 인증 보안: 당사 플랫폼에서 Google 계정으로 로그인한 후 2-Step Verification (TOTP)을 활성화할 수 있습니다. 누군가 귀하의 Gmail 계정을 해킹하거나 Gmail 비밀번호를 알게 되더라도 Google Authenticator의 6자리 인증 코드가 없으면 제3자가 귀하의 MecoPay 계정에 접근할 수 없습니다.",
            "생체인식 권장: 계정을 완전히 보호하기 위해 2-Step Verification 사용 시 지문(Fingerprint) 또는 생체인식 옵션을 사용하는 것을 강력히 권장합니다."
          ]
        },
        {
          "heading": "1.3. 단일 계정 및 영구 잠금 정책",
          "paragraphs": [
            "우리 플랫폼에서는 한 개인의 정보로 단 하나의 계정만 개설할 수 있습니다. 로그인 프로필의 신원 확인에는 두 가지 옵션이 있습니다 (18세 미만 또는 18세 이상):"
          ],
          "items": [
            "18세 이상: NID 및 출생증명서(Birth Certificate)의 정보와 사진 제출이 필수입니다. 프로필이 일단 인증되면 해당 문서들은 시스템에 영구적으로 잠깁니다.",
            "18세 미만: 출생증명서 정보 및 사진만 제출하여 계정 인증이 가능합니다. 이후 NID를 업데이트할 수 있는 기회는 있으나 출생증명서 정보는 영구적으로 잠기게 됩니다.",
            "경고: 18세 이상임에도 NID 제출을 회피하려고 잘못된 연령을 선택하면 계정이 인증되지 않으며 차단될 수 있습니다. 동일한 문서로 두 번째 계정을 개설하려는 시도는 거부됩니다."
          ]
        },
        {
          "heading": "1.4. 국제 은행 수준의 보안",
          "paragraphs": [
            "우리는 고객 정보 보호에 타협하지 않습니다. 귀하의 정보를 안전하게 유지하기 위해 MecoPay는 국제 은행 수준의 보안을 유지합니다."
          ],
          "items": [
            "프런트엔드 및 에지 보안 (MecoPay Shield): 당사의 글로벌 에지 네트워크를 통해 프런트엔드 및 API 트래픽이 암호화되며 DDoS 공격으로부터 보호됩니다.",
            "백엔드 보안 (Row Level Security - RLS): 귀하의 계정 데이터는 오직 귀하만 볼 수 있습니다.",
            "종단 간 암호화: Android 앱과 서버 간의 각 연결은 HMAC SHA-256 서명으로 보호됩니다."
          ]
        },
        {
          "heading": "1.5. 연락처",
          "paragraphs": [
            "이 개인정보 처리방침에 관해 질문이 있으면 support@mecopay.com으로 연락해 주십시오."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "이용 약관",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. 서비스 설명",
          "paragraphs": [
            "MecoPay는 올인원(All-in-One) 이커머스 SaaS 플랫폼으로, Innovative Education & Technology (IET)의 특별 프로젝트입니다. 이는 판매자(merchant)와 고객 간의 거래를 자동화하는 결제 자동화 및 통합 이커머스 생태계입니다.",
            "MecoPay는 고객으로부터 판매자의 계정으로 직접 결제를 처리하고 검증하도록 지원하며, 어떠한 고객이나 판매자의 자금을 자사에 보유하거나 예치하지 않습니다."
          ],
          "items": []
        },
        {
          "heading": "2.2. 자동 라우팅 및 거래 한도",
          "paragraphs": [],
          "items": [
            "개인용 MFS: 사용자는 개인 모바일 뱅킹 계정을 사용할 수 있습니다. 최대 2개의 개인 번호를 설정할 수 있으며, 첫 번째 번호의 한도가 초과되면 시스템이 두 번째 번호로 결제를 라우팅합니다.",
            "머천트 API: 개인 계정 한도를 초과하는 거래량이 필요한 경우 판매자(merchant)용 API를 설정해야 합니다."
          ]
        },
        {
          "heading": "2.3. 책임의 제한 (Limitation of Liability)",
          "paragraphs": [
            "개인 MFS 계정에서 과도한 거래나 자동 라우팅 사용으로 인해 해당 모바일 뱅킹 기관이 계정을 제한, 차단 또는 정지하는 경우 그 책임은 사용자에게 있습니다. 이러한 사유로 인해 MecoPay는 법적 또는 재정적으로 책임지지 않습니다."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "환불 정책 (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. 구독 환불",
          "paragraphs": [
            "MecoPay는 사용자가 서비스를 평가할 수 있도록 무료 체험을 제공합니다. 따라서 Basic 또는 Pro와 같은 유료 구독이 시작된 이후에는 일반적으로 요금이 환불되지 않습니다."
          ],
          "items": []
        },
        {
          "heading": "2. 환불 시 클라이언트에 대한 수수료 없음",
          "paragraphs": [
            "고객이 제품을 반품하거나 선불 환불을 요청하는 경우 클라이언트/판매자는 전액을 환불해야 합니다.",
            "환불을 확인할 때 MecoPay가 부과한 거래 또는 서비스 수수료는 클라이언트에게 추가로 차감되거나 부과되지 않습니다; 즉 면제됩니다."
          ],
          "items": []
        },
        {
          "heading": "3. 예외적 사례 (Exceptional Cases)",
          "paragraphs": [
            "다음의 경우 MecoPay 구독 요금의 환불이 고려될 수 있습니다:"
          ],
          "items": [
            "시스템의 기술적 결함으로 이중 청구가 발생한 경우.",
            "장기간의 예기치 않은 장애 또는 다운타임이 있는 경우.",
            "참고: 제3자 모바일 뱅킹 제공업체의 자체 서버 다운으로 인한 지연은 이 조건의 적용 대상이 아닙니다."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "부정행위 방지 및 고객 권리 정책",
      "alertTitle": "무관용 안티-사기 정책",
      "alert": "우리는 고객 권리 보호를 위해 무관용 원칙을 준수합니다. Checkout 페이지에 Report 버튼이 있으며, 사기가 발생하면 증거와 함께 직접 신고할 수 있습니다.",
      "sections": [
        {
          "heading": "1. 배송 확인 절차",
          "paragraphs": [],
          "items": [
            "실물 상품: 커스텀 또는 노코드 웹사이트를 사용하든 상관없이 delivery API 연결이 필수입니다. 백엔드가 courier API로부터 데이터를 받아 실시간으로 확인합니다.",
            "디지털 상품: 불만이 제기되면 구매자와 판매자의 스크린샷, 브랜드 데이터 및 서버 로그를 교차 확인하여 수동으로 검증합니다."
          ]
        },
        {
          "heading": "2. 사기 처벌 및 법적 조치",
          "paragraphs": [
            "입증될 경우 선불금을 받고 상품을 제공하지 않은 어떠한 판매자(merchant)나 클라이언트에 대해서도 다음 조치가 취해집니다:"
          ],
          "items": [
            "경고 및 해결: 신고 접수 후 증거와 함께 통지되며, 해결되지 않을 경우 계정이 정지됩니다.",
            "영구 정지: 불만이 입증되면 계정은 영구 정지되며 신분증은 블랙리스트에 등록됩니다.",
            "환불 의무: 클라이언트는 책임을 지고 전액을 환불해야 합니다.",
            "소송 및 법적 조치: 환불을 하지 않거나 해결하지 않을 경우 해당 소비자 보호법 및 사이버 법률에 따라 조치가 취해집니다."
          ]
        }
      ]
    },
    "docs": {
      "title": "API 문서",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "로그인하여 프로필 정보를 저장한 후 Your MecoPay 섹션의 Documentation Docs에서 Laravel, Node.js 또는 Python으로 만든 웹사이트용 상세 API 문서와 JSON 페이로드를 볼 수 있습니다.",
            "WordPress/WooCommerce 통합을 위한 Plugin Apps & Plugin 섹션과 개인 MFS 자동화를 위한 Sync App을 동일한 위치에서 다운로드할 수 있습니다."
          ],
          "items": []
        }
      ]
    }
  },
  "ru": {
    "privacy": {
      "title": "Политика конфиденциальности",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Какие данные мы собираем",
          "paragraphs": [],
          "items": [
            "Документы и подтверждения: номер вашего национального удостоверения (NID), фото NID, номер свидетельства о рождении (Birth Certificate), фото свидетельства о рождении и ваше фото паспортного размера.",
            "Контактная информация: номер телефона, имя и email-адрес.",
            "Данные транзакций: платежные ссылки, счета и статус транзакций."
          ]
        },
        {
          "heading": "1.2. Двухфакторная аутентификация (2FA) и безопасность аккаунта",
          "paragraphs": [
            "Для защиты аккаунтов в MecoPay не предусмотрена традиционная регистрация с email и паролем. Доступ осуществляется только через защищенное устройство, связанное с Google Account (вход через Google Sign-in)."
          ],
          "items": [
            "Защита доступа и 2-Step verification: после входа через Google Sign-in вы сможете включить 2-Step Verification (TOTP). Даже если кто‑то взломает ваш аккаунт Gmail или узнает ваш пароль Gmail, без шестизначного проверочного кода Google Authenticator доступ к вашему аккаунту MecoPay будет невозможен.",
            "Рекомендации по биометрии: для полной защиты аккаунта мы настоятельно рекомендуем использовать отпечаток пальца (Fingerprint) или биометрические опции в 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Один аккаунт на пользователя и политика постоянной блокировки",
          "paragraphs": [
            "На нашей платформе по данным одного человека может быть зарегистрирован только один аккаунт. Для проверки личности в профиле входа предусмотрены два варианта (младше 18 лет или старше 18):"
          ],
          "items": [
            "Старше 18 лет: обязательная подача данных и фото NID и свидетельства о рождении (Birth Certificate). После верификации профиля эти документы будут навсегда заблокированы в системе.",
            "Младше 18 лет: верификация возможна только по данным и фото свидетельства о рождении. Позже будет возможность обновить NID, однако данные свидетельства о рождении будут навсегда заблокированы.",
            "Внимание: если при достижении 18 лет пользователь укажет неверный возраст, чтобы избежать NID, аккаунт не будет верифицирован и может быть заблокирован. Попытки открыть второй аккаунт с теми же документами будут аннулированы."
          ]
        },
        {
          "heading": "1.4. Международный банковский уровень безопасности",
          "paragraphs": [
            "Мы не идем на компромиссы в защите данных клиентов. MecoPay поддерживает международный банковский уровень безопасности для защиты вашей информации."
          ],
          "items": [
            "Защита фронтенда и периферии (MecoPay Shield): через нашу глобальную edge‑сеть фронтенд и API‑трафик шифруются и защищены от DDoS‑атак.",
            "Защита бэкенда (Row Level Security - RLS): данные вашего аккаунта будет видеть только вы.",
            "Сквозное шифрование: каждое соединение между Android‑приложением и сервером защищено подписью HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Контакты",
          "paragraphs": [
            "По вопросам данной политики конфиденциальности обращайтесь на support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Условия и положения",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Описание сервиса",
          "paragraphs": [
            "MecoPay — это универсальная (All-in-One) e‑commerce SaaS‑платформа, являющаяся специальной инициативой Innovative Education & Technology (IET). Она представляет собой экосистему автоматизации платежей и интегрированного e‑commerce, позволяющую автоматизировать транзакции между продавцами и покупателями.",
            "MecoPay помогает обрабатывать и верифицировать платежи напрямую с клиента на счет продавца и не удерживает и не хранит денежные средства ни клиента, ни продавца."
          ],
          "items": []
        },
        {
          "heading": "2.2. Автоматическая маршрутизация и лимиты транзакций",
          "paragraphs": [],
          "items": [
            "Персональные MFS: пользователи могут использовать личные мобильные банковские аккаунты. Можно установить до 2 персональных номеров; когда лимит по первому номеру исчерпан, система будет направлять платежи на второй номер.",
            "Merchant API: если необходим объем транзакций, превышающий лимиты персональных аккаунтов, необходимо настроить Merchant API."
          ]
        },
        {
          "heading": "2.3. Ограничение ответственности (Limitation of Liability)",
          "paragraphs": [
            "Если в результате дополнительных транзакций на персональный MFS‑аккаунт или использования авто‑маршрутизации соответствующий мобильный банковский оператор ограничит, заблокирует или приостановит аккаунт, ответственность несет пользователь. В таких случаях MecoPay не несет юридической или финансовой ответственности."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Политика возврата средств (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Возврат по подписке",
          "paragraphs": [
            "MecoPay предоставляет пользователям бесплатную пробную версию для проверки сервиса. Поэтому после начала платной подписки, например Basic или Pro, плата, как правило, не подлежит возврату."
          ],
          "items": []
        },
        {
          "heading": "2. Нулевая комиссия для клиента в случае возврата",
          "paragraphs": [
            "Если покупатель возвращает товар или запрашивает возврат авансового платежа, клиент/продавец обязан полностью вернуть аванс.",
            "При верификации возврата комиссии за транзакции или обслуживание, которые MecoPay ранее удержал, не будут дополнительно взиматься с клиента или будут аннулированы."
          ],
          "items": []
        },
        {
          "heading": "3. Исключительные случаи (Exceptional Cases)",
          "paragraphs": [
            "В следующих случаях может рассматриваться возврат подписной платы MecoPay:"
          ],
          "items": [
            "в случае двойного выставления счета из‑за технической ошибки системы.",
            "при длительных непредвиденных сбоях или простоях.",
            "Примечание: задержки, вызванные падением серверов стороннего провайдера мобильного банкинга, на это условие не распространяются."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Политика против мошенничества и права клиентов",
      "alertTitle": "Политика нулевой терпимости к мошенничеству",
      "alert": "Мы придерживаемся политики нулевой терпимости для защиты прав клиентов. На странице оформления заказа (Checkout) имеется кнопка Report; в случае мошенничества можно напрямую подать жалобу с доказательствами.",
      "sections": [
        {
          "heading": "1. Процедура проверки доставки",
          "paragraphs": [],
          "items": [
            "Физические товары: независимо от того, используется ли кастомный или no-code вебсайт, обязательна интеграция delivery API. Бэкенд будет в реальном времени проверять данные от courier API.",
            "Цифровые товары: при жалобе будут вручную проверяться скриншоты покупателя и продавца, данные бренда (brand data) и сопоставляться серверные логи."
          ]
        },
        {
          "heading": "2. Санкции за мошенничество и правовые меры",
          "paragraphs": [
            "В случае доказанного факта, что любой merchant или client получил аванс и не предоставил товар, будут приняты следующие меры:"
          ],
          "items": [
            "Предупреждение и урегулирование: после получения жалобы с доказательствами будет направлено уведомление; при отсутствии решения аккаунт будет заблокирован (ban).",
            "Постоянный бан: если жалоба подтверждена, аккаунт будет навсегда заблокирован, а удостоверение личности — занесено в черный список (blacklisted).",
            "Обязательство по возврату: client обязан самостоятельно вернуть полную сумму.",
            "Иски и правовые действия: в случае отказа вернуть деньги или отсутствия урегулирования будут предприняты меры в соответствии с действующим законодательством о защите прав потребителей и киберзаконодательством."
          ]
        }
      ]
    },
    "docs": {
      "title": "Документация API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Войдя в систему и сохранив данные профиля, в разделе Your MecoPay в Documentation Docs вы сможете просмотреть подробную документацию API и JSON‑пейлоуды для сайтов, разработанных на Laravel, Node.js или Python.",
            "Для интеграции с WordPress/WooCommerce в разделе Plugin Apps & Plugin доступны соответствующие плагины, а для автоматизации Personal MFS можно скачать Sync App в том же месте."
          ],
          "items": []
        }
      ]
    }
  },
  "tr": {
    "privacy": {
      "title": "Gizlilik Politikası",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Hangi bilgileri topluyoruz",
          "paragraphs": [],
          "items": [
            "Kimlik ve kanıt: ulusal kimlik kartı (NID) numaranız, NID'in fotoğrafı, doğum kayıt belgesi (Birth Certificate) numarası, doğum kayıt belgesinin fotoğrafı ve pasaport boyutunda fotoğrafınız.",
            "İletişim bilgileri: telefon numarası, isim ve e-posta adresi.",
            "İşlem verileri: ödeme bağlantısı, fatura ve işlem durumu."
          ]
        },
        {
          "heading": "1.2. İki Faktörlü Doğrulama (2FA) ve Hesap Güvenliği",
          "paragraphs": [
            "MecoPay'de hesap güvenliği için geleneksel e-posta ve parola ile doğrudan hesap açma imkanı bulunmamaktadır. Erişim yalnızca Google Account (Google sign-in) ile ilişkilendirilmiş güvenli bir cihaz üzerinden sağlanmalıdır."
          ],
          "items": [
            "Erişim ve 2-Adımlı doğrulama güvenliği: Platformumuza Google sign-in ile giriş yaptıktan sonra 2-Step Verification (TOTP) etkinleştirebilirsiniz. Beklenmeyen bir durumda biri Gmail hesabınızı ele geçirirse veya Gmail parolanızı bilse bile Google Authenticator'ın 6 haneli doğrulama kodu olmadan MecoPay hesabınıza başkası erişemeyecektir.",
            "Biyometrik öneri: Hesabınızı tamamen korumak için 2-Step Verification sırasında parmak izi (Fingerprint) veya biyometrik seçeneklerin kullanılmasını şiddetle tavsiye ediyoruz."
          ]
        },
        {
          "heading": "1.3. Tek Hesap ve Kalıcı Kilit Politikası",
          "paragraphs": [
            "Platformumuzda bir kişinin bilgileriyle yalnızca tek bir hesap açılabilir. Giriş profilinde kimlik doğrulaması için iki seçenek bulunmaktadır (18 yaş altı veya 18 yaş üstü):"
          ],
          "items": [
            "18 yaş üstü: NID ve doğum kayıt belgesinin (Birth Certificate) hem bilgileri hem fotoğrafları zorunludur. Profil bir kez doğrulandığında bu belgeler sistemde kalıcı olarak kilitlenecektir.",
            "18 yaş altı: Sadece doğum kayıt belgesinin bilgileri ve fotoğrafı ile hesap doğrulanabilir. Daha sonra NID güncelleme imkanı olacak, ancak doğum kayıt bilgisi kalıcı olarak kilitli kalacaktır.",
            "Uyarı: 18 yaş üstü olmanıza rağmen NID'den kaçınmak amacıyla yanlış yaş seçerseniz hesap doğrulanmayacak ve engellenebilir. Aynı belge ile ikinci bir hesap açma girişimi reddedilecektir."
          ]
        },
        {
          "heading": "1.4. Uluslararası Banka Seviyesinde Güvenlik",
          "paragraphs": [
            "Müşteri verilerinin güvenliğinde ödün vermeyiz. Bilgilerinizi korumak için MecoPay uluslararası banka seviyesinde güvenlik sağlar."
          ],
          "items": [
            "Ön yüz ve uç güvenlik (MecoPay Shield): Küresel edge ağımız aracılığıyla ön yüz ve API trafiği şifrelenir ve DDoS saldırılarına karşı korunur.",
            "Arka uç güvenliği (Row Level Security - RLS): Hesabınızdaki veriyi yalnızca siz görebilirsiniz.",
            "Uçtan uca şifreleme: Android uygulaması ile sunucu arasındaki her bağlantı HMAC SHA-256 imzasıyla korunur."
          ]
        },
        {
          "heading": "1.5. İletişim",
          "paragraphs": [
            "Bu gizlilik politikasıyla ilgili sorularınız için support@mecopay.com adresiyle iletişime geçiniz."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Hüküm ve Koşullar",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Hizmet Tanımı",
          "paragraphs": [
            "MecoPay, Innovative Education & Technology (IET) tarafından yürütülen özel bir girişim olan All-in-One e-ticaret SaaS platformudur. Bu, satıcılar ve müşteriler arasındaki işlemleri otomatikleştiren bir ödeme otomasyonu ve entegre e-ticaret ekosistemidir.",
            "MecoPay, müşteriden satıcının hesabına doğrudan ödeme işleme ve doğrulamada yardımcı olur; herhangi bir müşteri veya satıcının parasını elinde tutmaz veya depolamaz."
          ],
          "items": []
        },
        {
          "heading": "2.2. Otomatik Yönlendirme ve İşlem Limitleri",
          "paragraphs": [],
          "items": [
            "Kişisel MFS: Kullanıcılar kişisel mobil bankacılık hesabı kullanabilir. En fazla 2 kişisel numara ayarlanabilir; ilk numaranın limiti dolduğunda sistem ödemeyi ikinci numaraya yönlendirecektir.",
            "Satıcı API: Kişisel hesabın limitlerini aşan hacimli işlemler gerekiyorsa satıcı API kurulmalıdır."
          ]
        },
        {
          "heading": "2.3. Sorumluluğun Sınırlandırılması (Limitation of Liability)",
          "paragraphs": [
            "Kişisel MFS hesabında aşırı işlem veya otomatik yönlendirme kullanımı nedeniyle ilgili mobil bankacılık otoritesi hesabı sınırlarsa, engellerse veya askıya alırsa sorumluluk kullanıcıya aittir. Bu tür durumlar nedeniyle MecoPay hukuki veya mali olarak sorumlu tutulamaz."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "İade Politikası (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Abonelik İadesi",
          "paragraphs": [
            "MecoPay, kullanıcılarına servisi değerlendirebilmeleri için ücretsiz deneme süresi sağlar. Bu nedenle Basic veya Pro gibi ücretli abonelikler başlatıldıktan sonra ücretler genel olarak iade edilmez."
          ],
          "items": []
        },
        {
          "heading": "2. İade Durumunda Müşteri İçin Sıfır Kesinti",
          "paragraphs": [
            "Müşteri bir ürünü iade ederse veya ön ödeme iadesi talep ederse müşteri/satıcı tüm peşin ödemeyi tam olarak geri ödemekle yükümlüdür.",
            "İade doğrulaması sırasında MecoPay tarafından alınan işlem veya servis ücreti müşteriden artık kesilmeyecek veya muaf tutulacaktır."
          ],
          "items": []
        },
        {
          "heading": "3. İstisnai Durumlar (Exceptional Cases)",
          "paragraphs": [
            "Aşağıdaki durumlarda MecoPay abonelik ücretinin iadesi değerlendirilebilir:"
          ],
          "items": [
            "Sistemin teknik hatası nedeniyle çift faturalandırma olması halinde.",
            "Uzun süreli beklenmeyen kesinti veya downtime olması halinde.",
            "Not: Üçüncü taraf mobil bankacılık sağlayıcısının kendi sunucu arızasından kaynaklanan gecikmeler bu şartın kapsamı dışında tutulur."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Sahtekarlıkla Mücadele ve Müşteri Hakları Politikası",
      "alertTitle": "Sıfır Tolerans Anti-Fraud Politikası",
      "alert": "Müşteri haklarını korumak için sıfır tolerans uyguluyoruz. Checkout page üzerinde Report butonu mevcuttur; dolandırıcılık durumunda kanıtlarla doğrudan şikayet bildirebilirsiniz.",
      "sections": [
        {
          "heading": "1. Teslimat Doğrulama Süreci",
          "paragraphs": [],
          "items": [
            "Fiziksel ürünler: Hangi özel veya no-code web sitesi kullanılırsa kullanılsın, delivery API entegrasyonu zorunludur. Arka uç, courier API'den alınan verilerle gerçek zamanlı doğrulama yapacaktır.",
            "Dijital ürünler: Şikayet halinde alıcı ve satıcının ekran görüntüleri, brand data ve sunucu logları çapraz kontrol edilerek manuel doğrulama yapılacaktır."
          ]
        },
        {
          "heading": "2. Dolandırıcılık Cezaları ve Hukuki İşlemler",
          "paragraphs": [
            "Kanıtlanması halinde herhangi bir merchant veya client peşinat alıp ürünü teslim etmediyse aşağıdaki adımlar uygulanacaktır:"
          ],
          "items": [
            "Uyarı ve çözüm: Rapor alındıktan sonra kanıtlarla bildirim yapılacak; çözüm sağlanmazsa hesap banlanacaktır.",
            "Permanent Ban: Şikayet kanıtlanırsa hesap kalıcı olarak banlanacak ve kimlik belgeleri kara listeye alınacaktır.",
            "İade Yükümlülüğü: Client kendi sorumluluğunda tam tutarı geri ödeyecektir.",
            "Dava ve hukuki işlemler: Para iadesi yapılmaz veya çözüm sağlanmazsa yürürlükteki consumer protection ve cyber law hükümleri doğrultusunda yasal işlem başlatılacaktır."
          ]
        }
      ]
    },
    "docs": {
      "title": "API Dokümantasyonu",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Profil bilgilerini kaydettikten sonra Your MecoPay bölümünden Documentation Docs'ta Laravel, Node.js veya Python ile hazırlanmış web siteleri için detaylı API dokümantasyonu ve JSON payload'larını görüntüleyebilirsiniz.",
            "WordPress/WooCommerce entegrasyonu için Plugin Apps & Plugin bölümünden ve Personal MFS otomasyonu için Sync App'i aynı yerden indirilebilir şekilde bulabilirsiniz."
          ],
          "items": []
        }
      ]
    }
  },
  "ta": {
    "privacy": {
      "title": "தனியுரிமைக் கொள்கை",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. எவ்வித தகவல்களை நாம் சேகரிக்கிறோம்",
          "paragraphs": [],
          "items": [
            "அடையாள மற்றும் சான்று: உங்கள் NID எண், NID-இன் படம், பிறப்பு பதிவு (Birth Certificate) எண், பிறப்பு பதிவு படம் மற்றும் உங்கள் பாஸ்போர்ட் அளவிலான படம்.",
            "தொடர்பு தகவல்: தொலைபேசி எண், பெயர் மற்றும் மின்னஞ்சல் முகவரி.",
            "பரிவர்த்தனை தரவுகள்: payment link, invoice மற்றும் பரிவர்த்தனை நிலை."
          ]
        },
        {
          "heading": "1.2. இரண்டு-காரண அடையாளச் சான்றிதழ் (2FA) மற்றும் கணக்கு பாதுகாப்பு",
          "paragraphs": [
            "MecoPay-இல் கணக்கு பாதுகாப்பு காரணமாக பாரம்பரிய மின்னஞ்சல் மற்றும் கடவுச்சொல் மூலம் நேரடியாக கணக்கு திறக்கும் வசதி இல்லை. நீங்கள் Google Account (Google Sign-in) இணைக்கப்பட்ட பாதுகாப்பான சாதனத்தின் மூலம் மட்டுமே அணுகலால் கணக்கை அணுக வேண்டும்."
          ],
          "items": [
            "அணுகல் மற்றும் 2-Step Verification பாதுகாப்பு: எங்கள் தளத்தில் Google Sign-in செய்த பிறகு நீங்கள் 2-Step Verification (TOTP) ஐ இயக்கு முடியும். யாரையாவது உங்கள் Gmail கணக்கை ஹேக் செய்தாலும் அல்லது உங்கள் Gmail கடவுச்சொல்லை அறிந்திருந்தாலும் கூட, Google Authenticator-ன் 6 இலக்க சோதனை குறியீட்டை விட்டு வேறு யாரும் உங்கள் MecoPay கணக்கில் நுழைய முடியாது.",
            "உயிரியல் பரிந்துரை: உங்கள் கணக்கை முழுமையாக பாதுகாக்க আমরা 2-Step Verification இற்கு விரல் அச்சு (Fingerprint) அல்லது உயிரியல் (biometric) விருப்பத்தை பயன்படுத்த மிகவும் பரிந்துரைக்கின்றோம்."
          ]
        },
        {
          "heading": "1.3. ஒரே கணக்கு மற்றும் நிரந்தர பூட்டு கொள்கை",
          "paragraphs": [
            "எங்கள் தளத்தில் ஒரே ஒரு நபரின் தகவலால் மட்டுமே ஒரு கணக்கைத் திறக்க முடியும். உள்நுழைவு پروஃபைலில் அடையாளச் சரிபார்ப்பு இரண்டு விருப்பங்களுடன் இருக்கும் (18 வயதுக்கு கீழ் அல்லது 18 வயதில் மேல்):"
          ],
          "items": [
            "18 வயதுக்கு மேல்: NID மற்றும் பிறப்பு பதிவு (Birth Certificate) இரண்டின் தகவல்களும் படங்களும் வழங்கப்படுவது கட்டாயம். ஒரு முறை پروஃபைல் சரிபார்க்கப்பட்டவுடன், இந்த ஆவணங்கள் சிஸ்டத்தில் நிரந்தரமாக பூட்டப்படும்.",
            "18 வயதுக்கு கீழ்: միայն பிறப்பு பதிவு தகவல் மற்றும் படம் கொடுத்து கணக்கை சரிபார்க்க முடியும். பின்னர் NID புதுப்பிக்க வாய்ப்பு இருக்கும், இருப்பினுமேற்பிறப்பு பதிவு தகவல் நிரந்தரமாக பூட்டப்பட்டிருக்கும்.",
            "எச்சரிக்கை: வயது 18-ஐ மீறிய போதிலும் NID-ஐ தவறாகத் தவிர்க்க வயது தவறாக தேர்ந்தெடுக்கப்பட்டால் கணக்கு சரிபார்க்கப்படாது மற்றும் தடை செய்யப்படலாம். அதே ஆவணத்துடன் இரண்டாவது கணக்கைத் திறப்பதை முயற்சிப்பது நிராகரிக்கப்படும்."
          ]
        },
        {
          "heading": "1.4. சர்வதேச வங்கி மட்டத்திலான பாதுகாப்பு",
          "paragraphs": [
            "எங்களின் பயனாளர்களின் தகவல் பாதுகாப்பில் எதுவும் தள்ளுபடி செய்யப்படுவதில்லை. உங்கள் தகவலை பாதுகாப்பாகக் காக்க MecoPay சர்வதேச வங்கி மட்டத்திலான பாதுகாப்பை பராமரிக்கிறது."
          ],
          "items": [
            "Frontend மற்றும் edge பாதுகாப்பு (MecoPay Shield): எங்கள் உலகளாவிய edge நெட்வொர்க்கின் மூலம் frontend மற்றும் API போக்குவரத்து குறியாக்கம் செய்யப்பட்டு DDoS அதிர்ச்சிகளிலிருந்து பாதுகாக்கப்படுகிறது.",
            "Backend பாதுகாப்பு (Row Level Security - RLS): உங்கள் கணக்கின் தரவை நீங்கள் மட்டுமே பார்க்கலாம்.",
            "End-to-end குறியாக்கம்: Android ஆப் மற்றும் சர்வருக்கிடையிலான ஒவ்வொரு இணைப்பும் HMAC SHA-256 கையொப்பத்தால் பாதுகாக்கப்படுகிறது."
          ]
        },
        {
          "heading": "1.5. தொடர்பு",
          "paragraphs": [
            "இந்த தனியுரிமைக் கொள்கை பற்றி கேள்விகள் இருந்தால் support@mecopay.com-இல் தொடர்பு கொள்ளவும்."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "விதிமுறைகள் மற்றும் நிபந்தனைகள்",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. சேவை விவரம்",
          "paragraphs": [
            "MecoPay ஒரு All-in-One e-commerce SaaS தளம் ஆகும், இது Innovative Education & Technology (IET)-இன் ஒரு தனி முயற்சி. இது வணிகர் மற்றும் வாடிக்கையாளர் இடையிலான பரிவர்த்தனைகளை தானியங்கி செய்வதற்கான ஒரு payment automation மற்றும் ஒருங்கிணைந்த e-commerce சூழ்நிலை வழங்குகிறது.",
            "MecoPay நேரடியாக வாடிக்கையாளர் முதல் வணிகரின் கணக்கிற்கு பணத்தை செயலாக்கி சரிபார்க்க உதவுகிறது மற்றும் எந்தவொரு வாடிக்கையாளர் அல்லது வணிகரின் பணத்தையும் தங்களை அருகில்தேவையில் பிடித்து வைக்காது அல்லது சேமிக்காது."
          ],
          "items": []
        },
        {
          "heading": "2.2. தானாக வழிமாற்றுதல் மற்றும் பரிவர்த்தனை வரம்பு",
          "paragraphs": [],
          "items": [
            "Personal MFS: பயனர்கள் தனிப்பட்ட மொபைல் பாங்கிங் கணக்குகளை பயன்படுத்த முடியும். அதிகபட்சம் 2 தனிப்பட்ட எண்ணைக் கொடுக்க முடியும்; முதலில் சேர்ந்துள்ள எண் வரம்பு முடிந்ததும் சிஸ்டம் இரண்டாவது எண்ணிடம் பணத்தை வழிமாற்றம் செய்யும்.",
            "Merchant API: தனிப்பட்ட கணக்குகளின் வரம்பைத் தாண்டும் அளவிலான பரிவர்த்தனைகளுக்கு Merchant API அமைக்கப்பட வேண்டும்."
          ]
        },
        {
          "heading": "2.3. பொறுப்பின் வரம்பு (Limitation of Liability)",
          "paragraphs": [
            "Personal MFS கணக்கில் கூடுதல் பரிவர்த்தனை அல்லது தானாக வழிமாற்றுதலினால் தொடர்புடைய மொபைல் பாங்கிங் அதிகாரிகள் கணக்கை வரம்பு, தடை அல்லது சஸ்பெண்ட் செய்தால், அதன் பொறுப்பு பயனரின் மீது உள்ளதாக இருக்கும். இதுபோன்ற காரணங்களால் MecoPay எந்தவொரு சட்டப்பூர்வ அல்லது நிதி பொறுப்பையும் ஏற்காது."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "ரீபண்ட் கொள்கை (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. சந்தா ரீபண்ட்",
          "paragraphs": [
            "MecoPay பயனாளர்களுக்கு சேவையை சோதிப்பதற்கான free trial வசதியை வழங்குகிறது. ஆகவே Basic அல்லது Pro போன்ற paid subscription தொடங்கின பிறகு வழக்கமாக கட்டணம் திரும்பபெறமுடியாது."
          ],
          "items": []
        },
        {
          "heading": "2. ரீபண்ட் நேரத்தில் கிளையன்ட்-க்கு ஜீரோ கட்டணம்",
          "paragraphs": [
            "வாடிக்கையாளர் எந்தப் பொருளைத் திருப்பினால் அல்லது முன் செலுத்திய பணத்தைத் திரும்பக்கொள்ள வேண்டுமெனக் கேட்டால் கிளையன்ட்/வணிகருக்கு முழு முன் கட்டணம் திரும்பவிருப்பாக வழங்கப்பட வேண்டும்.",
            "ரீபண்ட் சரிபார்க்கப்பட்டபோது MecoPay வசூலித்த பரிவர்த்தனை அல்லது சேவை கட்டணம் கிளையன்டின் பிடிக்கையிலிருந்து மீண்டும் கழிக்கப்படாது அல்லது மன்னிக்கப்படும்."
          ],
          "items": []
        },
        {
          "heading": "3. குறிப்பிட்ட விலக்குகள் (Exceptional Cases)",
          "paragraphs": [
            "பின்வரும் நிலையில் MecoPay-இன் subscription கட்டணத்தை ரீபண்ட் பணமாக எடுத்துக்கொள்ள பரிசீலிக்கப்படலாம்:"
          ],
          "items": [
            "சிஸ்டத்தில் தொழில்நுட்ப பிழை காரணமாக இரட்டை பில்லிங் நடந்தால்.",
            "நீண்டகாலத்துக்கு எதிர்பொராத அவுடேஜ் அல்லது டவுன்டைம் இருந்தால்.",
            "குறிப்பு: மூன்றாம் தரப்பு மொபைல் பாங்கிங் வழங்குநரின் சொந்த சர்வர் டவுன் காரணமாக ஏற்பட்ட தாமதம் இந்த நிபந்தனியின் கீழ் வராது."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "மோசடி எதிர்ப்பு மற்றும் வாடிக்கையாளர் உரிமைகள் கொள்கை",
      "alertTitle": "பொறுமையின்மை கொண்ட மோசடி எதிர்ப்பு கொள்கை",
      "alert": "எங்கள் நோக்கம் வாடிக்கையாளர் உரிமைகளை பாதுகாப்பதில் பொறுமையற்ற கொள்கையை பின்பற்றுவதாகும். Checkout பக்கத்தில் Report பொத்தான் உள்ளது; மோசடி ஏற்பட்டால் ஆதாரங்களுடன் நேரடியாக புகார் சொல்லலாம்.",
      "sections": [
        {
          "heading": "1. சரக்கு வழங்கல் சரிபார்ப்பு செயல்முறை",
          "paragraphs": [],
          "items": [
            "ஊடக பொருள்: எந்த custom அல்லது no-code வலைதளம் பயன்படுத்தினாலும் delivery API இணைத்தல் கட்டாயம். Backend courier API-இல் இருந்து தரவை கொண்டு real-time ஆக சரிபார்க்கப்படும்.",
            "டிஜிடல் பொருள்: புகார் வந்தால் வாங்குபவர் மற்றும் விற்பனையாளரின் ஸ்கிரீன்ஷாட்கள், brand data மற்றும் server log-ஐ cross-check செய்து கைமுறையாக சரிபார்ப்பு செய்யப்படும்."
          ]
        },
        {
          "heading": "2. மோசடி மீது தண்டனை மற்றும் சட்ட நடவடிக்கை",
          "paragraphs": [
            "ஆதாரமுடையதாக இருந்தால் எந்தவொரு merchant அல்லது client முன் பணம் பெற்றுவிட்டு பொருட்களை அளிக்காமலிருந்தால் கீழ்க்காணும் நடவடிக்கைகள் எடுக்கப்படும்:"
          ],
          "items": [
            "Warning மற்றும் தீர்வு: புகார் வந்ததும் ஆதாரங்களுடன் தெரிவிக்கபடும்; தீர்வு கிடைக்காவிட்டால் account ban செய்யப்படும்.",
            "நிரந்தரத் தடை: புகார் ஆதரிக்கபட்டு இருந்தால் account நிரந்தரமாக ban செய்யப்பட்டு அடையாள ஆவணங்கள் blacklisted செய்யப்படும்.",
            "ரீபண்ட் கடமையீடு: client தன் பொறுப்பில் முழு பணத்தைத் திருப்பி வழங்க வேண்டும்.",
            "வழக்கு மற்றும் சட்ட நடவடிக்கை: பணம் திருப்பி கொடுக்காவிட்டால் அல்லது தீர்வு இல்லாவிட்டால் பொருத்தமான consumer protection மற்றும் cyber law படி நடவடிக்கை எடுக்கப்படும்."
          ]
        }
      ]
    },
    "docs": {
      "title": "API ஆவணங்கள்",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "உள்நுழைந்து profile details சேமித்ததன் பின்னர் Your MecoPay பிரிவிலிருந்து Documentation Docs-இல் Laravel, Node.js அல்லது Python கொண்டு உருவாக்கப்பட்ட வலைத்தளங்களுக்கு விரிவான API Documentation மற்றும் JSON payload-ஐ காணலாம்.",
            "WordPress/WooCommerce integration-க்கான Plugin Apps & Plugin பிரிவிலும் Personal MFS automation-க்கான Sync App-ஐ ஒரே இடத்திலிருந்து download செய்யலாம்."
          ],
          "items": []
        }
      ]
    }
  },
  "ur": {
    "privacy": {
      "title": "رازداری کی پالیسی",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1۔ ہم کون سی معلومات جمع کرتے ہیں",
          "paragraphs": [],
          "items": [
            "شناختی دستاویزات اور ثبوت: آپ کا قومی شناختی نمبر (NID)، NID کی تصویر، پیدائش کا اندراج (Birth Certificate) نمبر، پیدائش کے اندراج کی تصویر اور آپ کی پاسپورٹ سائز تصویر۔",
            "رابطے کی معلومات: فون نمبر، نام اور ای میل ایڈریس۔",
            "ٹرانزیکشن ڈیٹا: پے منٹ لنک، انوائس اور ٹرانزیکشن اسٹیٹس۔"
          ]
        },
        {
          "heading": "1.2۔ ٹو-فیکٹر آتھینٹیکیشن (2FA) اور اکاؤنٹ سیکیورٹی",
          "paragraphs": [
            "MecoPay پر اکاؤنٹ کی حفاظت کے لیے روایتی ای میل اور پاس ورڈ سے براہِ راست اکاؤنٹ کھولنے کا انتظام نہیں ہے۔ آپ کو صرف Google Account (گوگل سائن-ان) سے منسلک محفوظ ڈیوائس کے ذریعے رسائی لینی ہوگی۔"
          ],
          "items": [
            "رسائی اور 2-Step ویریفیکیشن سیکیورٹی: ہمارے پلیٹ فارم پر گوگل سائن-ان کرنے کے بعد آپ 2-Step Verification (TOTP) فعال کر سکیں گے۔ کسی ناگہانی صورت میں اگر کوئی آپ کا Gmail اکاؤنٹ ہیک کر لے یا آپ کا Gmail پاس ورڈ جان لے تب بھی آپ کے Google Authenticator کے 6 ڈیجیٹ کے ویریفیکیشن کوڈ کے بغیر کوئی بھی آپ کے MecoPay اکاؤنٹ میں داخل نہیں ہو سکے گا۔",
            "بایومیٹرک سفارش: اپنے اکاؤنٹ کو مکمل طور پر محفوظ رکھنے کے لیے ہم 2-Step Verification میں فنگر پرنٹ (Fingerprint) یا بایومیٹرک آپشن کے استعمال کی سخت سفارش کرتے ہیں۔"
          ]
        },
        {
          "heading": "1.3۔ سنگل اکاؤنٹ اور دائمی لاک پالیسی",
          "paragraphs": [
            "ہمارے پلیٹ فارم پر کسی فرد کی معلومات سے صرف ایک ہی اکاؤنٹ کھولا جا سکتا ہے۔ لاگ ان پروفائل میں شناخت کی تصدیق کے لیے دو اختیارات ہوتے ہیں (18 سال سے کم یا 18 سال سے زیادہ):"
          ],
          "items": [
            "18 سال سے زیادہ: NID اور پیدائش کا سرٹیفیکیٹ (Birth Certificate) دونوں کی معلومات اور تصاویر فراہم کرنا لازمی ہے۔ ایک بار پروفائل کی تصدیق ہو جانے پر یہ دستاویزات سسٹم میں مستقل طور پر لاک ہو جائیں گی۔",
            "18 سال سے کم: صرف پیدائش کے اندراج کی معلومات اور تصویر فراہم کر کے اکاؤنٹ کی تصدیق کی جا سکے گی۔ بعد میں NID اپ ڈیٹ کرنے کا موقع ہوگا، تاہم پیدائش کے اندراج کی معلومات مستقل طور پر لاک رہیں گی۔",
            "خبردار: اگر عمر 18 سال سے زیادہ ہونے کے باوجود NID سے بچنے کے لیے غلط عمر منتخب کی گئی تو اکاؤنٹ کی توثیق نہیں ہوگی اور اسے بلاک کیا جا سکتا ہے۔ ایک ہی دستاویز سے دوسرا اکاؤنٹ کھولنے کی کوشش منسوخ کر دی جائے گی۔"
          ]
        },
        {
          "heading": "1.4۔ بین الاقوامی بینک-لیول سیکیورٹی",
          "paragraphs": [
            "ہم صارفین کے ڈیٹا کی حفاظت میں کوئی سمجھوتہ نہیں کرتے۔ آپ کی معلومات کو محفوظ رکھنے کے لیے MecoPay بین الاقوامی بینک لیول سیکیورٹی برقرار رکھتا ہے۔"
          ],
          "items": [
            "فرنٹ اینڈ اور ایج سیکیورٹی (MecoPay Shield): ہمارے عالمی ایج نیٹ ورک کے ذریعے فرنٹ اینڈ اور API ٹریفک کو انکرپٹ کیا جاتا ہے اور DDoS حملوں سے محفوظ رکھا جاتا ہے۔",
            "بیک اینڈ سیکیورٹی (Row Level Security - RLS): آپ کے اکاؤنٹ کا ڈیٹا صرف آپ ہی دیکھ سکیں گے۔",
            "اینڈ ٹو اینڈ انکرپشن: Android ایپ اور سرور کے ہر کنکشن کو HMAC SHA-256 سِگنیچر کے ذریعے محفوظ کیا جاتا ہے۔"
          ]
        },
        {
          "heading": "1.5۔ رابطہ",
          "paragraphs": [
            "اس رازداری کی پالیسی کے بارے میں سوالات کے لیے support@mecopay.com پر رابطہ کریں۔"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "شرائط و ضوابط",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1۔ سروس کی تفصیل",
          "paragraphs": [
            "MecoPay ایک All-in-One ای-کامرس SaaS پلیٹ فارم ہے، جو Innovative Education & Technology (IET) کی ایک خاص پہل ہے۔ یہ مرچنٹ اور کسٹمر کے درمیان لین دین کو خودکار بنانے والا ایک پے منٹ آٹومیشن اور مربوط ای-کامرس ایکوسسٹم ہے۔",
            "MecoPay براہِ راست کسٹمر سے مرچنٹ کے اکاؤنٹ میں ادائیگیوں کو پروسیس اور ویریفائی کرنے میں مدد کرتا ہے اور کسی بھی کسٹمر یا مرچنٹ کے فنڈز کو اپنے پاس ہولڈ یا جمع نہیں کرتا۔"
          ],
          "items": []
        },
        {
          "heading": "2.2۔ آٹو-راوٹنگ اور ٹرانزیکشن حد",
          "paragraphs": [],
          "items": [
            "پرسنل MFS: صارفین ذاتی موبائل بینکنگ اکاؤنٹس استعمال کر سکیں گے۔ زیادہ سے زیادہ 2 ذاتی نمبرز سیٹ کیے جا سکتے ہیں؛ پہلے نمبر کی حد ختم ہونے پر سسٹم ادائیگی دوسرے نمبر پر روٹ کرے گا۔",
            "مرچنٹ API: ذاتی اکاؤنٹ کی حد سے زیادہ حجم والی ٹرانزیکشنز کے لیے مرچنٹ API سیٹ کرنا ضروری ہوگا۔"
          ]
        },
        {
          "heading": "2.3۔ ذمہ داری کی محدودیت (Limitation of Liability)",
          "paragraphs": [
            "پرسنل MFS اکاؤنٹ میں اضافی ٹرانزیکشن یا آٹو-راوٹنگ کے استعمال کے باعث متعلقہ موبائل بینکنگ اتھارٹی اگر اکاؤنٹ کو محدود، بلاک یا معطل کر دے تو اس کی ذمہ داری صارف کی ہوگی۔ ایسے معاملات میں MecoPay کسی قانونی یا مالی ذمہ داری کا پابند نہیں ہوگا۔"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "ریفنڈ پالیسی (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1۔ سبسکرپشن ریفنڈ",
          "paragraphs": [
            "MecoPay صارفین کو فری ٹرائل فراہم کرتا ہے تاکہ وہ سروس کا جائزہ لے سکیں۔ اسی لیے Basic یا Pro جیسے پیڈ سبسکرپشن شروع ہونے کے بعد عام طور پر فیس قابلِ واپسی ہوتی ہے۔"
          ],
          "items": []
        },
        {
          "heading": "2۔ ریفنڈ کی صورت میں کلائنٹ کے لیے زیرو چارج",
          "paragraphs": [
            "اگر کسٹمر کوئی پروڈکٹ واپس کرے یا ایڈوانس ادائیگی کی واپسی طلب کرے تو کلائنٹ/مرچنٹ کو مکمل پیشگی رقم واپس کرنی ہوگی۔",
            "ریفنڈ کی توثیق کے وقت جو ٹرانزیکشن یا سروس فیس MecoPay نے لی تھی وہ کلائنٹ سے مزید نہیں کٹی جائے گی یا معاف کر دی جائے گی۔"
          ],
          "items": []
        },
        {
          "heading": "3۔ استثنائی معاملات (Exceptional Cases)",
          "paragraphs": [
            "مندرجہ ذیل صورتوں میں MecoPay کی سبسکرپشن فیس کی واپسی پر غور کیا جا سکتا ہے:"
          ],
          "items": [
            "سسٹم کی تکنیکی خرابی کی وجہ سے ڈبل بلنگ ہونے کی صورت میں۔",
            "طویل مدتی غیر متوقع آؤٹج یا ڈاؤن ٹائم کی صورت میں۔",
            "نوٹ: کسی تیسری پارٹی کے موبائل بینکنگ فراہم کنندہ کے اپنے سرور کے ڈاؤن ہونے کی وجہ سے تاخیر اس شرط کے تحت شامل نہیں ہے۔"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "اینٹی فراڈ اور صارفین کے حقوق کی پالیسی",
      "alertTitle": "زیرو ٹالرنس اینٹی-فراڈ پالیسی",
      "alert": "ہم صارفین کے حقوق کے تحفظ کے لیے زیرو ٹالرنس پالیسی اتباع کرتے ہیں۔ Checkout صفحے پر Report بٹن موجود ہے؛ فراڈ کی صورت میں ثبوت کے ساتھ براہِ راست شکایت درج کی جا سکتی ہے۔",
      "sections": [
        {
          "heading": "1۔ ڈیلیوری ویریفیکیشن کا عمل",
          "paragraphs": [],
          "items": [
            "فزیکل پروڈکٹس: چاہے کسٹم یا no-code ویب سائٹ استعمال کی جائے، delivery API کنکشن لازمی ہے۔ بیک اینڈ courier API سے ڈیٹا لے کر ریئل ٹائم میں تصدیق کرے گا۔",
            "ڈیجیٹل پروڈکٹس: شکایت کی صورت میں خریدار اور فروخت کنندہ کے اسکرین شاٹس، brand data اور server log کو کراس چیک کر کے دستی طور پر تصدیق کی جائے گی۔"
          ]
        },
        {
          "heading": "2۔ فراڈ کی سزا اور قانونی کارروائی",
          "paragraphs": [
            "اگر ثابت ہو کہ کسی بھی merchant یا client نے پیشگی رقم لے کر پروڈکٹ نہیں دی تو درج ذیل اقدامات کیے جائیں گے:"
          ],
          "items": [
            "Warning اور حل: رپورٹ موصول ہونے پر ثبوت کے ساتھ آگاہ کیا جائے گا؛ حل نہ ہونے پر account ban کیا جائے گا۔",
            "Permanent Ban: اگر شکایت ثابت ہو تو account مستقل طور پر ban اور شناختی دستاویزات کو blacklisted کیا جائے گا۔",
            "Refund کی پابندی: client کو اپنی ذمہ داری پر مکمل رقم واپس کرنی ہوگی۔",
            "عدالتی اور قانونی کارروائی: رقم واپس نہ کرنے یا حل نہ ہونے کی صورت میں متعلقہ consumer protection اور cyber law کے مطابق کارروائی کی جائے گی۔"
          ]
        }
      ]
    },
    "docs": {
      "title": "API دستاویزات",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "لاگ ان کر کے profile details save کرنے کے بعد Your MecoPay سیکشن سے Documentation Docs میں Laravel, Node.js یا Python سے بنائے گئے ویب سائٹس کے لیے تفصیلی API Documentation اور JSON payload دیکھا جا سکے گا۔",
            "WordPress/WooCommerce انٹیگریشن کے لیے Plugin Apps & Plugin سیکشن سے اور Personal MFS automation کے لیے Sync App اسی جگہ سے download کیا جا سکتا ہے۔"
          ],
          "items": []
        }
      ]
    }
  },
  "te": {
    "privacy": {
      "title": "గోప్యతా విధానం",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. మేము ఏ సమాచారము సేకరిస్తాము",
          "paragraphs": [],
          "items": [
            "పరిచయ పత్రాలు మరియు నిరూపణలు: మీ జాతీయ గుర్తింపు పత్రం (NID) సంఖ్య, NID యొక్క చిత్రం, పుట్టిన రిజిస్ట్రేషన్ (Birth Certificate) సంఖ్య, పుట్టిన రిజిస్ట్రేషన్ యొక్క చిత్రం మరియు మీ పాస్‌పోర్ట్-సైజ్ ఫోటో.",
            "సంప్రదింపు సమాచారం: ఫోన్ నంబరు, పేరు మరియు ఇమెయిల్ చిరునామా.",
            "లావాదేవీ డేటా: పేమెంట్ లింక్, ఇన్వాయిస్ మరియు ట్రాన్సాక్షన్ స్థితి."
          ]
        },
        {
          "heading": "1.2. రెండు-ఫ్యాక్టర్ అథెంటికేషన్ (2FA) మరియు ఖాతా భద్రత",
          "paragraphs": [
            "MecoPayలో ఖాతా భద్రత కోసం సంప్రదాయ ఇమెయిల్-పాస్‌వర్డ్తో నేరుగా ఖాతా తయారు చేసుకునే వ్యవస్థ లేదు. మీరు Google Account (గూగుల్ సైన్-ఇన్) కలిగిన భద్రুতమైన డివైస్ ద్వారా మాత్రమే యాక్సెస్ పొందాలి."
          ],
          "items": [
            "అాక్సెస్ మరియు 2-Step వెరిఫికేషన్ భద్రత: మా ప్లాట్‌ఫారమ్‌లో గూగుల్ సైన్-ఇన్ చేసిన తర్వాత మీరు 2-Step Verification (TOTP)ను సక్రియం చేయగలరు. ఎవరైనా మీ Gmail ఖాతాను హ్యాక్ చేసినా లేదా మీ Gmail పాస్‌వర్డ్ తెలుసుకున్నా కూడా, Google Authenticator యొక్క 6-అంకెల వెరిఫికేషన్ కోడ్ లేకుండా ఎవరికీ మీ MecoPay ఖాతాలో ప్రేవేశం సాధ్యంకాదు.",
            "బయోమెట్రిక్ సిఫార్సు: మీ ఖాతాను సంపూర్ణంగా రక్షించుకోడానికి 2-Step Verification సమయంలో ఫింగర్ప్రింట్ (Fingerprint) లేదా బయోమెట్రిక్ ఎంపిక ఉపయోగించమని మేము బలంగా సిఫార్సు చేస్తాము."
          ]
        },
        {
          "heading": "1.3. ఒకే ఖాతా మరియు శాశ్వత లాక్ విధానం",
          "paragraphs": [
            "మన ప్లాట్‌ఫాం‌లో ఒక వ్యక్తి యొక్క వివరాలతో కేవలం ఒకే ఒక ఖాతానే খুলబడుతుంది. లాగిన్ ప్రొఫైల్‌లో గుర్తింపు ధృవీకరణ కోసం రెండు ఎంపికలు ఉంటాయి (18 సంవత్సరాల కంటే తిన్నవారుగా లేదా 18 సంవత్సరాల కంటే ఎక్కువవారుగా):"
          ],
          "items": [
            "18 ఏళ్లకంటే ఎక్కువ: NID మరియు పుట్టిన రిజిస్ట్రేషన్ (Birth Certificate) రెండింటి వివరాలు మరియు చిత్రాలు అందించటం అనివార్యం. ఒకసారి ప్రొఫైల్ ధృవీకరించబడిన తర్వాత, ఈ డాక్యుమెంట్లు సిస్టంలో శాశ్వతంగా లాక్ చేయబడతాయి.",
            "18 సంవత్సరాలకి తక్కువ: కేవలం పుట్టిన రిజిస్ట్రేషన్ వివరాలు మరియు చిత్రాలతో ఖాతాను ధృవీకరించవచ్చు. తర్వాత NID అప్డేట్ చేసుకోవడానికి అవకాశముండి, అయితే పుట్టిన రిజిస్ట్రేషన్ సమాచారం శాశ్వతంగా లాక్‌గా ఉంటుంది.",
            "జాగ్రత్త: వయస్సు 18 ఏళ్లకు పైగా ఉన్నా కూడా NID నివారించేందుకు తప్పుగా వయస్సు ఎంచుకుంటే ఖాతా ధృవీకరించబడదు మరియు బ్లాక్ చేయబడవచ్చు. అదే డాక్యుమెంటుతో రెండవ ఖాతా తెరవాలని ప్రయత్నం రద్దు చేయబడుతుంది."
          ]
        },
        {
          "heading": "1.4. అంతర్జాతీయ బ్యాంక్-స్థాయి భద్రత",
          "paragraphs": [
            "మేము వినియోగదారుల సమాచార భద్రతపై ఒప్పందం చెయ్యమంటము. మీ సమాచారం రక్షితంగా ఉండేందుకు MecoPay అంతర్జాతీయ బ్యాంక్-స్థాయి భద్రతను నిర్వహిస్తుంది."
          ],
          "items": [
            "ఫ్రంట్‌ఎండ్ మరియు ఎజ్ భద్రత (MecoPay Shield): మా గ్లోబల్ ఎజ్ నెట్‌వర్క్ ద్వారా ఫ్రంట్‌ఎండ్ మరియు API ట్రాఫిక్ ఎన్‌క్రిప్టెడ్‌గా ఉండి DDoS దాడుల నుంచి రక్షించబడుతుంది.",
            "బ్యాక్‌ఎండ్ సెక్యూరిటీ (Row Level Security - RLS): మీ ఖాతా డేటాను మాత్రమే మీరు చూడగలరు.",
            "ఎండ్-టు-ఎండ్ ఎన్‌క్రిప్షన్: Android యాప్ మరియు సర్వర్ మధ్య ప్రతి కనెక్షన్ HMAC SHA-256 సిగ్నేచర్ ద్వారా రక్షితంగా ఉంటుంది."
          ]
        },
        {
          "heading": "1.5. సంప్రదింపు",
          "paragraphs": [
            "ఈ గోప్యతా విధానం గురించి ప్రశ్నలుంటే support@mecopay.com వద్ద సంప్రదించండి."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "నియమాలు & షరతులు",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. సేవ యొక్క వివరణ",
          "paragraphs": [
            "MecoPay ఒక ఆల్-ఇన్-వన్ (All-in-One) ఈ-కామర్స్ SaaS ప్లాట్‌ఫాం, ఇది Innovative Education & Technology (IET) యొక్క ఒక ప్రత్యేక ఉపక్రమం. ఇది మర్చంట్ మరియు కస్టమర్ల మధ్య లావాదేవీలను ఆటోమెట్ చేసే పేమెంట్ ఆటోమేషన్ మరియు సమగ్ర ఈ-కామర్స్ ఎకోసిస్టమ్.",
            "MecoPay నేరుగా కస్టమర్ నుండి మర్చంట్ ఖాతాకు పేమెంట్లు ప్రాసెస్ చేయడంలో మరియు ధృవీకరించడంలో సహాయం చేస్తుంది మరియు ఏ కస్టమర్ లేదా మర్చంట్ యొక్క డబ్బును స్వయంగా హోల్డ్ లేదా నిల్వ చేయదు."
          ],
          "items": []
        },
        {
          "heading": "2.2. ఆటో-రౌటింగ్ మరియు లావాదేవీ పరిమితి",
          "paragraphs": [],
          "items": [
            "పర్సనల్ MFS: వినియోగదారులు పర్సనల్ మొబైల్ బ్యాంకింగ్ ఖాతా ఉపయోగించవచ్చు. గరిష్ఠంగా 2 పర్సనల్ నంబర్లు సెట్ చేయవచ్చు; మొదటి నంబర్ పరిమితి తీరినప్పుడు సిస్టమ్ రెండవ నంబరికి పేమెంటును రూట్ చేస్తుంది.",
            "మర్చంట్ API: పర్సనల్ అకౌంట్ పరిమితికి మించిన వాల్యూమ్ లావాదేవీల అవసరం ఉంటే మర్చంట్ API సెటప్ చేయాలి."
          ]
        },
        {
          "heading": "2.3. బాధ్యత పరిమితి (Limitation of Liability)",
          "paragraphs": [
            "పర్సనల్ MFS ఖాతాలో అదనపు లావాదేవీలు లేదా ఆటో-రౌటింగ్ వాడకంతో సంబంధిత మొబైల్ బ్యాంకింగ్ అధికారం ఖాతాను పరిమితం చేయడం, బ్లాక్ చేయడం లేదా సస్పెండ్ చేయడం వల్ల కలిగే బాధ్యత వినియోగదారుని మీదే ఉంటుంది. ఇలాంటి కారణాల వల్ల MecoPay ఏ రకమైన న్యాయపరమైన లేదా ఆర్ధిక బాధ్యతను తీసుకోదు."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "రీఫండ్ విధానం (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. సబ్‌స్క్రిప్షన్ రీఫండ్",
          "paragraphs": [
            "MecoPay వినియోగదారులకు సేవను పరీక్షించడానికి ఫ్రీ ట్రయల్ అందిస్తుంది. అందువల్ల Basic లేదా Pro వంటి పేయిడ్ సబ్స్క్రిప్షన్ ప్రారంభమైన తర్వాత సాధారణంగా ఫీజులు తిరిగి ఇవ్వబడవు."
          ],
          "items": []
        },
        {
          "heading": "2. రీఫండ్ సందర్భాల్లో క్లయింట్‌కు జీరో ఛార్జ్",
          "paragraphs": [
            "కస్టమర్ ఏదైనా ఉత్పత్తిని రిటర్న్ చేస్తే లేదా అడ్వాన్స్ పేమెంట్ రీఫండ్ కోరితే క్లయింట్/మర్చంట్ పూర్తి చూపించిన ముందస్తు మొత్తాన్ని తిరిగి చెల్లించాలి.",
            "రీఫండ్ ధృవీకరణ సమయంలో MecoPay తీసుకున్నటువంటి ట్రాన్సాక్షన్ లేదా సర్వీస్ ఛార్జ్‌ను క్లయింట్ నుండి మళ్లీ తీసుకోబడదు లేదా ఆ ఛార్జ్ మాఫీ చేయబడుతుంది."
          ],
          "items": []
        },
        {
          "heading": "3. అసాధారణ సందర్భాలు (Exceptional Cases)",
          "paragraphs": [
            "క్రింది సందర్భాలలో MecoPay సబ్‌స్క్రిప్షన్ ఫీజును రీఫండ్ చేయటం పరిగణించవచ్చు:"
          ],
          "items": [
            "సిస్టమ్ సాంకేతిక లోపం కారణంగా డబుల్ బిలింగ్ జరిగితే.",
            "దీర్ఘకాలిక అనూహ్య అవుటేజ్ లేదా డౌన్‌టైమ్ ఉంటే.",
            "గమనిక: మూడో పక్ష మొబైల్ బ్యాంకింగ్ ప్రొవైడర్ యొక్క స్వంత సర్వర్ డౌన్ కారణంగా జరిగిన ఆలస్యం ఈ షరతు కింద రాదు."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "ప్రతారಿಕೆ నివారణ మరియు కస్టమర్ హక్కుల విధానం",
      "alertTitle": "జీరో-టాలరెన్స్ యాంటీ-ఫ్రాడ్ పాలసీ",
      "alert": "మేము వినియోగదారుల హక్కులను రక్షించడంలో జీరో-టాలరెన్స్ నిబంధనను అనుసరిస్తాము. Checkout పేజీలో Report బటన్ ఉంది; మోసం జరిగితే సాక్ష్యాలతో కలిసి నేరుగా ఫిర్యాదు చేయవచ్చు.",
      "sections": [
        {
          "heading": "1. డెలివరీ ధృవీకరణ ప్రక్రియ",
          "paragraphs": [],
          "items": [
            "ఫిజికల్ ఉత్పత్తి: కస్టమ్ లేదా నో-కోడ్ వెబ్‌సైట్ ఏదైనా ఉపయోగించినా, delivery API కలపటం తప్పనిసరి. బ్యాక్‌ఎండ్ courier API నుండి డేటా తీసుకుని రియల్-టైమ్‌లో ధృవీకరించబడుతుంది.",
            "డిజిటల్ ఉత్పత్తి: ఫిర్యాదువచ్చిన సందర్భంలో కొనుగోలుదారు మరియు విక్రేత స్క్రీన్‌షాట్‌లు, brand data మరియు server logలను క్రాస్-చెక్ చేసి మాన్యువల్‌గా విచారణ చేయబడుతుంది."
          ]
        },
        {
          "heading": "2. మోసానికి శిక్షలు మరియు చట్టపరమైన చర్యలు",
          "paragraphs": [
            "సాక్ష్యాలుంటే ఏ మర్చంట్ లేదా క్లయింట్ ముందస్తుగా తీసుకున్న డబ్బు ఇస్తున్న ఉత్పత్తి ఇవ్వకపోతే, క్రింద పేర్కొన్న చర్యలు తీసుకోబడతాయి:"
          ],
          "items": [
            "వార్నింగ్ మరియు పరిష్కారం: రిపోర్ట్ అందిన తర్వాత సాక్ష్యాలతో తెలియజేస్తాము; పరిష్కారం కాకపోతే ఖాతాను ban చేయబడుతుంది.",
            "శాశ్వత బాన్: ఫిర్యాదు సాక్ష్యాలతో నిరూపించబడిన పక్షంలో ఖాతాను శాశ్వతంగా ban చేసి గుర్తింపు పత్రాలను blacklisted చేస్తాము.",
            "రీఫండ్ బాధ్యత: క్లయింట్ తన బాధ్యతగా పూర్తి మొత్తాన్ని తిరిగి చెల్లించాలి.",
            "మాములు మరియు చట్టచర్యలు: డబ్బు తిరిగి చెల్లించకపోవడం లేదా పరిష్కారం లేకపోవడం సందర్భంలో వర్తించే వినియోగదారు రక్షణ చట్టం మరియు సైబర్ చట్టం ప్రకారం చర్యలు తీసుకుంటాము."
          ]
        }
      ]
    },
    "docs": {
      "title": "API డాక్యుమెంటేషన్",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "లాగిన్ చేసి profile details సేవ్ చేసిన తర్వాత Your MecoPay సెక్షన్ నుండి Documentation Docs లో Laravel, Node.js లేదా Python తో తయారుచేసిన వెబ్‌సైట్ కోసం వివరణాత్మక API Documentation మరియు JSON payload చూడవచ్చు.",
            "WordPress/WooCommerce ఇంటిగ్రేషన్ కోసం Plugin Apps & Plugin సెక్షన్ లో మరియు Personal MFS ఆటోమేషన్ కోసం Sync App అదే చోటు నుండి డౌన్లోడ్ చేసుకోవచ్చు."
          ],
          "items": []
        }
      ]
    }
  },
  "it": {
    "privacy": {
      "title": "Informativa sulla privacy",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Quali informazioni raccogliamo",
          "paragraphs": [],
          "items": [
            "Documenti di identità e prova: il tuo numero di identità nazionale (NID), la foto del NID, il numero del certificato di nascita (Birth Certificate), la foto del certificato di nascita e la tua foto formato passaporto.",
            "Informazioni di contatto: numero di telefono, nome e indirizzo email.",
            "Dati delle transazioni: link di pagamento, fatture e stato delle transazioni."
          ]
        },
        {
          "heading": "1.2. Autenticazione a due fattori (2FA) e sicurezza dell'account",
          "paragraphs": [
            "Su MecoPay non è previsto l'apertura diretta di un account tramite il tradizionale indirizzo email e password. È necessario accedere esclusivamente tramite un dispositivo protetto associato a Google Account (Google Sign-in)."
          ],
          "items": [
            "Protezione di accesso e verifica in 2 passaggi: dopo l'accesso con Google Sign-in sulla nostra piattaforma è possibile attivare la verifica in 2 passaggi (TOTP). Anche se qualcuno dovesse compromettere il tuo account Gmail o conoscere la tua password Gmail, non potrà accedere al tuo account MecoPay senza il codice di verifica a 6 cifre di Google Authenticator.",
            "Raccomandazione biometrica: per proteggere completamente il tuo account raccomandiamo vivamente di usare l'impronta digitale (Fingerprint) o le opzioni biometriche per la verifica in 2 passaggi."
          ]
        },
        {
          "heading": "1.3. Politica di account singolo e blocco permanente",
          "paragraphs": [
            "Sulla nostra piattaforma è possibile creare un solo account per ogni persona. Per la verifica dell'identità nel profilo di accesso sono previste due opzioni (meno di 18 anni o 18 anni e oltre):"
          ],
          "items": [
            "18 anni e oltre: è obbligatorio fornire dati e foto sia del NID che del certificato di nascita (Birth Certificate). Una volta verificato il profilo, questi documenti saranno bloccati permanentemente nel sistema.",
            "Meno di 18 anni: l'account può essere verificato fornendo solo i dati e la foto del certificato di nascita. Sarà possibile aggiornare il NID in seguito, ma le informazioni del certificato di nascita resteranno bloccate permanentemente.",
            "Avvertenza: se selezioni erroneamente un'età inferiore per evitare il NID pur essendo maggiorenne (18+), l'account non verrà verificato e potrà essere bloccato. Il tentativo di aprire un secondo account con gli stessi documenti verrà annullato."
          ]
        },
        {
          "heading": "1.4. Sicurezza a livello bancario internazionale",
          "paragraphs": [
            "Non facciamo compromessi sulla sicurezza dei dati dei clienti. Per proteggere le tue informazioni MecoPay mantiene standard di sicurezza a livello bancario internazionale."
          ],
          "items": [
            "Sicurezza frontend e edge (MecoPay Shield): tramite la nostra rete globale di edge il traffico frontend e le richieste API sono crittografate e protette dagli attacchi DDoS.",
            "Sicurezza backend (Row Level Security - RLS): i dati del tuo account saranno visibili solo a te.",
            "Crittografia end-to-end: ogni connessione tra l'app Android e il server è protetta da firma HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Contatti",
          "paragraphs": [
            "Per domande relative a questa informativa sulla privacy, contatta support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Termini e condizioni",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Descrizione del servizio",
          "paragraphs": [
            "MecoPay è una piattaforma SaaS di e-commerce all-in-one (All-in-One), iniziativa speciale di Innovative Education & Technology (IET). È un ecosistema integrato di automazione dei pagamenti e e-commerce che automatizza le transazioni tra merchant e clienti.",
            "MecoPay facilita il processo e la verifica dei pagamenti direttamente dal cliente al conto del merchant e non trattiene né custodisce fondi di clienti o merchant."
          ],
          "items": []
        },
        {
          "heading": "2.2. Instradamento automatico e limiti delle transazioni",
          "paragraphs": [],
          "items": [
            "MFS personale: gli utenti possono utilizzare conti di mobile banking personali. È possibile impostare fino a 2 numeri personali; quando il limite del primo numero è raggiunto il sistema instraderà i pagamenti al secondo numero.",
            "Merchant API: se sono necessari volumi di transazioni superiori ai limiti degli account personali, è necessario configurare una Merchant API."
          ]
        },
        {
          "heading": "2.3. Limitazione di responsabilità (Limitation of Liability)",
          "paragraphs": [
            "Se un'autorità del mobile banking limita, blocca o sospende un account personale a causa di transazioni aggiuntive o dell'uso dell'instradamento automatico, la responsabilità è dell'utente. In tali casi MecoPay non sarà legalmente o finanziariamente responsabile."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Politica di rimborso (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Rimborso delle sottoscrizioni",
          "paragraphs": [
            "MecoPay offre un periodo di prova gratuito agli utenti per testare il servizio. Pertanto, dopo l'avvio di sottoscrizioni a pagamento come Basic o Pro, le tariffe generalmente non sono rimborsabili."
          ],
          "items": []
        },
        {
          "heading": "2. Zero addebiti per il cliente in caso di rimborso",
          "paragraphs": [
            "Se un cliente restituisce un prodotto o richiede il rimborso di un pagamento anticipato, il client/merchant dovrà rimborsare integralmente l'anticipo.",
            "Quando si verifica un rimborso, le commissioni di transazione o di servizio che MecoPay aveva applicato non verranno più addebitate al client/merchant o saranno annullate."
          ],
          "items": []
        },
        {
          "heading": "3. Casi eccezionali (Exceptional Cases)",
          "paragraphs": [
            "Nei casi seguenti il rimborso della quota di sottoscrizione di MecoPay può essere preso in considerazione:"
          ],
          "items": [
            "In caso di doppia fatturazione dovuta a un errore tecnico di sistema.",
            "In caso di interruzione o downtime prolungato e imprevisto.",
            "Nota: i ritardi dovuti al downtime dei server del fornitore di mobile banking di terze parti non rientrano in questa condizione."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Politica Anti-Frode e diritti dei clienti",
      "alertTitle": "Politica di tolleranza zero anti-frode",
      "alert": "Applichiamo una politica di tolleranza zero per la tutela dei diritti dei clienti. Nella pagina di checkout è presente un pulsante Report; in caso di frode è possibile segnalare direttamente fornendo le prove.",
      "sections": [
        {
          "heading": "1. Procedura di verifica della consegna",
          "paragraphs": [],
          "items": [
            "Prodotti fisici: indipendentemente dal fatto che venga utilizzato un sito web custom o no-code, la connessione alla delivery API è obbligatoria. Il backend verificherà i dati in tempo reale prendendoli dalla courier API.",
            "Prodotti digitali: in caso di reclamo verranno verificate manualmente schermate (screenshot) del compratore e del venditore, i dati del brand e i log del server, confrontandoli (cross-check)."
          ]
        },
        {
          "heading": "2. Sanzioni per frode e azioni legali",
          "paragraphs": [
            "Se provato che un merchant o client non ha fornito un prodotto dopo aver ricevuto il pagamento anticipato, verranno intraprese le seguenti azioni:"
          ],
          "items": [
            "Avviso e risoluzione: dopo la ricezione della segnalazione saranno forniti i dettagli e le prove; se non si raggiunge una soluzione l'account verrà sospeso (ban).",
            "Ban permanente: se la segnalazione è comprovata, l'account sarà bannato definitivamente e i documenti d'identità saranno inseriti in blacklist.",
            "Obbligo di rimborso: il client sarà tenuto a rimborsare integralmente a propria responsabilità.",
            "Azione legale: se non viene effettuato il rimborso o non si raggiunge una soluzione, saranno intraprese azioni conformi alle normative vigenti sulla protezione del consumatore e al diritto informatico (cyber law)."
          ]
        }
      ]
    },
    "docs": {
      "title": "Documentazione API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Dopo aver effettuato il login e salvato i dettagli del profilo, nella sezione 'Your MecoPay' potrai accedere a Documentation Docs per visualizzare la Documentazione API dettagliata e i payload JSON per siti web sviluppati con Laravel, Node.js o Python.",
            "Per l'integrazione WordPress/WooCommerce puoi scaricare Plugin Apps & Plugin dalla relativa sezione, e per l'automazione di Personal MFS puoi scaricare lo Sync App dallo stesso luogo."
          ],
          "items": []
        }
      ]
    }
  },
  "nl": {
    "privacy": {
      "title": "Privacybeleid",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Welke gegevens verzamelen we",
          "paragraphs": [],
          "items": [
            "Identiteitsdocumenten en bewijs: uw nationale identiteitskaart (NID)-nummer, een foto van de NID, geboortecertificaat (Birth Certificate)-nummer, een foto van het geboortecertificaat en uw paspoortformaat foto.",
            "Contactgegevens: telefoonnummer, naam en e-mailadres.",
            "Transactiegegevens: betalingslink, facturen en transactie-status."
          ]
        },
        {
          "heading": "1.2. Twee-factor-authenticatie (2FA) en accountbeveiliging",
          "paragraphs": [
            "Er is geen traditionele aanmelding met e-mail en wachtwoord voor het openen van een account bij MecoPay. U moet toegang krijgen via een beveiligd apparaat gekoppeld aan uw Google Account (Google Sign-in)."
          ],
          "items": [
            "Toegang en 2-staps verificatiebeveiliging: nadat u zich via Google Sign-in op ons platform aanmeldt, kunt u 2-Step Verification (TOTP) activeren. Zelfs als iemand uw Gmail-account hackt of uw Gmail-wachtwoord kent, kan niemand toegang krijgen tot uw MecoPay-account zonder de 6-cijferige verificatiecode van uw Google Authenticator.",
            "Biometrische aanbeveling: om uw account volledig te beveiligen raden wij sterk aan bij 2-Step Verification de vingerafdruk (Fingerprint) of een biometrische optie te gebruiken."
          ]
        },
        {
          "heading": "1.3. Enkel account en beleid voor permanente vergrendeling",
          "paragraphs": [
            "Op ons platform kan met de gegevens van één persoon slechts één account worden aangemaakt. Voor identiteitsverificatie op het loginprofiel zijn er twee opties (onder de 18 jaar of 18 jaar en ouder):"
          ],
          "items": [
            "18 jaar en ouder: zowel NID- als geboortecertificaat (Birth Certificate)-gegevens en -foto's zijn verplicht. Zodra het profiel is geverifieerd, worden deze documenten permanent in het systeem vergrendeld.",
            "Onder de 18 jaar: het account kan worden geverifieerd door alleen geboorteregistratiegegevens en -foto te verstrekken. Later kan NID worden toegevoegd/geüpdatet, maar de geboorteregistratiegegevens blijven permanent vergrendeld.",
            "Waarschuwing: als u ouder dan 18 bent maar een verkeerde leeftijd selecteert om NID te ontwijken, wordt het account niet geverifieerd en kan het worden geblokkeerd. Pogingen om een tweede account met hetzelfde document te openen worden geweigerd."
          ]
        },
        {
          "heading": "1.4. Internationale bankniveau beveiliging",
          "paragraphs": [
            "Wij doen geen concessies aan de beveiliging van klantgegevens. MecoPay onderhoudt internationale bankniveau beveiliging om uw gegevens te beschermen."
          ],
          "items": [
            "Frontend en edge-beveiliging (MecoPay Shield): via ons globale edge-netwerk wordt frontend- en API-verkeer versleuteld en beschermd tegen DDoS-aanvallen.",
            "Backend-beveiliging (Row Level Security - RLS): alleen u kunt de gegevens van uw account inzien.",
            "End-to-end encryptie: elke verbinding tussen de Android-app en de server is beveiligd met een HMAC SHA-256-handtekening."
          ]
        },
        {
          "heading": "1.5. Contact",
          "paragraphs": [
            "Bij vragen over dit privacybeleid kunt u contact opnemen via support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Algemene voorwaarden",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Beschrijving van de dienst",
          "paragraphs": [
            "MecoPay is een all-in-one (All-in-One) e-commerce SaaS-platform, een initiatief van Innovative Education & Technology (IET). Het is een betaalautomatisering en geïntegreerd e-commerce-ecosysteem om transacties tussen merchants en klanten te automatiseren.",
            "MecoPay helpt betalingen direct van de klant naar de merchant-account te verwerken en te verifiëren en houdt geen geld van klanten of merchants aan."
          ],
          "items": []
        },
        {
          "heading": "2.2. Auto-routing en transactie-limiet",
          "paragraphs": [],
          "items": [
            "Personal MFS: gebruikers kunnen persoonlijke mobiele bankrekeningen gebruiken. Er kunnen maximaal 2 persoonlijke nummers ingesteld worden; als het limiet van het eerste nummer is bereikt, zal het systeem betalingen naar het tweede nummer routeren.",
            "Merchant API: als transacties een hoger volume vereisen dan de limieten van persoonlijke accounts, moet de Merchant API worden ingesteld."
          ]
        },
        {
          "heading": "2.3. Beperking van aansprakelijkheid (Limitation of Liability)",
          "paragraphs": [
            "Indien de bevoegde mobiele bankinstantie een account beperkt, blokkeert of schorst als gevolg van extra transacties of gebruik van auto-routing op een Personal MFS-account, ligt de verantwoordelijkheid bij de gebruiker. MecoPay is in dergelijke gevallen niet juridisch of financieel aansprakelijk."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Restitutiebeleid (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Abonnementsrestitutie",
          "paragraphs": [
            "MecoPay biedt gebruikers een gratis proefperiode zodat zij de dienst kunnen beoordelen. Daarom zijn de kosten doorgaans niet restitueerbaar nadat een betaald abonnement zoals Basic of Pro is gestart."
          ],
          "items": []
        },
        {
          "heading": "2. Terugbetaling zonder kosten voor de klant",
          "paragraphs": [
            "Als een klant een product retourneert of een terugbetaling van een vooruitbetaling eist, moet de client/merchant het volledige vooruitbetaalde bedrag terugbetalen.",
            "Bij verificatie van de terugbetaling wordt geen extra transactie- of servicevergoeding die MecoPay heeft ingehouden meer van de client afgetrokken of in rekening gebracht."
          ],
          "items": []
        },
        {
          "heading": "3. Uitzonderlijke gevallen (Exceptional Cases)",
          "paragraphs": [
            "In de volgende gevallen kan restitutie van MecoPay-abonnementskosten in overweging worden genomen:"
          ],
          "items": [
            "Bij dubbele facturering als gevolg van een technische storing in het systeem.",
            "Bij langdurige onverwachte uitval of downtime.",
            "Opmerking: vertragingen veroorzaakt door serveruitval van derde partij mobiele bankaanbieders vallen niet onder deze voorwaarde."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Anti-fraude & klantenrechtenbeleid",
      "alertTitle": "Zero-tolerance anti-fraudebeleid",
      "alert": "Wij hanteren een zero-tolerancebeleid voor de bescherming van klantrechten. Op de checkoutpagina is er een Report button; bij fraude kan direct met bewijs een klacht worden ingediend.",
      "sections": [
        {
          "heading": "1. Leveringsverificatieprocedure",
          "paragraphs": [],
          "items": [
            "Fysieke producten: ongeacht of er een custom of no-code website wordt gebruikt, is een delivery API-verbinding verplicht. De backend zal real-time verifiëren met gegevens van de courier API.",
            "Digitale producten: bij een klacht worden screenshots van koper en verkoper, brand data en serverlogs cross-checked en handmatig geverifieerd."
          ]
        },
        {
          "heading": "2. Straffen bij fraude en juridische stappen",
          "paragraphs": [
            "Als wordt bewezen dat een merchant of client vooruitbetaling heeft aangenomen en het product niet heeft geleverd, worden de volgende stappen genomen:"
          ],
          "items": [
            "Waarschuwing en oplossing: na ontvangst van het rapport wordt dit met bewijsmateriaal gemeld; bij uitblijven van oplossing wordt het account geband.",
            "Permanente ban: als de klacht bewezen wordt, wordt het account permanent geband en worden identiteitsdocumenten op een blacklist geplaatst.",
            "Terugbetalingsverplichting: de client is verplicht het volledige bedrag op eigen verantwoordelijkheid terug te betalen.",
            "Gerechtelijke stappen en juridische maatregelen: als het geld niet wordt terugbetaald of er geen oplossing wordt bereikt, zullen maatregelen worden getroffen volgens de geldende consumentenbescherming en cyberwetgeving."
          ]
        }
      ]
    },
    "docs": {
      "title": "API-documentatie",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Na inloggen en het opslaan van profielgegevens kunt u in het Your MecoPay-gedeelte onder Documentation Docs de gedetailleerde API-documentatie en JSON-payloads bekijken voor websites gemaakt met Laravel, Node.js of Python.",
            "Voor WordPress/WooCommerce-integratie kunt u in de Plugin Apps & Plugin-sectie downloaden en voor Personal MFS-automatisering kunt u de Sync App vanaf dezelfde plek downloaden."
          ],
          "items": []
        }
      ]
    }
  },
  "vi": {
    "privacy": {
      "title": "Chính sách Bảo mật",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Những thông tin chúng tôi thu thập",
          "paragraphs": [],
          "items": [
            "Giấy tờ tùy thân và bằng chứng: số NID (NID), ảnh NID, số Giấy khai sinh (Birth Certificate), ảnh giấy khai sinh và ảnh cỡ hộ chiếu của bạn.",
            "Thông tin liên hệ: số điện thoại, tên và địa chỉ email.",
            "Dữ liệu giao dịch: liên kết thanh toán, hóa đơn và trạng thái giao dịch."
          ]
        },
        {
          "heading": "1.2. Xác thực hai yếu tố (2FA) và bảo mật tài khoản",
          "paragraphs": [
            "Để bảo vệ tài khoản trên MecoPay, hệ thống không cho phép tạo tài khoản trực tiếp bằng email truyền thống và mật khẩu. Bạn chỉ có thể truy cập thông qua thiết bị được bảo mật liên kết với Google Account (Google Sign-in)."
          ],
          "items": [
            "Bảo mật truy cập và 2-Step Verification: Sau khi đăng nhập bằng Google Sign-in trên nền tảng của chúng tôi, bạn có thể kích hoạt 2-Step Verification (TOTP). Trong trường hợp ai đó xâm nhập tài khoản Gmail của bạn hoặc biết mật khẩu Gmail, họ vẫn không thể truy cập vào tài khoản MecoPay của bạn nếu không có mã xác thực 6 chữ số từ Google Authenticator.",
            "Khuyến nghị sinh trắc học: Để bảo vệ tài khoản hoàn toàn, chúng tôi khuyến nghị mạnh mẽ sử dụng tùy chọn vân tay (Fingerprint) hoặc tùy chọn sinh trắc học khác cho 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Tài khoản đơn lẻ và chính sách khóa vĩnh viễn",
          "paragraphs": [
            "Trên nền tảng của chúng tôi, mỗi cá nhân chỉ được mở một tài khoản bằng thông tin của họ. Hồ sơ đăng nhập có hai tùy chọn để xác minh danh tính (dưới 18 tuổi hoặc trên 18 tuổi):"
          ],
          "items": [
            "Trên 18 tuổi: Bắt buộc cung cấp thông tin và ảnh cả NID và Giấy khai sinh (Birth Certificate). Khi hồ sơ đã được xác minh, những tài liệu này sẽ bị khóa vĩnh viễn trong hệ thống.",
            "Dưới 18 tuổi: Có thể xác minh tài khoản chỉ bằng thông tin và ảnh giấy khai sinh. Về sau có thể cập nhật NID, tuy nhiên thông tin giấy khai sinh sẽ bị khóa vĩnh viễn.",
            "Cảnh báo: Nếu bạn trên 18 tuổi nhưng chọn tuổi sai để né NID, hồ sơ sẽ không được xác minh và có thể bị chặn. Mọi cố gắng mở tài khoản thứ hai bằng cùng một giấy tờ sẽ bị từ chối."
          ]
        },
        {
          "heading": "1.4. Bảo mật cấp ngân hàng quốc tế",
          "paragraphs": [
            "Chúng tôi không thỏa hiệp về bảo mật thông tin khách hàng. Để bảo vệ dữ liệu của bạn, MecoPay duy trì bảo mật ở tiêu chuẩn cấp ngân hàng quốc tế."
          ],
          "items": [
            "Bảo mật Frontend và Edge (MecoPay Shield): Lưu lượng frontend và API của chúng tôi được mã hóa và bảo vệ khỏi tấn công DDoS thông qua mạng edge toàn cầu.",
            "Bảo mật Backend (Row Level Security - RLS): Dữ liệu tài khoản của bạn chỉ có thể được xem bởi chính bạn.",
            "Mã hóa đầu cuối: Mỗi kết nối giữa ứng dụng Android và máy chủ được bảo vệ bằng chữ ký HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Liên hệ",
          "paragraphs": [
            "Nếu có câu hỏi về chính sách bảo mật này, vui lòng liên hệ support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Điều khoản & Điều kiện",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Mô tả dịch vụ",
          "paragraphs": [
            "MecoPay là một nền tảng e‑commerce SaaS All-in-One, là một sáng kiến của Innovative Education & Technology (IET). Nó là một hệ sinh thái thanh toán tự động và e‑commerce tích hợp nhằm tự động hóa giao dịch giữa merchant và customer.",
            "MecoPay hỗ trợ xử lý và xác minh thanh toán trực tiếp từ customer tới tài khoản merchant và không giữ hoặc tạm trữ tiền của bất kỳ customer hay merchant nào."
          ],
          "items": []
        },
        {
          "heading": "2.2. Tự định tuyến và giới hạn giao dịch",
          "paragraphs": [],
          "items": [
            "Personal MFS: Người dùng có thể sử dụng tài khoản ngân hàng di động cá nhân. Có thể thiết lập tối đa 2 số cá nhân; khi giới hạn của số đầu tiên đạt tới mức, hệ thống sẽ định tuyến thanh toán sang số thứ hai.",
            "Merchant API: Nếu giao dịch có khối lượng vượt quá giới hạn của tài khoản cá nhân, cần thiết lập Merchant API."
          ]
        },
        {
          "heading": "2.3. Giới hạn trách nhiệm (Limitation of Liability)",
          "paragraphs": [
            "Trong trường hợp cơ quan cung cấp mobile banking liên quan giới hạn, chặn hoặc đình chỉ tài khoản do giao dịch vượt mức hoặc do sử dụng tự định tuyến trên tài khoản MFS cá nhân, người dùng sẽ chịu trách nhiệm. MecoPay sẽ không chịu trách nhiệm về mặt pháp lý hoặc tài chính trong những trường hợp như vậy."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Chính sách Hoàn tiền (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Hoàn tiền đăng ký",
          "paragraphs": [
            "MecoPay cung cấp cho người dùng bản dùng thử miễn phí để họ kiểm tra dịch vụ. Vì vậy, thông thường phí cho các gói trả phí như Basic hoặc Pro không được hoàn sau khi bắt đầu."
          ],
          "items": []
        },
        {
          "heading": "2. Miễn phí cho khách hàng khi hoàn tiền",
          "paragraphs": [
            "Nếu khách hàng trả lại sản phẩm hoặc yêu cầu hoàn lại tiền trước, client/merchant phải hoàn trả toàn bộ số tiền đặt cọc trước cho khách hàng.",
            "Khi xác minh hoàn tiền, bất kỳ khoản phí giao dịch hoặc phí dịch vụ mà MecoPay đã thu sẽ không bị trừ thêm từ client hoặc sẽ được miễn."
          ],
          "items": []
        },
        {
          "heading": "3. Trường hợp ngoại lệ (Exceptional Cases)",
          "paragraphs": [
            "Trong các trường hợp sau, việc hoàn lại phí đăng ký của MecoPay có thể được xem xét:"
          ],
          "items": [
            "Nếu xảy ra tính toán hai lần do lỗi kỹ thuật của hệ thống gây ra double billing.",
            "Nếu có thời gian gián đoạn hoặc downtime kéo dài ngoài dự kiến.",
            "Lưu ý: Trì hoãn do server của bên cung cấp mobile banking thứ ba bị sập thì không thuộc điều kiện này."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Chính sách Chống gian lận & Quyền khách hàng",
      "alertTitle": "Chính sách Không khoan nhượng về Chống gian lận",
      "alert": "Chúng tôi tuân thủ chính sách không khoan nhượng nhằm bảo vệ quyền lợi khách hàng. Trên trang Checkout có nút Report; nếu có gian lận, có thể gửi khiếu nại trực tiếp kèm bằng chứng.",
      "sections": [
        {
          "heading": "1. Quy trình xác minh giao hàng",
          "paragraphs": [],
          "items": [
            "Sản phẩm vật lý: Bất kể sử dụng website tùy chỉnh hay no-code, việc kết nối delivery API là bắt buộc. Backend sẽ lấy dữ liệu từ courier API để xác minh theo thời gian thực.",
            "Sản phẩm số: Nếu có khiếu nại, sẽ xác minh thủ công bằng cách đối chiếu ảnh chụp màn hình của người mua và người bán, dữ liệu thương hiệu và log máy chủ."
          ]
        },
        {
          "heading": "2. Hình phạt cho gian lận và biện pháp pháp lý",
          "paragraphs": [
            "Nếu chứng minh được merchant hoặc client đã nhận tiền trước nhưng không giao sản phẩm, sẽ thực hiện các bước sau:"
          ],
          "items": [
            "Cảnh báo và giải quyết: Sau khi nhận báo cáo sẽ thông báo kèm bằng chứng; nếu không giải quyết, tài khoản sẽ bị ban.",
            "Cấm vĩnh viễn: Nếu khiếu nại được chứng minh, tài khoản sẽ bị cấm vĩnh viễn và giấy tờ tùy thân sẽ bị đưa vào danh sách đen.",
            "Nghĩa vụ hoàn tiền: Client phải chịu trách nhiệm hoàn trả toàn bộ số tiền.",
            "Khởi kiện và biện pháp pháp lý: Nếu không hoàn tiền hoặc không giải quyết, sẽ tiến hành theo các quy định bảo vệ người tiêu dùng và luật an ninh mạng hiện hành."
          ]
        }
      ]
    },
    "docs": {
      "title": "Tài liệu API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Sau khi đăng nhập và lưu chi tiết hồ sơ, từ mục Your MecoPay bạn có thể vào Documentation Docs để xem chi tiết API Documentation và JSON payload cho website được phát triển bằng Laravel, Node.js hoặc Python.",
            "Để tích hợp WordPress/WooCommerce, vào phần Plugin Apps & Plugin; để tự động hóa Personal MFS, tải Sync App từ cùng một nơi."
          ],
          "items": []
        }
      ]
    }
  },
  "th": {
    "privacy": {
      "title": "นโยบายความเป็นส่วนตัว",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. เราเก็บข้อมูลใดบ้าง",
          "paragraphs": [],
          "items": [
            "เอกสารประจำตัวและหลักฐาน: หมายเลขบัตรประจำตัวประชาชน (NID) ของคุณ, รูปภาพของ NID, หมายเลขสูติบัตร (Birth Certificate), รูปภาพสูติบัตร และรูปถ่ายขนาดพาสปอร์ตของคุณ।",
            "ข้อมูลการติดต่อ: หมายเลขโทรศัพท์ ชื่อ และที่อยู่อีเมล.",
            "ข้อมูลธุรกรรม: ลิงก์การชำระเงิน ใบแจ้งหนี้ และสถานะการทำธุรกรรม."
          ]
        },
        {
          "heading": "1.2. การยืนยันตัวตนแบบสองขั้นตอน (2FA) และความปลอดภัยของบัญชี",
          "paragraphs": [
            "ที่ MecoPay ไม่มีระบบเปิดบัญชีด้วยอีเมลและรหัสผ่านแบบดั้งเดิมโดยตรง คุณต้องเข้าถึงผ่านอุปกรณ์ที่เชื่อมโยง Google Account (การเข้าสู่ระบบด้วย Google) เท่านั้น."
          ],
          "items": [
            "การเข้าถึงและการยืนยันแบบ 2 ขั้นตอน: หลังจากเข้าสู่ระบบด้วย Google บนแพลตฟอร์มของเรา คุณสามารถเปิดใช้งาน 2-Step Verification (TOTP) ได้ หากมีคนแฮ็กบัญชี Gmail ของคุณหรือรู้รหัสผ่าน Gmail ของคุณ ก็ไม่สามารถเข้าถึงบัญชี MecoPay ของคุณได้โดยไม่มีรหัสยืนยัน 6 หลักจาก Google Authenticator.",
            "คำแนะนำเกี่ยวกับไบโอเมตริก: เพื่อความปลอดภัยของบัญชีอย่างเต็มที่ เราแนะนำอย่างยิ่งให้ใช้ฟิงเกอร์ปริ้นต์ (Fingerprint) หรือทางเลือกไบโอเมตริกสำหรับ 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. นโยบายบัญชีเดียวและการล็อกถาวร",
          "paragraphs": [
            "บนแพลตฟอร์มของเราสามารถเปิดบัญชีได้เพียงหนึ่งบัญชีต่อบุคคลเท่านั้น โปรไฟล์การเข้าสู่ระบบมีตัวเลือกการยืนยันตัวตนสองแบบ (อายุต่ำกว่า 18 ปี หรือ 18 ปีขึ้นไป):"
          ],
          "items": [
            "อายุ 18 ปีขึ้นไป: จำเป็นต้องให้ข้อมูลและรูปภาพของทั้ง NID และสูติบัตร (Birth Certificate) เมื่อโปรไฟล์ได้รับการยืนยัน เอกสารเหล่านี้จะถูกล็อกในระบบเป็นการถาวร.",
            "อายุต่ำกว่า 18 ปี: สามารถยืนยันบัญชีได้โดยให้ข้อมูลและรูปภาพของสูติบัตรเท่านั้น โดยสามารถอัปเดต NID ในภายหลังได้ แต่ข้อมูลสูติบัตรจะถูกล็อกถาวร.",
            "คำเตือน: หากผู้ใช้เป็นอายุ 18 ปีขึ้นไปแต่เลือกอายุผิดพลาดเพื่อหลีกเลี่ยง NID บัญชีจะไม่ผ่านการยืนยันและอาจถูกบล็อก การพยายามเปิดบัญชีที่สองด้วยเอกสารชุดเดียวกันจะถูกยกเลิก."
          ]
        },
        {
          "heading": "1.4. ความปลอดภัยระดับธนาคารสากล",
          "paragraphs": [
            "เราไม่ประนีประนอมต่อความปลอดภัยของข้อมูลลูกค้า MecoPay รักษามาตรฐานความปลอดภัยระดับธนาคารสากลเพื่อปกป้องข้อมูลของคุณ."
          ],
          "items": [
            "ความปลอดภัยส่วนหน้าบ้านและ edge (MecoPay Shield): ผ่านเครือข่าย edge ระดับโลกของเรา ทราฟฟิกส่วนหน้าและ API ถูกเข้ารหัสและป้องกันจากการโจมตี DDoS.",
            "ความปลอดภัยส่วนหลังบ้าน (Row Level Security - RLS): ข้อมูลบัญชีของคุณจะมองเห็นได้เฉพาะคุณเท่านั้น.",
            "การเข้ารหัสแบบจุดต่อจุด: การเชื่อมต่อทุกครั้งระหว่างแอป Android และเซิร์ฟเวอร์จะได้รับการป้องกันด้วยลายเซ็น HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. การติดต่อ",
          "paragraphs": [
            "หากมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อ support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "ข้อกำหนดและเงื่อนไข",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. คำอธิบายบริการ",
          "paragraphs": [
            "MecoPay เป็นแพลตฟอร์ม e‑commerce แบบ All-in-One ในรูปแบบ SaaS ซึ่งเป็นโครงการพิเศษของ Innovative Education & Technology (IET) เป็นระบบนิเวศอีคอมเมิร์ซที่รวมการทำงานและระบบอัตโนมัติการชำระเงินเพื่อทำให้การทำธุรกรรมระหว่างผู้ค้าและลูกค้าเป็นไปโดยอัตโนมัติ.",
            "MecoPay ช่วยประมวลผลและยืนยันการชำระเงินจากลูกค้าไปยังบัญชีผู้ค้าทันที และจะไม่ถือหรือเก็บเงินของลูกค้าหรือผู้ค้าไว้กับตนเอง."
          ],
          "items": []
        },
        {
          "heading": "2.2. การกำหนดเส้นทางอัตโนมัติและขีดจำกัดการทำธุรกรรม",
          "paragraphs": [],
          "items": [
            "MFS ส่วนบุคคล: ผู้ใช้สามารถใช้บัญชีโมบายแบงก์กิ้งส่วนบุคคลได้ สามารถตั้งหมายเลขส่วนตัวได้สูงสุด 2 หมายเลข เมื่อวงเงินของหมายเลขแรกถึงขีดจำกัด ระบบจะเปลี่ยนเส้นทางการชำระเงินไปยังหมายเลขที่สอง.",
            "API สำหรับผู้ค้า: หากต้องการทำธุรกรรมที่มีปริมาณมากเกินกว่าขีดจำกัดของบัญชีส่วนบุคคล จะต้องตั้งค่า Merchant API."
          ]
        },
        {
          "heading": "2.3. ข้อจำกัดความรับผิด (Limitation of Liability)",
          "paragraphs": [
            "หากมีการทำธุรกรรมเกินจำกัดหรือการใช้การเปลี่ยนเส้นทางอัตโนมัติบนบัญชี MFS ส่วนบุคคล ทำให้หน่วยงานโมบายแบงก์กิ้งที่เกี่ยวข้องจำกัด บล็อก หรือระงับบัญชี ความรับผิดชอบตกอยู่กับผู้ใช้ ในกรณีดังกล่าว MecoPay จะไม่รับผิดชอบทางกฎหมายหรือทางการเงิน."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "นโยบายการคืนเงิน (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. การคืนเงินค่าสมาชิก",
          "paragraphs": [
            "MecoPay ให้ทดลองใช้ฟรีแก่ผู้ใช้เพื่อทดสอบบริการ ดังนั้นเมื่อเริ่มการสมัครสมาชิกแบบชำระเงิน เช่น Basic หรือ Pro โดยทั่วไปค่าธรรมเนียมจะไม่คืนเงิน."
          ],
          "items": []
        },
        {
          "heading": "2. ในกรณีการคืนเงินลูกค้า ไม่มีค่าธรรมเนียมสำหรับผู้ค้า",
          "paragraphs": [
            "หากลูกค้าคืนสินค้า หรือขอคืนเงินมัดจำ ผู้ค้าหรือคลายแอนต์ต้องคืนเงินมัดจำเต็มจำนวนให้แก่ลูกค้า.",
            "เมื่อมีการยืนยันการคืนเงิน ค่าธรรมเนียมการทำธุรกรรมหรือค่าบริการที่ MecoPay เรียกเก็บจะไม่ถูกหักจากผู้ค้า หรือจะได้รับการยกเว้น."
          ],
          "items": []
        },
        {
          "heading": "3. กรณีพิเศษ (Exceptional Cases)",
          "paragraphs": [
            "ในกรณีต่อไปนี้ อาจพิจารณาคืนค่าธรรมเนียมการสมัครสมาชิกของ MecoPay:"
          ],
          "items": [
            "กรณีมีการเรียกเก็บเงินซ้ำเนื่องจากข้อผิดพลาดทางเทคนิคของระบบ.",
            "กรณีมีการขัดข้องหรือการหยุดทำงานที่ไม่คาดคิดเป็นระยะเวลานาน.",
            "หมายเหตุ: ความล่าช้าที่เกิดจากการที่เซิร์ฟเวอร์ของผู้ให้บริการโมบายแบงก์กิ้งของบุคคลที่สามล่ม ไม่อยู่ภายใต้เงื่อนไขนี้."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "นโยบายต่อต้านการทุจริตและสิทธิของลูกค้า",
      "alertTitle": "นโยบายต่อต้านการทุจริตแบบไม่อดทน",
      "alert": "เราดำเนินนโยบายไม่ยอมให้มีการทุจริตเพื่อคุ้มครองสิทธิของลูกค้า ในหน้าชำระเงินมีปุ่มรายงาน (Report); หากพบการทุจริตสามารถยื่นเรื่องโดยนำเสนอหลักฐานได้โดยตรง.",
      "sections": [
        {
          "heading": "1. กระบวนการยืนยันการจัดส่ง",
          "paragraphs": [],
          "items": [
            "สินค้าจริง: ไม่ว่าจะเป็นเว็บไซต์แบบคัสตอมหรือแบบโนโค้ด ต้องมีการเชื่อมต่อ delivery API เป็นข้อบังคับ ข้อมูลจาก courier API ทางแบ็กเอนด์จะถูกนำมาตรวจสอบแบบเรียลไทม์.",
            "สินค้าดิจิทัล: เมื่อมีข้อร้องเรียน จะมีการตรวจสอบด้วยตนเองโดยข้ามตรวจสอบระหว่างภาพหน้าจอของผู้ซื้อและผู้ขาย ข้อมูลแบรนด์ และ server log."
          ]
        },
        {
          "heading": "2. การลงโทษการทุจริตและมาตรการทางกฎหมาย",
          "paragraphs": [
            "หากมีการพิสูจน์ได้ว่าผู้ค้าหรือผู้ว่าจ้างรับเงินล่วงหน้าแต่ไม่ส่งสินค้า จะดำเนินการตามขั้นตอนต่อไปนี้:"
          ],
          "items": [
            "คำเตือนและการแก้ไข: หลังจากได้รับรายงาน จะมีการแจ้งพร้อมหลักฐาน หากไม่ยอมแก้ไข บัญชีจะถูกแบน.",
            "การแบนถาวร: หากข้อกล่าวหาพิสูจน์ได้ บัญชีจะถูกแบนถาวรและเอกสารประจำตัวจะถูกใส่บัญชีดำ (blacklisted).",
            "ภาระผูกพันการคืนเงิน: ผู้ค้าต้องรับผิดชอบในการคืนเงินเต็มจำนวนให้กับลูกค้า.",
            "การฟ้องร้องและดำเนินคดี: หากไม่คืนเงินหรือไม่ยอมแก้ไข จะมีการดำเนินคดีตามกฎหมายคุ้มครองผู้บริโภคและกฎหมายไซเบอร์ที่เกี่ยวข้อง."
          ]
        }
      ]
    },
    "docs": {
      "title": "เอกสาร API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "หลังจากล็อกอินและบันทึกรายละเอียดโปรไฟล์ ในส่วน Your MecoPay คุณสามารถไปที่ Documentation/Docs เพื่อดูเอกสาร API โดยละเอียดและตัวอย่าง JSON payload สำหรับเว็บไซต์ที่พัฒนาด้วย Laravel, Node.js หรือ Python.",
            "สำหรับการเชื่อมต่อกับ WordPress/WooCommerce ให้ไปที่ส่วน Plugin Apps & Plugin และสำหรับการทำงานอัตโนมัติของ Personal MFS ให้ดาวน์โหลด Sync App จากตำแหน่งเดียวกัน."
          ],
          "items": []
        }
      ]
    }
  },
  "uk": {
    "privacy": {
      "title": "Політика конфіденційності",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Яку інформацію ми збираємо",
          "paragraphs": [],
          "items": [
            "Ідентифікаційні документи та підтвердження: ваш національний ідентифікаційний номер (NID), фото NID, номер свідоцтва про народження (Birth Certificate), фото свідоцтва про народження та ваше фото паспортного розміру.",
            "Контактні дані: номер телефону, ім'я та адреса електронної пошти.",
            "Дані транзакцій: посилання на оплату, рахунки-фактури (invoice) та статус транзакції."
          ]
        },
        {
          "heading": "1.2. Двофакторна автентифікація (2FA) та безпека акаунту",
          "paragraphs": [
            "У MecoPay немає можливості створити акаунт традиційним способом за електронною поштою та паролем. Ви маєте отримувати доступ лише через захищений пристрій, пов'язаний із Google Account (вхід через Google)."
          ],
          "items": [
            "Доступ і захист 2-Step Verification: після входу через Google на нашій платформі ви можете активувати 2-Step Verification (TOTP). Навіть якщо хтось зламає ваш акаунт Gmail або дізнається ваш пароль від Gmail, без шестизначного коду в Google Authenticator ніхто не зможе увійти в ваш акаунт MecoPay.",
            "Рекомендації щодо біометрії: для повного захисту акаунту ми наполегливо рекомендуємо використовувати опцію відбитка пальця (Fingerprint) або інші біометричні методи у межах 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Політика єдиного акаунту та постійної блокування",
          "paragraphs": [
            "На нашій платформі за даними однієї особи можна створити лише один акаунт. У профілі входу передбачено два варіанти перевірки особи (до 18 років або старше 18 років):"
          ],
          "items": [
            "Понад 18 років: обов'язкове надання інформації та фото як NID, так і свідоцтва про народження (Birth Certificate). Після верифікації профілю ці документи будуть назавжди заблоковані в системі.",
            "До 18 років: верифікація акаунту можлива лише за даними та фото свідоцтва про народження. Надалі можна буде оновити NID, але інформація свідоцтва про народження залишиться назавжди заблокованою.",
            "Попередження: якщо, щоб уникнути NID, помилково вказати вік до 18 років, хоча насправді вам понад 18, профіль не буде верифіковано і може бути заблокований. Спроба створити другий акаунт з тими ж документами буде відхилена."
          ]
        },
        {
          "heading": "1.4. Безпека на рівні міжнародного банку",
          "paragraphs": [
            "Ми не йдемо на компроміси щодо безпеки даних клієнтів. Для захисту ваших даних MecoPay підтримує безпеку на рівні міжнародного банку."
          ],
          "items": [
            "Безпека фронтенду та edge (MecoPay Shield): через нашу глобальну edge-мережу трафік фронтенду і API шифрується та захищений від DDoS-атак.",
            "Безпека бекенду (Row Level Security - RLS): дані вашого акаунту зможете бачити тільки ви.",
            "End-to-end шифрування: кожне підключення між Android-додатком і сервером захищене підписом HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Зв'язок",
          "paragraphs": [
            "Якщо у вас є питання щодо цієї політики конфіденційності, зв'яжіться за адресою support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Умови та положення",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Опис послуги",
          "paragraphs": [
            "MecoPay — це універсальна (All-in-One) SaaS-платформа для електронної комерції, яка є спеціальною ініціативою Innovative Education & Technology (IET). Вона є екосистемою для автоматизації платежів та інтегрованої електронної торгівлі між продавцями та покупцями.",
            "MecoPay допомагає безпосередньо обробляти та верифікувати платежі від клієнта на рахунок продавця і не утримує кошти клієнтів чи продавців на власних рахунках."
          ],
          "items": []
        },
        {
          "heading": "2.2. Авто-маршрутизація та ліміти транзакцій",
          "paragraphs": [],
          "items": [
            "Персональний MFS: користувачі можуть використовувати персональні мобільні банківські акаунти. Можна встановити максимум 2 персональні номери; коли ліміт першого номера буде вичерпано, система перенаправить платіж на другий номер.",
            "API для продавців (Merchant API): якщо потрібні транзакції з обсягом, що перевищує ліміти персонального акаунту, необхідно налаштувати Merchant API."
          ]
        },
        {
          "heading": "2.3. Обмеження відповідальності (Limitation of Liability)",
          "paragraphs": [
            "Якщо через додаткові транзакції на персональному MFS-акаунті або використання авто-маршрутизації відповідні мобільні банківські органи обмежують, блокують або призупиняють акаунт, відповідальність несе користувач. У таких випадках MecoPay не несе жодної юридичної чи фінансової відповідальності."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Політика повернення коштів (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Повернення коштів за підписку",
          "paragraphs": [
            "MecoPay надає користувачам пробний період, щоб вони могли перевірити сервіс. Отже після початку платної підписки, такої як Basic або Pro, плата, як правило, підлягає поверненню."
          ],
          "items": []
        },
        {
          "heading": "2. У разі повернення коштів — нульова комісія для клієнта",
          "paragraphs": [
            "Якщо покупець повертає товар або вимагає повернення передоплати, клієнт/продавець зобов'язаний повернути всю суму авансу.",
            "Під час верифікації повернення MecoPay не утримає і не стягне з клієнта ту транзакційну чи сервісну комісію, яку він брав."
          ],
          "items": []
        },
        {
          "heading": "3. Виняткові випадки (Exceptional Cases)",
          "paragraphs": [
            "У наведених випадках можливе розгляд повернення плати за підписку MecoPay:"
          ],
          "items": [
            "У разі подвійного нарахування через технічну помилку системи.",
            "У разі тривалого неочікуваного простою або відсутності роботи.",
            "Примітка: затримки, спричинені збоєм серверів стороннього мобільного банківського провайдера, не підпадають під цю умову."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Політика протидії шахрайству та права клієнтів",
      "alertTitle": "Політика нульової толерантності щодо шахрайства",
      "alert": "Ми дотримуємось політики нульової толерантності для захисту прав клієнтів. На сторінці оформлення замовлення (Checkout page) є кнопка Report; у разі шахрайства можна негайно подати скаргу з доказами.",
      "sections": [
        {
          "heading": "1. Процедура перевірки доставки",
          "paragraphs": [],
          "items": [
            "Фізичний товар: незалежно від того, використовується кастомний чи no-code вебсайт, підключення delivery API є обов'язковим. Бекенд перевірятиме дані в режимі реального часу, отримані з courier API.",
            "Цифровий продукт: у разі скарги будуть вручну перевірені скріншоти покупця та продавця, дані бренду (brand data) та серверні логи шляхом перехресної перевірки."
          ]
        },
        {
          "heading": "2. Санкції за шахрайство та правові заходи",
          "paragraphs": [
            "Якщо буде доведено, що будь-який продавець або клієнт отримав аванс і не надав товар, будуть вжиті такі заходи:"
          ],
          "items": [
            "Попередження та вирішення: після отримання звіту нададуться докази; якщо не буде вирішення, акаунт буде заблоковано.",
            "Постійна заборона: якщо звинувачення підтвердяться, акаунт буде назавжди заблоковано, а ідентифікаційні документи внесено до чорного списку.",
            "Обов'язок повернення коштів: клієнт зобов'язаний самостійно повернути повну суму.",
            "Позови та правові заходи: якщо кошти не повернено або не досягнуто рішення, будуть вжиті дії відповідно до чинного законодавства про захист прав споживачів та кіберзаконодавства."
          ]
        }
      ]
    },
    "docs": {
      "title": "Документація API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Після входу та збереження даних профілю у розділі Your MecoPay в Documentation Docs ви зможете переглянути детальну документацію API та JSON payload для вебсайтів, створених на Laravel, Node.js або Python.",
            "Для інтеграції з WordPress/WooCommerce у розділі Plugin Apps & Plugin, а для автоматизації персонального MFS — Sync App можна завантажити в тому ж місці."
          ],
          "items": []
        }
      ]
    }
  },
  "pl": {
    "privacy": {
      "title": "Polityka prywatności",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Jakie informacje zbieramy",
          "paragraphs": [],
          "items": [
            "Dokumenty tożsamości i potwierdzenia: numer Twojego krajowego dowodu osobistego (NID), zdjęcie NID, numer aktu urodzenia (Birth Certificate), zdjęcie aktu urodzenia oraz Twoje zdjęcie paszportowe.",
            "Dane kontaktowe: numer telefonu, imię i nazwisko oraz adres e-mail.",
            "Dane transakcyjne: link do płatności, faktury oraz status transakcji."
          ]
        },
        {
          "heading": "1.2. Uwierzytelnianie dwuskładnikowe (2FA) i zabezpieczenie konta",
          "paragraphs": [
            "W MecoPay nie przewidziano tradycyjnego tworzenia konta za pomocą e-maila i hasła. Dostęp uzyskuje się wyłącznie za pomocą zabezpieczonego urządzenia powiązanego z Kontem Google (Google Sign-in)."
          ],
          "items": [
            "Ochrona dostępu i weryfikacji dwuetapowej: Po zalogowaniu za pomocą Google Sign-in możesz włączyć 2-Step Verification (TOTP). Nawet jeśli ktoś przełamie Twoje konto Gmail lub pozna hasło do Gmaila, bez 6-cyfrowego kodu weryfikacyjnego z Google Authenticator nikt nie będzie mógł uzyskać dostępu do Twojego konta MecoPay.",
            "Zalecenia dotyczące biometrii: Aby w pełni zabezpieczyć konto, zdecydowanie zalecamy użycie odcisku palca (Fingerprint) lub opcji biometrycznych przy weryfikacji 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Pojedyncze konto i polityka stałego zablokowania",
          "paragraphs": [
            "Na naszej platformie na podstawie danych jednej osoby można utworzyć tylko jedno konto. W profilu logowania dostępne są dwie opcje weryfikacji tożsamości (poniżej 18 lat lub powyżej 18 lat):"
          ],
          "items": [
            "Powyżej 18 lat: wymagane jest podanie danych i zdjęć zarówno NID, jak i aktu urodzenia (Birth Certificate). Po zweryfikowaniu profilu te dokumenty zostaną trwale zablokowane w systemie.",
            "Poniżej 18 lat: konto można zweryfikować wyłącznie za pomocą danych i zdjęcia aktu urodzenia. Później istnieje możliwość zaktualizowania NID, jednak dane aktu urodzenia pozostaną trwale zablokowane.",
            "Uwaga: jeśli osoba powyżej 18 roku życia poda błędny wiek w celu uniknięcia NID, konto nie zostanie zweryfikowane i może zostać zablokowane. Próba utworzenia drugiego konta tym samym dokumentem zostanie odrzucona."
          ]
        },
        {
          "heading": "1.4. Międzynarodowe zabezpieczenia na poziomie bankowym",
          "paragraphs": [
            "Nie idziemy na kompromisy w kwestii bezpieczeństwa danych klientów. MecoPay utrzymuje międzynarodowy poziom zabezpieczeń bankowych, aby chronić Twoje dane."
          ],
          "items": [
            "Bezpieczeństwo frontendu i edge (MecoPay Shield): ruch frontendu i API jest szyfrowany i chroniony przed atakami DDoS przez naszą globalną sieć edge.",
            "Bezpieczeństwo backendu (Row Level Security - RLS): dane Twojego konta są widoczne wyłącznie dla Ciebie.",
            "Szyfrowanie end-to-end: każde połączenie między aplikacją na Androida a serwerem zabezpieczone jest podpisem HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Kontakt",
          "paragraphs": [
            "W sprawach związanych z niniejszą polityką prywatności prosimy o kontakt pod adresem support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Warunki i zasady",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Opis usługi",
          "paragraphs": [
            "MecoPay to kompleksowa platforma e‑commerce typu SaaS (All-in-One), będąca inicjatywą Innovative Education & Technology (IET). Jest to ekosystem płatności i automatyzacji e‑commerce, który automatyzuje transakcje między merchantami a klientami.",
            "MecoPay pomaga przetwarzać i weryfikować płatności bezpośrednio z klienta na konto merchantu i nie zatrzymuje ani nie przechowuje środków żadnego klienta ani merchantu."
          ],
          "items": []
        },
        {
          "heading": "2.2. Automatyczne przekierowywanie i limity transakcji",
          "paragraphs": [],
          "items": [
            "Personalne MFS: użytkownicy mogą używać osobistych kont bankowości mobilnej. Można ustawić maksymalnie 2 numery personalne; gdy limit pierwszego numeru zostanie osiągnięty, system przekieruje płatność na drugi numer.",
            "Merchant API: jeśli potrzebne są transakcje o wolumenie przekraczającym limity kont personalnych, należy skonfigurować Merchant API."
          ]
        },
        {
          "heading": "2.3. Ograniczenie odpowiedzialności (Limitation of Liability)",
          "paragraphs": [
            "Jeżeli w wyniku dodatkowych transakcji na personalnym koncie MFS lub korzystania z automatycznego przekierowywania odpowiednie władze bankowości mobilnej ograniczą, zablokują lub zawieszą konto, odpowiedzialność ponosi użytkownik. W takich przypadkach MecoPay nie ponosi żadnej odpowiedzialności prawnej ani finansowej."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Polityka zwrotów (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Zwroty za subskrypcję",
          "paragraphs": [
            "MecoPay udostępnia użytkownikom darmowy okres próbny, aby mogli sprawdzić usługę. W związku z tym opłaty za płatne subskrypcje, takie jak Basic czy Pro, zazwyczaj nie podlegają zwrotowi po ich uruchomieniu."
          ],
          "items": []
        },
        {
          "heading": "2. Zero opłat dla klienta w przypadku zwrotu",
          "paragraphs": [
            "Jeśli klient zwróci produkt lub zażąda zwrotu płatności z góry, klient/merchant musi zwrócić pełną wpłaconą kwotę.",
            "W czasie weryfikacji zwrotu opłata transakcyjna lub opłata za usługę pobrana przez MecoPay nie zostanie potrącona ani nie będzie egzekwowana od klienta."
          ],
          "items": []
        },
        {
          "heading": "3. Przypadki wyjątkowe (Exceptional Cases)",
          "paragraphs": [
            "W poniższych przypadkach rozważany może być zwrot opłaty za subskrypcję MecoPay:"
          ],
          "items": [
            "W przypadku podwójnego naliczenia z powodu błędu technicznego systemu.",
            "W przypadku długotrwałych, nieoczekiwanych przerw lub przestojów.",
            "Uwaga: opóźnienia spowodowane awarią serwerów dostawcy bankowości mobilnej strony trzeciej nie wchodzą w zakres tego warunku."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Polityka antyfraudowa i prawa klienta",
      "alertTitle": "Polityka zero tolerancji wobec oszustw",
      "alert": "Stosujemy zasadę zerowej tolerancji w ochronie praw klientów. Na stronie realizacji płatności (Checkout) dostępny jest przycisk 'Report'; w przypadku oszustwa można złożyć bezpośrednie zgłoszenie wraz z dowodami.",
      "sections": [
        {
          "heading": "1. Proces weryfikacji dostawy",
          "paragraphs": [],
          "items": [
            "Produkty fizyczne: niezależnie od tego, czy używany jest serwis custom czy no-code, integracja z delivery API jest obowiązkowa. Backend będzie pobierać dane z API kuriera i weryfikować je w czasie rzeczywistym.",
            "Produkty cyfrowe: w przypadku reklamacji przeprowadza się ręczną weryfikację, porównując zrzuty ekranu kupującego i sprzedawcy, dane marki oraz logi serwera."
          ]
        },
        {
          "heading": "2. Sankcje za oszustwa i kroki prawne",
          "paragraphs": [
            "Jeśli zostanie udowodnione, że jakikolwiek merchant lub klient przyjął pieniądze z góry i nie dostarczył produktu, zostaną podjęte następujące kroki:"
          ],
          "items": [
            "Ostrzeżenie i rozwiązanie: po otrzymaniu zgłoszenia i dowodów zostanie ono przekazane; jeśli nie dojdzie do rozwiązania, konto zostanie zbanowane.",
            "Stały ban: jeśli zarzuty zostaną udowodnione, konto zostanie trwale zablokowane, a dokumenty tożsamości umieszczone na czarnej liście (blacklisted).",
            "Obowiązek zwrotu: klient będzie zobowiązany samodzielnie zwrócić pełną kwotę.",
            "Postępowanie sądowe i środki prawne: jeśli nie nastąpi zwrot pieniędzy lub nie zostanie znalezione rozwiązanie, podejmowane będą kroki zgodnie z obowiązującymi przepisami ochrony konsumentów i prawem dotyczącym przestępstw komputerowych."
          ]
        }
      ]
    },
    "docs": {
      "title": "Dokumentacja API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Po zalogowaniu i zapisaniu szczegółów profilu w sekcji Your MecoPay w Documentation Docs znajdziesz szczegółową Dokumentację API i przykładowe JSON payloady dla stron wykonanych w Laravel, Node.js lub Python.",
            "Integracje z WordPress/WooCommerce znajdziesz w sekcji Plugin Apps & Plugin, a do automatyzacji Personal MFS możesz pobrać Sync App z tego samego miejsca."
          ],
          "items": []
        }
      ]
    }
  },
  "el": {
    "privacy": {
      "title": "Πολιτική Απορρήτου",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Ποιες πληροφορίες συλλέγουμε",
          "paragraphs": [],
          "items": [
            "Ταυτότητα και αποδεικτικά: ο αριθμός του εθνικού σας ταυτότητας (NID), φωτογραφία του NID, ο αριθμός του πιστοποιητικού γέννησης (Birth Certificate), φωτογραφία του πιστοποιητικού γέννησης και φωτογραφία τύπου passport size.",
            "Στοιχεία επικοινωνίας: αριθμός τηλεφώνου, όνομα και διεύθυνση email.",
            "Δεδομένα συναλλαγών: σύνδεσμος πληρωμής, τιμολόγιο και κατάσταση συναλλαγής."
          ]
        },
        {
          "heading": "1.2. Έλεγχος δύο παραγόντων (2FA) και ασφάλεια λογαριασμού",
          "paragraphs": [
            "Στο MecoPay δεν υπάρχει δυνατότητα δημιουργίας λογαριασμού με παραδοσιακό email και κωδικό πρόσβασης. Πρέπει να αποκτάτε πρόσβαση μόνο μέσω ασφαλούς συσκευής συνδεδεμένης με Google Account (Google Sign-in)."
          ],
          "items": [
            "Πρόσβαση και ασφάλεια 2‑Step Verification: Μετά το Google Sign-in στην πλατφόρμα μας μπορείτε να ενεργοποιήσετε το 2‑Step Verification (TOTP). Ακόμη κι αν κάποιος παραβιάσει τον λογαριασμό Gmail σας ή μάθει τον κωδικό Gmail, δεν θα μπορεί να εισέλθει στον λογαριασμό σας στο MecoPay χωρίς τον 6ψήφιο κωδικό επαλήθευσης από το Google Authenticator.",
            "Σύσταση βιομετρικών: Για πλήρη ασφάλεια του λογαριασμού σας συνιστούμε έντονα τη χρήση επιλογών δακτυλικού αποτυπώματος (Fingerprint) ή άλλων βιομετρικών στο πλαίσιο του 2‑Step Verification."
          ]
        },
        {
          "heading": "1.3. Μοναδικός λογαριασμός και πολιτική μόνιμου κλειδώματος",
          "paragraphs": [
            "Στην πλατφόρμα μας με τα στοιχεία ενός φυσικού προσώπου μπορεί να δημιουργηθεί μόνο ένας λογαριασμός. Στο προφίλ σύνδεσης υπάρχουν δύο επιλογές για την επαλήθευση ταυτότητας (κάτω των 18 ετών ή άνω των 18 ετών):"
          ],
          "items": [
            "Άνω των 18 ετών: Απαιτείται υποχρεωτικά η παροχή πληροφοριών και φωτογραφιών τόσο του NID όσο και του πιστοποιητικού γέννησης (Birth Certificate). Μόλις επαληθευτεί το προφίλ, αυτά τα έγγραφα θα κλειδωθούν μόνιμα στο σύστημα.",
            "Κάτω των 18 ετών: Η επαλήθευση του λογαριασμού μπορεί να γίνει μόνο με την παροχή των στοιχείων και της φωτογραφίας του πιστοποιητικού γέννησης. Υπάρχει δυνατότητα μετέπειτα ενημέρωσης του NID, αλλά τα στοιχεία του πιστοποιητικού γέννησης θα παραμείνουν μόνιμα κλειδωμένα.",
            "Προειδοποίηση: Εάν, παρότι είστε άνω των 18, επιλέξετε λανθασμένα ηλικία για να αποφύγετε το NID, ο λογαριασμός δεν θα επαληθευτεί και μπορεί να μπλοκαριστεί. Η προσπάθεια δημιουργίας δεύτερου λογαριασμού με το ίδιο έγγραφο θα απορριφθεί."
          ]
        },
        {
          "heading": "1.4. Ασφάλεια επιπέδου διεθνούς τράπεζας",
          "paragraphs": [
            "Δεν συμβιβαζόμαστε με την ασφάλεια των δεδομένων των πελατών. Το MecoPay διατηρεί ασφάλεια επιπέδου διεθνούς τράπεζας για να προστατεύει τα δεδομένα σας."
          ],
          "items": [
            "Ασφάλεια frontend και edge (MecoPay Shield): Μέσω του παγκόσμιου edge δικτύου μας, η κίνηση του frontend και του API είναι κρυπτογραφημένη και προστατεύεται από επιθέσεις DDoS.",
            "Ασφάλεια backend (Row Level Security - RLS): Τα δεδομένα του λογαριασμού σας μπορεί να τα δει αποκλειστικά εσείς.",
            "Κρυπτογράφηση από άκρο σε άκρο: Κάθε σύνδεση της εφαρμογής Android και του διακομιστή προστατεύεται με υπογραφή HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. Επικοινωνία",
          "paragraphs": [
            "Για ερωτήσεις σχετικά με αυτή την πολιτική απορρήτου επικοινωνήστε στο support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Όροι και Προϋποθέσεις",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Περιγραφή υπηρεσίας",
          "paragraphs": [
            "Το MecoPay είναι μια ολοκληρωμένη (All-in-One) πλατφόρμα e‑commerce SaaS, μια ειδική πρωτοβουλία της Innovative Education & Technology (IET). Πρόκειται για ένα σύστημα αυτοματοποίησης πληρωμών και ενσωματωμένο οικοσύστημα ηλεκτρονικού εμπορίου που αυτοματοποιεί τις συναλλαγές μεταξύ εμπόρων και πελατών.",
            "Το MecoPay βοηθά στην επεξεργασία και επαλήθευση πληρωμών απευθείας από τον πελάτη στον λογαριασμό του εμπόρου και δεν κρατά ούτε συγκεντρώνει τα χρήματα οποιουδήποτε πελάτη ή εμπόρου."
          ],
          "items": []
        },
        {
          "heading": "2.2. Αυτόματη δρομολόγηση και όρια συναλλαγών",
          "paragraphs": [],
          "items": [
            "Προσωπικό MFS: Οι χρήστες μπορούν να χρησιμοποιούν προσωπικό λογαριασμό mobile banking. Μπορούν να ρυθμίσουν έως δύο προσωπικούς αριθμούς· όταν εξαντληθεί το όριο του πρώτου αριθμού, το σύστημα θα δρομολογεί την πληρωμή στον δεύτερο αριθμό.",
            "Merchant API: Εάν απαιτούνται συναλλαγές με όγκο μεγαλύτερο από τα όρια ενός προσωπικού λογαριασμού, θα πρέπει να ρυθμιστεί Merchant API."
          ]
        },
        {
          "heading": "2.3. Περιορισμός ευθύνης (Limitation of Liability)",
          "paragraphs": [
            "Σε περίπτωση που λόγω επιπλέον συναλλαγών σε προσωπικό MFS λογαριασμό ή χρήσης αυτόματης δρομολόγησης οι αρμόδιες αρχές του mobile banking περιορίσουν, μπλοκάρουν ή αναστείλουν τον λογαριασμό, η ευθύνη βαρύνει τον χρήστη. Το MecoPay δεν θα ευθύνεται νομικά ή οικονομικά για τέτοιου είδους περιστατικά."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Πολιτική Επιστροφών (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Επιστροφή συνδρομής",
          "paragraphs": [
            "Το MecoPay παρέχει δωρεάν δοκιμή στους χρήστες ώστε να μπορούν να ελέγξουν την υπηρεσία. Επομένως, μετά την έναρξη μιας επί πληρωμή συνδρομής όπως Basic ή Pro, τα τέλη κατά κανόνα δεν επιστρέφονται."
          ],
          "items": []
        },
        {
          "heading": "2. Μηδενική χρέωση για τον πελάτη σε περίπτωση επιστροφής",
          "paragraphs": [
            "Εάν ο πελάτης επιστρέψει κάποιο προϊόν ή ζητήσει επιστροφή προκαταβολής, ο πελάτης/έμπορος οφείλει να επιστρέψει πλήρως το ποσό που είχε εισπραχθεί προκαταβολικά.",
            "Κατά την επαλήθευση της επιστροφής, τυχόν τέλη συναλλαγής ή υπηρεσίας που είχε εισπράξει το MecoPay δεν θα αφαιρούνται εκ νέου από τον πελάτη/έμπορο ή δεν θα επιβάλλονται. "
          ],
          "items": []
        },
        {
          "heading": "3. Εξαιρετικές περιπτώσεις (Exceptional Cases)",
          "paragraphs": [
            "Σε παρακάτω περιπτώσεις μπορεί να εξεταστεί επιστροφή των τελών συνδρομής του MecoPay:"
          ],
          "items": [
            "Σε περίπτωση διπλής χρέωσης λόγω τεχνικού σφάλματος του συστήματος.",
            "Σε περίπτωση μακροχρόνιας απροσδόκητης διακοπής λειτουργίας (outage) ή downtime.",
            "Σημείωση: Καθυστέρηση λόγω πτώσης των δικών τους servers του παρόχου mobile banking τρίτου μέρους δεν καλύπτεται από αυτή την προϋπόθεση."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Πολιτική Anti-Fraud & Δικαιώματα Πελατών",
      "alertTitle": "Πολιτική μηδενικής ανοχής κατά της απάτης",
      "alert": "Ακολουθούμε πολιτική μηδενικής ανοχής στην προάσπιση των δικαιωμάτων των πελατών. Στη σελίδα Checkout υπάρχει κουμπί Report: σε περίπτωση απάτης μπορεί να υποβληθεί άμεσα καταγγελία με στοιχεία/αποδείξεις.",
      "sections": [
        {
          "heading": "1. Διαδικασία επαλήθευσης παράδοσης",
          "paragraphs": [],
          "items": [
            "Φυσικό προϊόν: Ανεξάρτητα από το αν χρησιμοποιείται custom ή no-code ιστότοπος, η σύνδεση με το delivery API είναι υποχρεωτική. Το backend θα λαμβάνει δεδομένα από το courier API και θα επαληθεύει σε πραγματικό χρόνο.",
            "Ψηφιακό προϊόν: Σε περίπτωση καταγγελίας, θα γίνει χειροκίνητος έλεγχος με συγκρίσεις (cross-check) των screenshot του αγοραστή και του πωλητή, των στοιχείων της μάρκας (brand data) και των server logs."
          ]
        },
        {
          "heading": "2. Κυρώσεις για απάτη και νομικά μέτρα",
          "paragraphs": [
            "Σε περίπτωση απόδειξης ότι οποιοσδήποτε merchant ή client πήρε προκαταβολή και δεν παρείχε το προϊόν, θα ληφθούν τα ακόλουθα μέτρα:"
          ],
          "items": [
            "Προειδοποίηση και επίλυση: Μετά την υποβολή αναφοράς θα κοινοποιηθεί με αποδεικτικά στοιχεία· εφόσον δεν υπάρχει λύση, ο λογαριασμός θα απαγορευτεί (ban).",
            "Μόνιμο ban: Εάν η καταγγελία αποδειχθεί, ο λογαριασμός θα απαγορευτεί οριστικά και τα έγγραφα ταυτότητας θα μπουν σε blacklist.",
            "Υποχρέωση επιστροφής: Ο client θα πρέπει να επιστρέψει πλήρως το ποσό με δική του ευθύνη.",
            "Δικαστικά και νομικά μέτρα: Εάν δεν επιστραφούν τα χρήματα ή δεν υπάρξει λύση, θα κινηθούν διαδικασίες σύμφωνα με τη νομοθεσία περί προστασίας καταναλωτών και τους νόμους περί κυβερνοχώρου (cyber law)."
          ]
        }
      ]
    },
    "docs": {
      "title": "Τεκμηρίωση API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Μετά από σύνδεση και αποθήκευση των λεπτομερειών του προφίλ, στην ενότητα Your MecoPay μπορείτε στο Documentation Docs να δείτε λεπτομερή API Documentation και JSON payload για ιστότοπους που έχουν κατασκευαστεί με Laravel, Node.js ή Python.",
            "Για ενσωμάτωση WordPress/WooCommerce μπορείτε να κάνετε λήψη από την ενότητα Plugin Apps & Plugin, ενώ για αυτοματισμό Personal MFS μπορείτε να κατεβάσετε την εφαρμογή Sync App από το ίδιο σημείο."
          ],
          "items": []
        }
      ]
    }
  },
  "he": {
    "privacy": {
      "title": "מדיניות פרטיות",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. אילו פרטים אנו אוספים",
          "paragraphs": [],
          "items": [
            "תעודות זהות והוכחות: מספר תעודת הזהות הלאומית (NID), תמונת ה-NID, מספר רישום הלידה (Birth Certificate), תמונת רישום הלידה ותמונת פספורט בגודל דרכון.",
            "פרטי קשר: מספר טלפון, שם וכתובת אימייל.",
            "נתוני טרנזקציה: קישור תשלום, חשבונית ומצב הטרנזקציה."
          ]
        },
        {
          "heading": "1.2. אימות דו-שלבי (2FA) ואבטחת חשבון",
          "paragraphs": [
            "ב-MecoPay לא קיימת אפשרות לפתוח חשבון ישירות באמצעות אימייל וסיסמה מסורתיים. יש לגשת אך ורק דרך מכשיר מאובטח שמחובר ל-Google Account (Google Sign-in)."
          ],
          "items": [
            "אבטחת גישה ואימות דו-שלבי: לאחר כניסה דרך Google Sign-in בפלטפורמה שלנו תוכלו להפעיל 2-Step Verification (TOTP). במצב שבו מישהו יפרוץ לחשבון ה-Gmail שלכם או ידע את סיסמת ה-Gmail שלכם, עדיין לא יוכל להיכנס לחשבון ה-MecoPay שלכם ללא קוד האימות בן 6 הספרות של Google Authenticator.",
            "המלצה על ביומטריה: כדי לאבטח את חשבונכם במלואו, אנו ממליצים בחוזקה להשתמש באופציות ביומטריות כגון טביעת אצבע (Fingerprint) עבור 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. מדיניות חשבון יחיד ונעילה קבועה",
          "paragraphs": [
            "בפלטפורמה שלנו ניתן לפתוח חשבון אחד בלבד לפרט. בפרופיל ההתחברות יש שתי אפשרויות לאימות זהות (מתחת לגיל 18 או מעל גיל 18):"
          ],
          "items": [
            "מעל גיל 18: חובה לספק הן את פרטי ותמונת ה-NID והן את פרטי ותמונת רישום הלידה (Birth Certificate). עם אימות הפרופיל, מסמכים אלה יינעלו במערכת לצמיתות.",
            "מתחת לגיל 18: ניתן לאמת את החשבון אך ורק באמצעות פרטי ותמונת רישום הלידה. יהיה ניתן לעדכן מאוחר יותר את ה-NID, אולם פרטי רישום הלידה יינעלו במערכת לצמיתות.",
            "אזהרה: אם מעל גיל 18 תבחרו בטעות גיל נמוך כדי להימנע מ-NID, החשבון לא יאומת ועלול להיחסם. ניסיון לפתוח חשבון שני עם אותו מסמך יבוטל."
          ]
        },
        {
          "heading": "1.4. אבטחה ברמת בנקים בינלאומית",
          "paragraphs": [
            "אנו לא מתפשרים על אבטחת נתוני הלקוחות. על מנת להגן על המידע שלכם, MecoPay שומרת על אבטחה ברמת בנקים בינלאומית."
          ],
          "items": [
            "אבטחת Frontend ו-Edge (MecoPay Shield): תעבורת ה-Frontend וה-API מוצפנת ומוגנת מפני התקפות DDoS באמצעות רשת הקצה הגלובלית שלנו.",
            "אבטחת Backend (Row Level Security - RLS): רק אתם יכולים לצפות בנתוני החשבון שלכם.",
            "הצפנה מקצה לקצה: כל חיבור בין אפליקציית אנדרואיד לשרת מוגן באמצעות חתימת HMAC SHA-256."
          ]
        },
        {
          "heading": "1.5. יצירת קשר",
          "paragraphs": [
            "לשאלות בנוגע למדיניות פרטיות זו פנו ל-support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "תנאים והגבלות",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. תיאור השירות",
          "paragraphs": [
            "MecoPay היא פלטפורמת e-commerce מסוג All-in-One SaaS, היוזמה מיוחדת של Innovative Education & Technology (IET). זוהי מערכת אקוסיסטם משולבת לאוטומציה של תשלומים ולניהול מסחר בין סוחרים ללקוחות.",
            "MecoPay מסייעת בעיבוד ואימות תשלומים ישירות מחשבון הלקוח לחשבון הסוחר ואינה מחזיקה או מאחסנת כספים של לקוחות או סוחרים."
          ],
          "items": []
        },
        {
          "heading": "2.2. ניתוב אוטומטי ומגבלות עסקה",
          "paragraphs": [],
          "items": [
            "MFS פרסונלי: משתמשים יוכלו להשתמש בחשבונות בנק נייד פרסונליים. ניתן להגדיר עד 2 מספרים אישיים; כאשר המגבלה של המספר הראשון תסתיים, המערכת תנתב תשלומים למספר השני.",
            "API לסוחרים: אם נדרש נפח עסקאות העולה על מגבלות החשבון הפרסונלי, יש להגדיר Merchant API."
          ]
        },
        {
          "heading": "2.3. הגבלת אחריות (Limitation of Liability)",
          "paragraphs": [
            "אם רשות הבנקאות הניידת תגביל, תחסום או תשהה חשבון בעקבות תשלומי יתר או שימוש בניווט אוטומטי בחשבון MFS פרסונלי, האחריות תהיה על המשתמש. בשל מקרים כאלה MecoPay לא תהיה אחראית משפטית או כספית."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "מדיניות החזר כספי (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. החזרי מנויים",
          "paragraphs": [
            "MecoPay מספקת למשתמשים ניסיון חינם כדי לבדוק את השירות. לכן, לאחר התחלת מנוי בתשלום כגון Basic או Pro, בדרך כלל דמי המנוי אינם ניתנים להחזר."
          ],
          "items": []
        },
        {
          "heading": "2. החזר ללקוח ללא חיוב נוסף",
          "paragraphs": [
            "אם לקוח מחזיר מוצר או מבקש החזר עבור תשלום מראש, הלקוח/הסוחר חייב להחזיר את כל התשלום המוקדם במלואו.",
            "במהלך אימות ההחזר, כל עמלות עסקה או שירות ש-MecoPay גבתה לא יוחסרו או ינוכו מהלקוח."
          ],
          "items": []
        },
        {
          "heading": "3. מקרים חריגים (Exceptional Cases)",
          "paragraphs": [
            "במקרים הבאים ניתן לשקול החזר דמי מנוי של MecoPay:"
          ],
          "items": [
            "במקרה של חיוב כפול עקב תקלה טכנית במערכת.",
            "במקרה של השבתה או אאוטייג ארוך ובלתי צפוי.",
            "הערה: עיכובים הנובעים מהשבתת שרתים של ספקי בנקאות ניידת צד שלישי אינם נכללים בתנאי זה."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "מדיניות נגד הונאה וזכויות הלקוח",
      "alertTitle": "מדיניות אפס-סובלנות נגד הונאות",
      "alert": "אנו דבקים במדיניות אפס-סובלנות להגנת זכויות הלקוחות. בדף התשלום יש כפתור Report; במקרה של הונאה ניתן להגיש תלונה ישירות עם ראיות.",
      "sections": [
        {
          "heading": "1. תהליך אימות משלוח",
          "paragraphs": [],
          "items": [
            "מוצרים פיזיים: בין אם מדובר באתר מותאם אישית או אתר ללא קוד, חיבור ל-delivery API הינו חובה. ה-backend יבדוק בזמן אמת נתונים מה-courier API.",
            "מוצרים דיגיטליים: במקרה של תלונה יבוצע אימות ידני על ידי בדיקה חוצת-התאמה של צילומי מסך של הקונה והמוכר, נתוני המותג ויומני השרת (server log)."
          ]
        },
        {
          "heading": "2. עונשים וצעדים משפטיים על הונאה",
          "paragraphs": [
            "אם יתברר שסוחר או לקוח קיבל תשלום מראש ולא סיפק את המוצר, ינקטו הצעדים הבאים:"
          ],
          "items": [
            "אזהרה ופתרון: עם קבלת הדיווח יועברו הראיות; אם לא יתקבל פתרון החשבון ייחסם.",
            "חסימה קבועה: אם הטענה תוכח, החשבון ייחסם לצמיתות ותעודת הזהות תתווסף לרשימה שחורה.",
            "חובת החזר: הלקוח יהיה חייב להחזיר את מלוא הסכום באחריותו.",
            "תביעה ופעולה משפטית: אם לא יוחזר הכסף או לא יימצא פתרון, ינקטו צעדים בהתאם לחוקי הגנת הצרכן ולדיני סייבר הרלוונטיים."
          ]
        }
      ]
    },
    "docs": {
      "title": "תיעוד API",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "לאחר כניסה ושמירת פרטי הפרופיל, בסעיף Your MecoPay בתיעוד (Documentation Docs) תוכלו לצפות בתיעוד API מפורט וב-JSON payload עבור אתרי אינטרנט שנבנו ב-Laravel, Node.js או Python.",
            "לשילוב עם WordPress/WooCommerce ניתן להוריד בקטגוריית Plugin Apps & Plugin, ולעבור לאוטומציה של Personal MFS ניתן להוריד את ה-Sync App מאותו מקום."
          ],
          "items": []
        }
      ]
    }
  },
  "si": {
    "privacy": {
      "title": "ගෝපීයතා ප්‍රතිපත්තිය",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. අපි රැස් කරගන්නා තොරතුරු",
          "paragraphs": [],
          "items": [
            "හැඳුනුම් පත් හා සාක්ෂි: ඔබගේ ජාතික හැඳුනුම්පත් (NID) අංකය, NID-යේ ඡායාරූපය, උපන් ලේඛනය (Birth Certificate) අංකය, උපන් ලේඛනයේ ඡායාරූපය හා ඔබගේ පාස්පෝර්ට් ප්‍රමාණයේ ඡායාරූපය.",
            "සම්බන්ධතා තොරතුරු: දුරකථන අංකය, නම සහ ඊ‑මේල් ලිපිනය.",
            "ගනුදෙනු දත්ත: ගෙවීම් සබැඳි, ඉන්වොයිස් සහ ගනුදෙනු තත්ත්වය."
          ]
        },
        {
          "heading": "1.2. දෙක-හරස් ආධාරක අධිකරණය (2FA) සහ ගිණුම් ආරක්ෂාව",
          "paragraphs": [
            "MecoPay හි ගිණුම් ආරක්ෂාව සඳහා සාම්ප්‍රදායික ඊ‑මේල් හා මුරපද භාවිතයෙන් සෘජුව ගිණුමක් විවෘත කිරීමේ බෙහෙවින් ක්‍රමයක් නොමැත. ඔබට Google Account (Google sign‑in) එක්කර ඇති ආරක්ෂිත උපාංගයක් හරහා පමණක් ප්‍රවේශ විය යුතුය."
          ],
          "items": [
            "ප්‍රවේශය සහ 2‑Step Verification ආරක්ෂාව: අපගේ වේදිකාවට Google sign‑in කිරීමෙන් පසුව ඔබට 2‑Step Verification (TOTP) සක්‍රීය කළ හැක. අනපේක්ෂිත තත්ත්වයකදී කිසිවෙක් ඔබගේ Gmail ගිණුම හෑක් කළහොත් හෝ Gmail මුරපදය දැනගත්තහොත් පවා, Google Authenticator හි 6 අංක TOTP වරප්‍රසාද කේතයකින් තොරව ඔබගේ MecoPay ගිණුමට පිවිසීමට කිසිවෙක් නොහැකි වේ.",
            "ජීවගුණික (Biometric) නිර්දේශය: ඔබගේ ගිණුම සම්පූර්ණයෙන් ආරක්ෂා කර ගැනීමට 2‑Step Verification සඳහා Fingerprint (අංගවිකල්ප) හෝ වෙනත් ජීවගුණික විකල්ප භාවිත කිරීමට අපි දැඩි ලෙස නිර්දේශ කරමු."
          ]
        },
        {
          "heading": "1.3. ඒකල ගිණුම සහ ස්ථිර ලොක් ප්‍රතිපත්තිය",
          "paragraphs": [
            "අපගේ වේදිකාවෙන් එක් පුද්ගලයකුගේ තොරතුරු මත එක් ගිණුමක් පමණක් විවෘත කළ හැක. ලොගින් පැතිකඩේ හැඳුනුම් සත්‍යාපනය සඳහා විකල්ප දෙකක් ඇත (වයස 18ට අඩු හෝ 18ට ඉහළ):"
          ],
          "items": [
            "18ට ඉහළ: NID හා උපන් ලේඛනය (Birth Certificate) දෙකම පිළිබඳ තොරතුරු සහ ඡායාරූප ඉදිරිපත් කිරීම අවශ්‍ය වේ. එක් වරක් පැතිකඩ සත්‍යාපිත කරන ලද්දහොත් මෙම ලේඛන පද්ධතිය තුළ ස්ථිරව ලොක් කරනු ලැබේ.",
            "18ට අඩු: උපන් ලේඛනයේ තොරතුරු සහ ඡායාරූප පමණක් ඉදිරිපත් කර ගිණුම සත්‍යාපනය කළ හැක. පසුව NID යාවත්කාලීන කිරීමේ අවස්ථාව තිබේ, නමුත් උපන් ලේඛන තොරතුර ස්ථිරව ලොක් කරනු ලබයි.",
            "සත්‍යපාරකය: වයස 18ට ඉහළ වූවත් NID වලගැටළු වලින් වලක්වීමට වැරදි වයස තෝරාගත්හොත් ගිණුම සත්‍යාපනය නොවී අවහිර විය හැක. ඒකම ලේඛන භාවිතයෙන් දෙවන ගිණුමක් විවෘත කිරීම උත්සාහ කිරීම වළක්වනු ලැබේ."
          ]
        }
      ]
    },
    "terms": {
      "title": "නියම සහ කොන්දේසි",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. සේවා විස්තරය",
          "paragraphs": [
            "MecoPay යනු All‑in‑One විශේෂිත e‑commerce SaaS වේදිකාවකි, එය Innovative Education & Technology (IET) හි විශේෂ උත්සාහයකි. මෙය වෙළෙන්දෝ හා ගනුදෙනුකරුවන් අතර ගනුදෙනු ස්වයංක්‍රීය කිරීමට බෙහෙවින් උපකාරී payment automation හා ඒකාබද්ධ e‑commerce පරිසරයකි.",
            "MecoPay විසින් ගනුදෙනුකරුවෙකුගෙන් වෙළෙන්දෝගේ ගිණුමට සෘජුව ගෙවීම් සැකසීම සහ සත්‍යාපනය කිරීම සඳහා උදව් කරයි; කිසිදු ගනුදෙනුකරු හෝ වෙළෙන්දෝගේ මුදල් අප වෙත තබා නොගනී. "
          ],
          "items": []
        },
        {
          "heading": "2.2. ස්වයංක්‍රීය නැවත දෙසවන හා ගනුදෙනු සීමා",
          "paragraphs": [],
          "items": [
            "Personal MFS: පරිශීලකයන්ට තමන්ගේ Personal mobile banking ගිණුම් භාවිතා කළ හැක. උපරිම දවස් 2ක් පරිශීලක පුද්ගලික නම්බර් ලෙස සකස් කළ හැක; පළමු නම්බරයේ සීමාව පිරුණු විට පද්ධතිය දෙවන නම්බරයට ගෙවීම් reroute කරනු ඇත.",
            "Merchant API: පුද්ගලික ගිණුමේ සීමාවට වඩා වැඩි ප්‍රමාණයේ ගනුදෙනු අවශ්‍ය නම් Merchant API සකස් කළ යුතුය."
          ]
        },
        {
          "heading": "2.3. වගකීම් සීමා (Limitation of Liability)",
          "paragraphs": [
            "Personal MFS ගිණුමෙහි අතිරික්ත ගනුදෙනු හෝ ස්වයංක්‍රීය නැවත දෙසවන භාවිතය හේතුවෙන් අදාල mobile banking අධිකාරිය ගිණුම සීමා, අවහිර හෝ තාවකාලිකව අවලංගු කරන ලෙස ක්‍රියා කළහොත් එම්බස් වගකීම පරිශීලකයාට අයත් වේ. එවැනි අවස්ථාවන් සඳහා MecoPay කිසිදු නීතිමය හෝ මූල්‍ය වගකීමක් නොගෙන සිටින්නේය."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "පිළිතුරු ප්‍රතිපත්ති (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. සබ්ස්ක්‍රිප්ශන් ප්‍රතිපත්ති",
          "paragraphs": [
            "MecoPay පරිශීලකයින්ට සේවාව පරීක්ෂා කිරීමට නිදහස් ට්‍රයල් පහසුකමක් සපයයි. ඒනිසා Basic හෝ Pro වැනි මුදල් ගෙවන subscription ආරම්භ වූ පසු සාමාන්‍යයෙන් ගෙවීම් මුදල් ආපසු දීම අසම්භවික වේ."
          ],
          "items": []
        },
        {
          "heading": "2. ප්‍රතිචාර සඳහා ගනුදෙනුකරුට ශුන්‍ය පිරිවැය",
          "paragraphs": [
            "ගනුදෙනුකරු නිෂ්පාදනය ආපසු යොමු කලහොත් හෝ ආග්‍රමික ගෙවීම් ප්‍රතිචාරයක් අවශ්‍ය නම් client/merchant විසින් මුල් මුදල සම්පූර්ණයෙන් ආපසු ලබාදිය යුතුය.",
            "ප්‍රතිචාර සත්‍යාපනය කිරීමේදී MecoPay විසින් ගෙන තිබූ ගනුදෙනු හෝ සේවා ගාස්තු client වෙතින් නැවත කැප නොකරනු ලැබේ හෝ මකා දමනු ලැබේ."
          ],
          "items": []
        },
        {
          "heading": "3. විශේෂ අවස්ථා (Exceptional Cases)",
          "paragraphs": [
            "පහත සඳහන් අවස්ථාවන්හිදී MecoPay විසින් subscription ගාස්තුව ප්‍රතිචාර කිරීම සලකා බලනු ඇත:"
          ],
          "items": [
            "පද්ධති තාක්ෂණික දෝෂයක් හේතුවෙන් ද්විත්ව බිල්පත කිරීම සිදුවුනහොත්.",
            "දිගු කාලීන අප්‍රत्याशිත outage හෝ downtime ඇති වූ විට.",
            "සටහන: තෙවන පාර්ශවීය mobile banking සපයන්නාගේ තම සේවාදායක (server) downtime හේතුවෙන් ඇති වූ ප්‍රමාද මෙම කොන්දේසියේ අඩංගු නොවේ."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "වංචා විරෝධී සහ පාරිභෝගික අයිතිවාසිකම් ප්‍රතිපත්තිය",
      "alertTitle": "ශුන්‍ය‑සහාන වංචා විරුද්ධ ප්‍රතිපත්තිය",
      "alert": "අපි පාරිභෝගිකයින්ගේ අයිතිවාසිකම් ආරක්ෂා කිරීම සඳහා ශුන්‍ය‑සහන නීතිය අනුගමනය කරමු. Checkout page-ෙහි Report button තිබේ; වංචාවක් සිදුවුවහොත්, සාක්ෂි සමඟ සෘජුව උද්ඝෝෂණය කළ හැක.",
      "sections": [
        {
          "heading": "1. බෙදාහැරීම සත්‍යාපන ක්‍රියාවලිය",
          "paragraphs": [],
          "items": [
            "භෞතික නිෂ්පාදන: custom හෝ no‑code වෙබ් අඩවිය ඕනෑම වුවත්, delivery API අනු සම්බන්ධ කිරීම අනිවාර්ය වේ. Backend courier API මඟින් දත්ත ලබාගෙන real‑time පරික්ෂා කරනු ඇත.",
            "ඩිජිටල් නිෂ්පාදන: පැමිණිල්ලක් ලැබුණු විට ග купить/විකිණීමකරුගේ ස්ක්‍රීන්ශොට්, brand data සහ server log හරිහැටි cross‑check කරමැනුවෙන් පරික්ෂා කරනු ලැබේ."
          ]
        },
        {
          "heading": "2. වංචාව සඳහා මෙන්ම නීතිමය පිලිවෙත්",
          "paragraphs": [
            "සාක්ෂි සමඟ ස්ථිර වන්නේ නම් කිසිඳු merchant හෝ client විසින් අගරැව මුදල් ගෙන නිෂ්පාදන ලබාදි නොමැති නම් පහත පියවර ගනු ලැබේ:"
          ],
          "items": [
            "අවවාද හා විසඳුම: පැමිණිල්ල ලැබුණු පසු සාක්ෂි සමඟ දැනුම් දෙමින් විසඳුම සැපයීමට කටයුතු කොට නැතිනම් ගිණුම ban කරනු ලැබේ.",
            "ස්ථිරවම Ban: පැමිණිල්ල සාක්ෂි මත සත්‍ය ලෙස සාධක කළහොත් ගිණුම ස්ථිරවම ban කරනු ලැබේ සහ හැඳුනුම් ලේඛන blacklisted කෙරේ.",
            "ප්‍රතිචාර බද්ධතාව: client තම වගකීමෙහි සිට සම්පූර්ණ මුදල ආපසු ලබා දිය යුතුය.",
            "දෙස්පාලන හා නීතිමය ක්‍රියාමාර්ග: මුදල් ආපසු නොදැක්වුවහොත් හෝ විසඳුමක් නොලැබුණහොත් ප්‍රචලිත consumer protection සහ cyber law යටතේ ක්‍රියාමාර්ග ගනු ලැබේ."
          ]
        }
      ]
    },
    "docs": {
      "title": "API Documentation",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "ලොගීන් වී profile details save කිරීමෙන් පසුව Your MecoPay කොටසෙන් Documentation Docs යටතේ Laravel, Node.js හෝ Python භාවිතයෙන් සාදා ඇති වෙබ්අඩවි සඳහා විස්තරාත්මක API Documentation සහ JSON payload ඔබට බැලිය හැක.",
            "WordPress/WooCommerce integration සඳහා Plugin Apps & Plugin කොටසෙන් සහ Personal MFS automation සඳහා Sync App එක එම ස්ථානයෙන් download කළ හැක."
          ],
          "items": []
        }
      ]
    }
  },
  "ne": {
    "privacy": {
      "title": "गोपनीयता नीति",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. हामी कुन-कुन जानकारी सङ्कलन गर्छौं",
          "paragraphs": [],
          "items": [
            "पहिचान पत्र र प्रमाण: तपाईंको राष्ट्रिय परिचयपत्र (NID) नम्बर, NID को तस्बिर, जन्म दर्ता (Birth Certificate) नम्बर, जन्म दर्ता को तस्बिर र तपाईंको पासपोर्ट साइजको फोटो।",
            "सम्पर्क जानकारी: फोन नम्बर, नाम र इमेल ठेगाना।",
            "लेनदेन डेटा: पेमेन्ट लिंक, इनभ्वाइस र लेनदेन स्थिति।"
          ]
        },
        {
          "heading": "1.2. दुई-तह प्रमाणीकरण (2FA) र खाताको सुरक्षा",
          "paragraphs": [
            "MecoPay मा खाताको सुरक्षा लागि पारम्परिक इमेल र पासवर्डले सिधै खाता खोल्ने व्यवस्था गरिएको छैन। तपाईंले केवल Google Account (गुगल साइन-इन) जोडिएको सुरक्षित डिभाइसबाट पहुँच गर्नुपर्नेछ।"
          ],
          "items": [
            "पहुँच र 2-Step भेरिफिकेशन सुरक्षा: हाम्रो प्लेटफर्ममा गुगल साइन-इन गरेपछि तपाईं 2-Step Verification (TOTP) सक्रिय गर्न सक्नुहुन्छ। कुनै अवाञ्छित परिस्थितिमा यदि कसैले तपाईंको जीमेल अकाउन्ट ह्याक गर्‍यो वा तपाईंको जीमेल पासवर्ड थाहा पाए पनि, तपाईंको Google Authenticator को 6 अंकको भेरिफिकेशन कोडबिना अरू कसैले तपाईंको MecoPay खाता प्रवेश गर्न सक्दैन।",
            "बायोमेट्रिक सिफारिस: तपाईंको खातालाई पूर्ण रूपमा सुरक्षित राख्न हामी 2-Step Verificationमा फिंगरप्रिन्ट (Fingerprint) वा बायोमेट्रिक विकल्प प्रयोग गर्न कडा सिफारिस गर्छौं।"
          ]
        },
        {
          "heading": "1.3. सिंगल खाता र स्थायी लक नीति",
          "paragraphs": [
            "हाम्रो प्लेटफर्ममा एउटै व्यक्तिको विवरणबाट केवल एकै खाता खोल्न सकिन्छ। लगइन प्रोफाइलमा परिचय प्रमाणिकरणका लागि दुई विकल्प हुन्छन् (१८ वर्ष मुनि वा १८ वर्ष माथि):"
          ],
          "items": [
            "१८ वर्ष माथि: NID र जन्म दर्ता (Birth Certificate) दुवैको विवरण र तस्बिर प्रदान अनिवार्य हुनेछ। एक पटक प्रोफाइल प्रमाणिकरणपछि यी दस्तावेजहरू प्रणालीमा स्थायी रूपमा लक हुनेछ।",
            "१८ वर्ष मुनि: केवल जन्म दर्ताका विवरण र तस्बिर प्रदान गरेर खाता प्रमाणिकरण गर्न सकिन्छ। पछि NID अपडेट गर्ने अवसर हुनेछ, तर जन्म दर्ताको विवरण स्थायी रूपमा लक हुनेछ।",
            "चेतावनी: १८ वर्ष माथि भएता पनि NID हटाउनका लागि गलत उमेर छनौट गर्दा खाता प्रमाणित हुने छैन र ब्लक हुन सक्छ। एउटै दस्तावेजले दोस्रो खाता खोल्ने प्रयास अस्वीकृत हुनेछ।"
          ]
        },
        {
          "heading": "1.4. अन्तर्राष्ट्रिय बैंक-स्तरीय सुरक्षा",
          "paragraphs": [
            "हामी ग्राहकहरूको डेटा सुरक्षा मा सम्झौता गर्दैनौं। तपाईंको जानकारी सुरक्षित राख्न MecoPay अन्तर्राष्ट्रिय बैंक-स्तरीय सुरक्षा कायम राख्दछ।"
          ],
          "items": [
            "फ्रन्टएन्ड र एज सुरक्षा (MecoPay Shield): हाम्रो ग्लोबल एज नेटवर्क मार्फत फ्रन्टएन्ड र API ट्राफिक एनक्रिप्टेड र DDoS आक्रमणबाट सुरक्षित राखिन्छ।",
            "ब्याकएन्ड सुरक्षा (Row Level Security - RLS): तपाईंको खाताको डेटा केवल तपाईं मात्र हेर्न पाउनुहुनेछ।",
            "एन्ड-टु-एन्ड इन्क्रिप्शन: एन्ड्रोइड एप र सर्भरको प्रत्येक कनेक्सन HMAC SHA-256 सिग्नेचरले सुरक्षित रहन्छ।"
          ]
        },
        {
          "heading": "1.5. संपर्क",
          "paragraphs": [
            "यो गोपनीयता नीतिबारे प्रश्न भएमा support@mecopay.com मा सम्पर्क गर्नुहोस्।"
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "नियम तथा सर्त",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. सेवा विवरण",
          "paragraphs": [
            "MecoPay एउटा अल-इन-वन (All-in-One) ई-कमर्स SaaS प्लेटफर्म हो, जुन Innovative Education & Technology (IET) को एक विशेष पहल हो। यसले व्यापारीहरू र ग्राहकहरू बीचको लेनदेन स्वचालित बनाउन पेमेन्ट अटोमेसन र समेकित ई-कमर्स इकोसिस्टम प्रदान गर्छ।",
            "MecoPay सिधा ग्राहकबाट व्यापारीको खातामा भुक्तानी प्रक्रिया र प्रमाणिकरण गर्न सहयोग गर्छ र कुनै ग्राहक वा व्यापारीको रकम आफैंमा होल्ड वा जम्मा राख्दैन।"
          ],
          "items": []
        },
        {
          "heading": "2.2. अटो-राउटिङ र लेनदेन सीमा",
          "paragraphs": [],
          "items": [
            "पर्सनल MFS: प्रयोगकर्ताहरू पर्सनल मोबाइल बैंकिङ् खाता प्रयोग गर्न सक्नेछन्। अधिकतम २ वटा व्यक्तिगत नम्बर सेट गर्न सकिन्छ; पहिलो नम्बरको सीमा सकिएपछि प्रणाली दोस्रो नम्बरमा भुक्तानी राउट गर्नेछ।",
            "व्यापारी API: पर्सनल खाताको सीमाभन्दा बढी भोल्युमको लेनदेन आवश्यक परेमा व्यापारी API सेट गर्नु पर्नेछ।"
          ]
        },
        {
          "heading": "2.3. दायित्वको सीमितता (Limitation of Liability)",
          "paragraphs": [
            "पर्सनल MFS खातामा अतिरिक्त लेनदेन वा अटो-राउटिङको प्रयोगका कारण सम्बन्धित मोबाइल बैंकिङ प्राधिकरणले खाता सीमित, ब्लक वा सस्पेन्ड गरेको खण्डमा त्यसको जिम्मेवारी प्रयोगकर्ताको हुनेछ। यस्ता कारणबाट MecoPay कानुनी वा आर्थिक रूपमा दायित्वमा पर्ने छैन।"
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "रिफन्ड नीति (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. सदस्यता रिफन्ड",
          "paragraphs": [
            "MecoPay प्रयोगकर्ताहरूलाई फ्री ट्रायल सुविधा दिन्छ, जसले उनीहरूलाई सेवा परीक्षण गर्न मद्दत गर्छ। त्यसैले Basic वा Pro जस्ता पेड सदस्यता सुरु भएपछि सामान्यतया शुल्क फिर्ता हुँदैन।"
          ],
          "items": []
        },
        {
          "heading": "2. रिफन्डको अवस्थामा क्लाइन्टका लागि जीरो चार्ज",
          "paragraphs": [
            "ग्राहकले कुनै उत्पादन फिर्ता गर्दा वा अग्रिम भुक्तानीको रिफन्ड माग गर्दा क्लाइन्ट/व्यापारीले पूर्ण अग्रिम रकम फिर्ता गर्नुपर्छ।",
            "रिफन्ड प्रमाणित गर्दा MecoPay ले लिएर राखेको जुन ट्रान्जेक्सन वा सेवा शुल्क थियो, त्यो क्लाइन्टबाट पुन: कटिनेछैन वा माफ गरिनेछ।"
          ],
          "items": []
        },
        {
          "heading": "3. अपवादात्मक अवस्था (Exceptional Cases)",
          "paragraphs": [
            "तलका अवस्थामा MecoPay को सदस्यता शुल्क रिफन्ड गर्नेबारे विचार गर्न सकिन्छ:"
          ],
          "items": [
            "प्रणालीगत प्राविधिक त्रुटिका कारण डबल बिलिङ भएमा।",
            "दीर्घकालीन अप्रत्याशित आउटेज वा डाउनटाइम भएमा।",
            "नोट: तेस्रो पक्षको मोबाइल बैंकिङ प्रदायकको आफ्नै सर्भर डाउनका कारण भएको ढिलाइ यस नियमको दायरा भित्र पर्दैन।"
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "धोखाधडी विरोधी र ग्राहक अधिकार नीति",
      "alertTitle": "जीरो-टॉलरन्स एन्टी-फ्रड नीति",
      "alert": "हामी ग्राहकका अधिकार संरक्षणमा जीरो-टॉलरन्स नीति अपनाउँछौं। Checkout पेजमा Report बटन हुन्छ; धोखाधडी भएमा प्रमाणसहित सिधा उजुरी गर्न सकिनेछ।",
      "sections": [
        {
          "heading": "1. डेलिभरी प्रमाणिकरण प्रक्रिया",
          "paragraphs": [],
          "items": [
            "फिजिकल उत्पादन: कस्टम वा नो-कोड वेबसाइट जुनसुकै प्रयोग गरे पनि, delivery API कन्कनेक्ट अनिवार्य छ। ब्याकएन्ड courier API बाट डेटा लिएर रियल-टाइममा प्रमाणिकरण गरिनेछ।",
            "डिजिटल उत्पादन: उजुरी आएमा खरीददार र विक्रेताको स्क्रिनशट, brand data र server log क्रस-चेक गरेर म्यानुअली प्रमाणित गरिनेछ।"
          ]
        },
        {
          "heading": "2. धोखाधडीको सजाय र कानुनी प्रक्रिया",
          "paragraphs": [
            "यदि प्रमाणित भयो भने कुनै पनि merchant वा client ले अग्रिम रकम लिएर उत्पादन प्रदान नगरेमा, तलका कदम चालिनेछ:"
          ],
          "items": [
            "Warning र समाधान: रिपोर्ट पाएपछि प्रमाणसहित सूचित गरिनेछ; समाधान नभए खाता ban गरिनेछ।",
            "Permanent Ban: उजुरी प्रमाणित भएमा खाता स्थायी रूपमा ban गरिनेछ र परिचयपत्र blacklisted गरिनेछ।",
            "Refund जिम्मेवारी: client ले आफ्नै जिम्मेवारीमा पूर्ण रकम फिर्ता गर्नुपर्नेछ।",
            "मुद्दा र कानुनी कदम: रकम फिर्ता नगरे वा समाधान नै नभएमा प्रचलित consumer protection र cyber law अनुसार कारबाही गरिनेछ।"
          ]
        }
      ]
    },
    "docs": {
      "title": "API डकुमेन्टेसन",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "लगइन गरेर profile details save गरेपछि Your MecoPay सेक्सनबाट Documentation Docs मा Laravel, Node.js वा Python बाट बनाइएको वेबसाइटको लागि विस्तृत API Documentation र JSON payload हेर्न सक्नुहुन्छ।",
            "WordPress/WooCommerce integration का लागि Plugin Apps & Plugin सेक्सनमा र Personal MFS automation का लागि Sync App त्यही स्थानबाट download गर्न सकिन्छ।"
          ],
          "items": []
        }
      ]
    }
  },
  "sv": {
    "privacy": {
      "title": "Integritetspolicy",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Vilka uppgifter samlar vi in",
          "paragraphs": [],
          "items": [
            "Identitetshandlingar och bevis: ditt nationella identitetsdokument (NID)-nummer, bild av NID, födelsebevisets (Birth Certificate) nummer, bild av födelsebeviset samt ditt passfoto.",
            "Kontaktuppgifter: telefonnummer, namn och e-postadress.",
            "Transaktionsdata: betalningslänk, faktura och transaktionsstatus."
          ]
        },
        {
          "heading": "1.2. Tvåfaktorsautentisering (2FA) och kontosäkerhet",
          "paragraphs": [
            "Det finns ingen traditionell möjlighet att skapa ett konto direkt med e-post och lösenord i MecoPay. Du måste enbart få åtkomst via en skyddad enhet kopplad till ett Google Account (গুগল সাইন-ইন)."
          ],
          "items": [
            "Åtkomst och 2‑stegsverifieringsskydd: Efter inloggning med Google sign‑in på vår plattform kan du aktivera 2‑Step Verification (TOTP). Om någon på oönskat sätt skulle hacka ditt Gmail‑konto eller få reda på ditt Gmail‑lösenord kan de ändå inte komma åt ditt MecoPay‑konto utan den sexsiffriga verifieringskoden från Google Authenticator.",
            "Biometrisk rekommendation: För att hålla ditt konto fullt skyddat rekommenderar vi starkt att använda fingeravtryck (Fingerprint) eller biometriska alternativ för 2‑Step Verification."
          ]
        },
        {
          "heading": "1.3. Enkelkonto och permanent låsningspolicy",
          "paragraphs": [
            "På vår plattform kan endast ett konto öppnas per person med en individs uppgifter. För identitetsverifiering på inloggningsprofilen finns två alternativ (under 18 år eller 18 år och äldre):"
          ],
          "items": [
            "Över 18 år: Uppgifter och bilder av både NID och födelsebeviset (Birth Certificate) är obligatoriska. När profilen har verifierats kommer dessa dokument att låsas permanent i systemet.",
            "Under 18 år: Konto kan verifieras enbart genom att lämna uppgifter och bild av födelsebeviset. Det kommer senare att finnas möjlighet att uppdatera NID, men födelsebevisuppgifterna kommer att förbli permanent låsta.",
            "Varning: Om du är över 18 år men väljer fel ålder för att undvika NID kommer kontot inte att verifieras och kan bli blockerat. Försök att öppna ett andra konto med samma dokument kommer att avvisas."
          ]
        },
        {
          "heading": "1.4. Internationell banknivåsäkerhet",
          "paragraphs": [
            "Vi gör inga eftergifter när det gäller kunders datasäkerhet. För att skydda din information upprätthåller MecoPay internationell banknivåsäkerhet."
          ],
          "items": [
            "Frontend‑ och edge‑säkerhet (MecoPay Shield): Genom vårt globala edge‑nätverk är frontend‑ och API‑trafik krypterad och skyddad mot DDoS‑attacker.",
            "Backend‑säkerhet (Row Level Security - RLS): Endast du kan se dina kontodata.",
            "End-to-end‑kryptering: Varje anslutning mellan Android‑appen och servern skyddas med HMAC SHA-256‑signatur."
          ]
        },
        {
          "heading": "1.5. Kontakt",
          "paragraphs": [
            "Om du har frågor om denna integritetspolicy, kontakta support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Villkor och bestämmelser",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Beskrivning av tjänsten",
          "paragraphs": [
            "MecoPay är en allt‑i‑ett (All-in-One) e‑handels‑SaaS‑plattform, ett särskilt initiativ från Innovative Education & Technology (IET). Det är ett betalningsautomations‑ och integrerat e‑handelsekosystem som automatiserar transaktioner mellan handlare och kunder.",
            "MecoPay hjälper till att bearbeta och verifiera betalningar direkt från kund till handlarens konto och håller eller innehar inte kunders eller handlares pengar."
          ],
          "items": []
        },
        {
          "heading": "2.2. Automatisk routning och transaktionsgräns",
          "paragraphs": [],
          "items": [
            "Personlig MFS: Användare kan använda personliga mobilbankkonton. Upp till 2 personliga nummer kan ställas in; när den första numrets gräns är nådd kommer systemet att routa betalningar till det andra numret.",
            "Merchant API: Om transaktionsvolymen överstiger gränserna för personliga konton måste Merchant API konfigureras."
          ]
        },
        {
          "heading": "2.3. Ansvarsbegränsning (Limitation of Liability)",
          "paragraphs": [
            "Om den behöriga mobilbankmyndigheten begränsar, blockerar eller suspenderar ett konto på grund av extra transaktioner eller användning av automatisk routning på personliga MFS‑konton, är användaren ansvarig. I sådana fall kommer MecoPay inte att hållas rättsligt eller ekonomiskt ansvarigt."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Återbetalningspolicy (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Prenumerationsåterbetalning",
          "paragraphs": [
            "MecoPay erbjuder gratis provperioder så att användare kan utvärdera tjänsten. Därför är avgifter för betalda prenumerationer såsom Basic eller Pro normalt inte återbetalningsbara efter att prenumerationen påbörjats."
          ],
          "items": []
        },
        {
          "heading": "2. Återbetalning utan avgift för klienten",
          "paragraphs": [
            "Om en kund returnerar en produkt eller begär återbetalning av en förskottsbetalning måste klienten/handlaren återbetala hela förskottsbeloppet.",
            "När återbetalningen verifieras kommer de transaktions‑ eller serviceavgifter som MecoPay debiterat inte att dras från klienten eller kommer att efterges."
          ],
          "items": []
        },
        {
          "heading": "3. Undantagsfall (Exceptional Cases)",
          "paragraphs": [
            "I följande fall kan återbetalning av MecoPay‑prenumerationsavgiften beaktas:"
          ],
          "items": [
            "Vid dubbeldebitering till följd av tekniskt fel i systemet.",
            "Vid långvariga oförutsedda avbrott eller driftstopp.",
            "Observera: Förseningar på grund av en tredjeparts mobilbankleverantörs egna servernedgång omfattas inte av detta villkor."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Policy för bedrägeribekämpning och kundrättigheter",
      "alertTitle": "Nolltoleranspolicy för bedrägerier",
      "alert": "Vi följer en nolltoleransprincip för att skydda kunders rättigheter. På Checkout‑sidan finns en Report‑knapp; vid bedrägeri kan du anmäla direkt med bevis.",
      "sections": [
        {
          "heading": "1. Leveransverifieringsprocess",
          "paragraphs": [],
          "items": [
            "Fysiska produkter: Oavsett om det är en custom eller no‑code webbplats är anslutning till delivery API obligatorisk. Backend kommer att verifiera i realtid genom att hämta data från kurirens courier API.",
            "Digitala produkter: Vid anmälan kommer köparens och säljarens skärmdumpar, brand data och serverloggar att korsgranskas manuellt."
          ]
        },
        {
          "heading": "2. Påföljder vid bedrägeri och rättsliga åtgärder",
          "paragraphs": [
            "Om det bevisas att en merchant eller klient har tagit emot förskottsbetalning utan att leverera produkten kommer följande åtgärder att vidtas:"
          ],
          "items": [
            "Varning och åtgärd: Efter att rapport mottagits med bevis kommer ärendet att meddelas; om ingen lösning uppnås kommer kontot att spärras.",
            "Permanent bannlysning: Om anmälan styrks kommer kontot att permanent bannlysas och identitetshandlingarna att svartlistas.",
            "Återbetalningsskyldighet: Klienten är skyldig att på egen bekostnad återbetala hela beloppet.",
            "Rättsliga åtgärder: Om pengar inte återbetalas eller ingen lösning nås kommer åtgärder att vidtas i enlighet med gällande konsumentskyddslagar och cybersäkerhetslagstiftning."
          ]
        }
      ]
    },
    "docs": {
      "title": "API‑dokumentation",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Efter inloggning och sparande av profildetaljer kan du i avsnittet Your MecoPay under Documentation Docs se detaljerad API‑dokumentation och JSON‑payload för webbplatser byggda med Laravel, Node.js eller Python.",
            "För WordPress/WooCommerce‑integration finns Plugin Apps & Plugin‑avsnittet, och för Personal MFS‑automatisering kan du ladda ner Sync App från samma ställe."
          ],
          "items": []
        }
      ]
    }
  },
  "da": {
    "privacy": {
      "title": "Privatlivspolitik",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1.1. Hvilke oplysninger indsamler vi",
          "paragraphs": [],
          "items": [
            "Identifikation og dokumentation: dit nationale identitetskort (NID)-nummer, billede af NID, fødselsregistrering (Birth Certificate)-nummer, billede af fødselsregistreringen og dit pasfoto (passport size).",
            "Kontaktoplysninger: telefonnummer, navn og e-mailadresse.",
            "Transaktionsdata: betalingslink, faktura og transaktionsstatus."
          ]
        },
        {
          "heading": "1.2. Two-faktor-autentifikation (2FA) og kontosikkerhed",
          "paragraphs": [
            "Der er ingen mulighed for at oprette en konto i MecoPay direkte med en traditionel e-mail og adgangskode. Du skal få adgang via en sikret enhed tilknyttet en Google Account (Google Sign-in)."
          ],
          "items": [
            "Adgangs- og 2-trins-verifikationssikkerhed: Efter at have logget ind med Google Sign-in på vores platform kan du aktivere 2-Step Verification (TOTP). Selv i tilfælde af at nogen får adgang til din Gmail-konto eller kender din Gmail-adgangskode, kan de ikke få adgang til din MecoPay-konto uden den 6-cifrede verifikationskode fra Google Authenticator.",
            "Biometrisk anbefaling: For fuld sikkerhed af din konto anbefaler vi stærkt at bruge fingeraftryk (Fingerprint) eller andre biometriske muligheder til 2-Step Verification."
          ]
        },
        {
          "heading": "1.3. Enkeltkonto og permanent låsepolitik",
          "paragraphs": [
            "På vores platform kan der oprettes kun én konto pr. person. Til identitetsverifikation i loginprofilen er der to muligheder (under 18 år eller 18 år og derover):"
          ],
          "items": [
            "18 år og derover: Oplysninger og billeder af både NID og fødselsregistrering (Birth Certificate) er obligatoriske. Når profilen er verificeret, vil disse dokumenter blive permanent låst i systemet.",
            "Under 18 år: Kontoen kan verificeres ved kun at levere oplysninger og billede af fødselsregistreringen. Der vil være mulighed for senere at opdatere NID, men fødselsregistreringsoplysningerne vil blive permanent låst.",
            "Advarsel: Hvis man vælger forkert alder for at undgå NID, selvom man er over 18, vil kontoen ikke blive verificeret og kan blive blokeret. Forsøg på at oprette en anden konto med samme dokument vil blive afvist."
          ]
        },
        {
          "heading": "1.4. International bank-niveau sikkerhed",
          "paragraphs": [
            "Vi går ikke på kompromis med kunders datasikkerhed. For at beskytte dine oplysninger opretholder MecoPay international bank-niveau sikkerhed."
          ],
          "items": [
            "Frontend- og edge-sikkerhed (MecoPay Shield): Gennem vores globale edge-netværk er frontend og API-trafik krypteret og beskyttet mod DDoS-angreb.",
            "Backend-sikkerhed (Row Level Security - RLS): Kun du vil kunne se dine konto-data.",
            "End-to-end-kryptering: Hver forbindelse mellem Android-appen og serveren er beskyttet med HMAC SHA-256-signatur."
          ]
        },
        {
          "heading": "1.5. Kontakt",
          "paragraphs": [
            "Hvis du har spørgsmål om denne privatlivspolitik, kontakt venligst support@mecopay.com."
          ],
          "items": []
        }
      ]
    },
    "terms": {
      "title": "Vilkår og betingelser",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "2.1. Beskrivelse af tjenesten",
          "paragraphs": [
            "MecoPay er en alt-i-en (All-in-One) e-handels SaaS-platform, som er et særligt initiativ fra Innovative Education & Technology (IET). Det er et betalingsautomations- og integreret e-handelsøkosystem, der automatiserer transaktioner mellem handlere og kunder.",
            "MecoPay hjælper med at behandle og verificere betalinger direkte fra kunder til handleres konti og holder eller opbevarer ikke penge fra kunder eller handlere."
          ],
          "items": []
        },
        {
          "heading": "2.2. Auto-routing og transaktionsgrænser",
          "paragraphs": [],
          "items": [
            "Personlig MFS: Brugere kan bruge personlige mobile banking-konti. Op til 2 personlige numre kan indstilles; når grænsen for det første nummer er nået, vil systemet rute betalinger til det andet nummer.",
            "Merchant API: Hvis der er behov for transaktioner med volumen over grænsen for personlige konti, skal merchant API implementeres."
          ]
        },
        {
          "heading": "2.3. Ansvarsbegrænsning (Limitation of Liability)",
          "paragraphs": [
            "Hvis den relevante mobile banking-udbyder begrænser, blokerer eller suspenderer en konto som følge af ekstraordinære transaktioner eller brug af auto-routing på en personlig MFS-konto, er ansvaret brugerens. MecoPay er ikke juridisk eller økonomisk ansvarlig for sådanne tilfælde."
          ],
          "items": []
        }
      ]
    },
    "refund": {
      "title": "Refusionspolitik (Refund Policy)",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "1. Abonnementsrefusion",
          "paragraphs": [
            "MecoPay tilbyder brugerne en gratis prøveperiode, så de kan teste tjenesten. Derfor er gebyrer for betalte abonnementer som Basic eller Pro som udgangspunkt ikke refunderbare efter påbegyndelse."
          ],
          "items": []
        },
        {
          "heading": "2. Ved refusion: nul gebyr for klienten",
          "paragraphs": [
            "Hvis en kunde returnerer et produkt eller kræver refusion af en forudbetaling, skal klienten/handleren tilbagebetale hele det forudbetalte beløb.",
            "Når refusion verificeres, vil de transaktions- eller servicegebyrer, som MecoPay har opkrævet, ikke blive trukket fra klientens refundering eller vil blive eftergivet."
          ],
          "items": []
        },
        {
          "heading": "3. Ekseptionelle tilfælde (Exceptional Cases)",
          "paragraphs": [
            "I følgende tilfælde kan MecoPay overveje refusion af abonnementsgebyrer:"
          ],
          "items": [
            "Ved dobbelt fakturering som følge af tekniske fejl i systemet.",
            "Ved langvarige uventede udbrud eller nedetid.",
            "Bemærk: Forsinkelser som følge af nedetid på tredjeparts mobile banking-udbyderes egne servere er ikke omfattet af denne betingelse."
          ]
        }
      ]
    },
    "antiFraud": {
      "title": "Anti-fraud og kunders rettighederspolitik",
      "alertTitle": "Nul-tolerance anti-fraud-politik",
      "alert": "Vi fører en nul-tolerancepolitik for at beskytte kunders rettigheder. På checkout-siden er der en 'Report'-knap; i tilfælde af bedrageri kan der indsendes en klage med beviser direkte.",
      "sections": [
        {
          "heading": "1. Leveringsverifikationsproces",
          "paragraphs": [],
          "items": [
            "Fysiske produkter: Uanset om der bruges custom eller no-code hjemmesider, er forbindelse til delivery API påkrævet. Backend vil hente data fra courier API og verificere i realtid.",
            "Digitale produkter: Ved klager vil købers og sælgers skærmbilleder, branddata og serverlogs blive krydstjekket manuelt."
          ]
        },
        {
          "heading": "2. Straffe for bedrageri og juridiske skridt",
          "paragraphs": [
            "Hvis det bevises, at en merchant eller klient har modtaget forudbetaling uden at levere produktet, vil følgende skridt blive taget:"
          ],
          "items": [
            "Advarsel og løsning: Efter modtagelse af rapport vil sagen blive kommunikeret med beviser; hvis der ikke opnås løsning, vil kontoen blive blokeret.",
            "Permanent udelukkelse: Hvis anklagen er bevist, vil kontoen blive permanent udelukket, og identitetsdokumenterne vil blive blacklistede.",
            "Refusionspligt: Klienten er forpligtet til selv at tilbagebetale det fulde beløb på eget ansvar.",
            "Retssag og juridiske tiltag: Hvis beløbet ikke tilbagebetales eller der ikke opnås løsning, vil der blive taget skridt i henhold til gældende forbrugerbeskyttelse og cyberlovgivning."
          ]
        }
      ]
    },
    "docs": {
      "title": "API-dokumentation",
      "alertTitle": "",
      "alert": "",
      "sections": [
        {
          "heading": "",
          "paragraphs": [
            "Efter login og gemning af profildetaljer kan du i sektionen 'Your MecoPay' under Documentation Docs se detaljeret API-dokumentation og JSON-payload til websteder bygget med Laravel, Node.js eller Python.",
            "Til WordPress/WooCommerce-integration findes Plugin Apps & Plugin-sektionen, og til Personal MFS-automatisering kan Sync App downloades fra samme sted."
          ],
          "items": []
        }
      ]
    }
  }
} as const;

export type LegalPageKey = 'privacy' | 'terms' | 'refund' | 'antiFraud' | 'docs';
export const getLegalCopy = (page: LegalPageKey, language: string) => (legalCopy as Record<string, any>)[language]?.[page] || legalCopy.en[page];
